import {
  CaretDownOutlined,
  CaretUpOutlined,
  CloseOutlined,
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  MedicineBoxOutlined,
  MinusOutlined,
  PlusOutlined,
  SearchOutlined,
  ArrowRightOutlined,
  SettingOutlined,
  SettingFilled,
  MinusCircleOutlined,
} from '@ant-design/icons'
import {selectAcupdataList, selectTwoMenus} from '../../../layouts/layoutSlice'
import { createAsyncThunk, current, unwrapResult } from '@reduxjs/toolkit'
import {
  Badge,
  Button,
  Checkbox,
  Col,
  Dropdown,
  InputNumber,
  Modal,
  notification,
  Row,
  Space,
  Table,
  TableColumnType,
  Popover,
  Switch,
  Form,
  message,
  Menu,
  Select,
  Input,
  Card,
  Spin,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import Draggable from 'react-draggable'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import {
  RootDispatch,
  RootState,
  RootThunk,
  RootThunkApi,
} from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { Material } from '../../../models/material'
import {
  getTemplateCategoryName,
  PrintTemplateCategory,
} from '../../../models/print'
import {
  isTcmRecipeCategory,
  Recipe,
  RecipeStatus,
  RecipeCategory,
  getRecipeCategoryName,
  getNewNormalFrequencyCodeCalc,
} from '../../../models/recipe'
import { DefaultUseMethod } from '../../../models/recipeusemethod'
import { Checks, Settings } from '../../../models/setting'

import {
  CopyRecipeParams,
  PayTypeBodyBatch,
  replaceMakeInfoParams,
} from '../../../services/recipe'
import { ThemeContext } from '../../../theme/ThemeContext'
import { useQuery } from '../../../utils/HttpUtils'
import { mergeGroup, splitGroup } from '../../../utils/MaterialUtils'
import { setUpdateFlagsAsync } from '../../payment/confirm/paymentConfirmSlice'
import { PrintTemplateModal } from '../../print/PrintTemplateModal'
import {selectBooleanSetting, selectStringSetting, setSettings} from '../../settings/settingsSlice'
import { getTreatments, selectRegistration } from '../diagnosis/diagnosisSlice'
import { Treatments, TreatmentsRef } from '../list/Treatments'
import {
  DisposeColumns,
  MedicineMaterialColumns,
  MedicineMaterialDiscountColumns,
  TcmTreatColumn,
  TcmColumns,
  TcmDiscountColumns,
} from './columns'
import { RecipeItemEditor } from './components/RecipeItemSelect'
import AddCurePlanModal from './modals/AddCurePlanModal'
import { BatchAddModal } from './modals/BatchAddModal'
import { CurePlanListModal } from './modals/curePlanListModal'
import { RecipeItemModal } from './modals/RecipeItemModal'
import { ReplaceMakeSettingModal } from './modals/ReplaceMakeSettingModal'
import { SetMealModal } from './modals/SetMealModal'
import styles from './RecipeEditor.module.css'
import {
  copyRecipe,
  createOrUpdateRecipe,
  createRetailRecipe,
  createRetailRecipePatient,
  exchangeList,
  getInsuranceToSelfpay,
  getPrintZXDData,
  getRecipeDetail,
  getReplaceMakeInfo,
  isdeleteReplaceMakeSetting,
  removeMaterials,
  resetRecipeEditor,
  saveRecipeMaterials,
  selectAddCurePlanModalVisible,
  selectCurePlanListVisible,
  selectPageLoading,
  selectPlanCount,
  selectRecipe,
  selectRecipeMaterials,
  setCurePlanListVisible,
  setMaterials,
  setPageLoading,
  updateItemPayTypeBatchAsync,
  updateSortAndGroupNumber,
  getPatientCouponsList,
  getCouponsUse,
  getBatchSynchronizationRecipeItem,
  saveRecipeComboMaterials,
  setBatchAddVisibel,
  createOrUpdateGroupRecipe,
  deleteGroupRecipe,
  PRESCRIPTION_DRUG_LIMIT_CREATE_RECIPE,
  PRESCRIPTION_DRUG_LIMIT_RECIPE_FULL,
} from './recipeEditorSlice'
import {
  curePlanListAsync,
  editST,
  getRecipeList,
  removeRecipe, saveAcupointAsync,
  saveToothAsync,
  selectPatientInfo,
  selectTreatment,
  setPatientInfo,
  setRecipeEditorTreatment,
  syncToothAsync,
  updateItemPayTypeAsync,
} from './recipeListEditorSlice'
import { UseMethodModal } from './UseMethodModal'
import { GlobalKeyboardAction } from '../../../compnents/actions/GlobalKeyboardAction'
import * as service from '../../../services/setting'
import {
  api,
  selectCurrentDoctorLimit,
  selectEdition,
  selectInsuranceArray,
  selectTenantFunction,
  selectTenantName,
  selectUserId,
  selectUserName,
  sendAsync,
} from '../../../app/applicationSlice'
import {
  getSettingDetail,
  selectSettings,
} from '../../user/setting/settingSlice'
import { size, sum } from 'lodash'
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import {
  DndContext,
  DragEndEvent,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'
import {
  getSignatureAsync,
   selectTenantPrintTemplateWithTemplateCode,
} from '../../personalManagement/personalDetail/personalDetailSlice'
import list from 'antd/lib/list'
import { PrintSettingModal } from '../../print/printSettingModal'
import { queries } from '@testing-library/react'
import { SetmealModal } from '../../setmeal/setmealmodal'
import {
  setSetmealSelectId,
  setSetmealDetail,
  getSetmeal,
} from '../../setmeal/setmealSlice'
import { CouponsItems } from '../../coupons/couponsItems'
import { getTips } from '../../../models/echart'
import { getPrintTemplateSettingDetail } from '../../print/printSlice'
import { DecoctingSettingModal } from './modals/DecoctingSettingModal'
import { RecipeComparisonModal } from './modals/RecipeComparisonModal'
import { getMaterialList } from '../list/treatmentSlice'
import { defaultXianBingListAsync } from '../tcmCases/tcmCasesSlice'
import { SettingTreatmentParts } from '../../examinetreat/settingTreatmentParts'
import { getTreatmentPartsName, TreatmentPartsCategoris } from '../../../models/setmeal'
import { ChangeElseFactorModal } from './modals/changeElseFactorModal'
import { TFMethodModal } from './TFMethodModal'
import { ItemCompletionType } from '../../completion/completionSlice'
import { RecipeItemInput, RecipeItemInputRef } from './components/RecipeItemInput'
import moment from 'moment'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { ChooseBWXWModal } from './modals/ChooseBWXWModal'
import { RegisterModal } from '../../nurse/pitest/nopitest/registerModal'
import { getNewAutoChangePriceDrugCount, getNewAutoChangePriceSplitDrugCount, getNewAutoChangePriceSplitUseDays, getNewAutoChangePriceUseDays, getOldAutoChangePriceDrugCount, getOldAutoChangePriceSplitDrugCount, getOldAutoChangePriceSplitUseDays, getOldAutoChangePriceUseDays } from '../../../models/RecipeItemAutoChangePrice'
import { CopyModal } from '../CopyModal'
import { CopyTCModal } from '../CopyTCModal'
const { Option } = Select

export enum RecipeEditorMode {
  Normal = 0,
  Retail = 2,
  Extra = 3,
}

interface RecipeEditorProps {
  ZYHGcategory?: number
  isMember?: boolean
  patientPhone?: any
  patientName?: any
  name?: any
  kskdTag?: any //快速开单
  ydkdFlag?: any //药店开单
  yzcfTag?: any //医嘱处方标志
  kqMoveTag?: any
  isSettledFlag?: any
  onRefreshRecipe?: (mats: Material[]) => void
  isInsurance?: boolean
  patientObj?: any //完善病历信息
  insuranceCode?: string
  mode?: RecipeEditorMode
  treatmentId?: string
  recipeId?: string
  recipeCategory?: RecipeCategory
  data?: any
  RecipeStatus?: RecipeStatus
  RecipeDate?: string
  patientId?: string
  style?: React.CSSProperties
  onChange?: (recipe: Recipe) => void
  onNewRecipe?: (recipe: Recipe, copyDiease?: any) => void
  getPatientData?: (v: any) => void
  tipCountNum?: (v?: any) => void
  disabled?: boolean //处方外配标志
  toothRegistrationId?: string
  state?: any
  discountFlag?: any
  refresh?: (v?: any) => void
  isCoupons?: boolean
  onBeforePrintRecipe?: () => Promise<boolean>
}

const RecipeEditorRef = ({
  ZYHGcategory,
  isMember = false,
  patientPhone,
  patientName,
  name,
  kskdTag = false,
  ydkdFlag = false,
  yzcfTag,
  kqMoveTag,
  isSettledFlag,
  onRefreshRecipe,
  isInsurance,
  patientObj, //完善病历信息
  insuranceCode,
  mode = RecipeEditorMode.Normal,
  treatmentId,
  recipeId, //当前点击的处方id
  recipeCategory, // 处方类型 中药3、颗粒剂12
  patientId,
  RecipeStatus, //支付状态
  RecipeDate, //支付时间
  style,
  data,
  onChange,
  onNewRecipe,
  getPatientData,
  tipCountNum,
  refresh,
  disabled, //处方外配标志
  toothRegistrationId,
  state, //快速开单
  discountFlag,
  isCoupons,
  onBeforePrintRecipe,
}: RecipeEditorProps): ReactElement => {

   // 用于保存每个药品输入框的ref
  const refMedical = useRef<Record<string, any>>({});
  // 用于保存每个克数输入框的ref
  const refNumber = useRef<Record<string, any>>({});
  // 用于保存新增框的ref
  const refMedicalAdd = useRef<any>(null);

  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const query = useQuery()

  const userId = useSelector(selectUserId)

  const location = useLocation()

  const recipe = useSelector(selectRecipe)

  const tenantName = useSelector(selectTenantName)

  const userName = useSelector(selectUserName)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const materials = useSelector(selectRecipeMaterials)

  const insuranceArray = useSelector(selectInsuranceArray)

  const createAutoFeeSwitch: any = useSelector(selectTenantFunction)

  const treatment = useSelector(selectTreatment)

  const patientInfo = useSelector(selectPatientInfo)

  const planCount = useSelector(selectPlanCount)

  const [
    updateItemTypeBatchReadLoading,
    setUpdateItemTypeBatchReadLoading,
  ] = useState(false)

  const registration = useSelector(selectRegistration)

  const pageLoading = useSelector(selectPageLoading)

  const allPersonalPreferences = JSON.parse(localStorage?.getItem('allPersonalPreferences') || '{}')

  const checkData = allPersonalPreferences?.records || []

  const KSKDMRTS = checkData?.find((item: any) => item?.code == '2004')?.codeName //中药方默认帖数

  const syncFirstItemFUD = checkData?.find((v: any) => v.code == '11')?.codeName == 'true' ? true : false

  const wbTag = checkData?.filter((v: any) => v?.code == '5')?.[0]

  const allowedToChangePrice = useSelector(
    selectBooleanSetting(Settings.Recipe.ChangePrice)
  )

    const useSpecifiedBatch = useSelector(
    selectBooleanSetting(Settings.Recipe.UseSpecifiedBatch)
  )

  const ignoreStorage = useSelector(
    selectBooleanSetting(Settings.Recipe.IgnoreStorage)
  )

  const tcmUseSpecifiedBatch = useSelector(
    selectBooleanSetting(Settings.Recipe.TcmUseSpecifiedBatch)
  )

  const tcmIgnoreStorage = useSelector(
    selectBooleanSetting(Settings.Recipe.TcmIgnoreStorage)
  )
  
  const autoChangePrice = useSelector(
    selectBooleanSetting(Settings.Recipe.AutoChangePriceAfter)
  )

  const [isModalRegisterVisible, setIsModalRegisterVisible] = useState(false)

  const [hoverItemKey, setHoverItemKey] = useState<string | null>(null);

  const [isPrintSettingModalVisible, setIsPrintSettingModalVisible] = useState(
    false
  )

  const [form] = Form.useForm()

  const [ZYFTFform]:any = Form.useForm()

  const [dataList, setDataList] = useState<any>()

  const [showFlag, setShowFlag] = useState(false)

  const [couldReplaceStockListModalVisible, setCouldReplaceStockListModalVisible] = useState<any>()

  const [editTreatmentParts, setEditTreatmentParts] = useState(false)

  const [treatmentParts, setTreatmentParts] = useState<string>('')

  const [treatmentPartsList, setTreatmentPartsList] = useState<any>([])

  const [
    isTreatmentPartsModalVisible,
    setIsTreatmentPartsModalVisible,
  ] = useState<any>(false)

  const [buttonFlag, setButtonFlag] = useState<any>('')

  const curePlanListVisible = useSelector(selectCurePlanListVisible)
  const acupointList = useSelector(selectAcupdataList)


  const [showAmount, setShowAmount] = useState(false)
  const [showProducer, setShowProducer] = useState(false)
  const [showRemark, setShowRemark] = useState(false)
  const [showZs, setShowZs] = useState(false)
  const [showBarCode, setShowBarCode] = useState(false)
  const settings = useSelector(selectSettings)

  const tipsCount = localStorage.getItem('tipsCount')

  const ref = useRef<TreatmentsRef>(null)

  const [loading, setLoading] = useState(false)

  const [tipCount, setTipCount] = useState<any>(Number(tipsCount) || 7)

  const [openYl, setOpenYl] = useState<any>(false)

  const [YSCKLSBLData, setYSCKLSBLData] = useState<any>()

  const [recipeUseMethod, setRecipeUseMethod] = useState<string[]>(
    DefaultUseMethod
  )

  const [elseRecipeUseMethod, setElseRecipeUseMethod] = useState<any>({})
  const [elseMethod, setElseMethod] = useState<any>()
  const [elseRemark, setElseRemark] = useState<any>()

  const [isDispose, setIsDispose] = useState(false) // 是否为处置项目

  const [targetMaterial, setTargetMaterial] = useState<Material | undefined>()

  const [selectedKeys, setSelectedKeys] = useState<string[]>([])

  const [isSetMealModalVisible, setIsSetMealModalVisible] = useState(false)

  //代煎设置弹窗
  const [
    isDecoctingSettingModalVisible,
    setIsDecoctingSettingModalVisible,
  ] = useState(false)

  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false)

  const [isCopyReciptModalVisible, setIsCopyReciptModalVisible] = useState(
    false
  )

  const [isCopyReciptParam, setIsCopyReciptParam] = useState<any>()

  const [copyDiease, setCopyDiease] = useState<any>()

  const [isCopyReciptTip, setIsCopyReciptTip] = useState<any>()

  const [isCopyMealModalVisible, setIsMealModalVisible] = useState(false)

  const [category, setCategory] = useState<any>()

  const [comboId, setComboId] = useState<any>()

  const [copyMealParams, setCopyMealParams] = useState<any>()

  const [selectData, setSelectData] = useState<any>()

  const [selectMessage, setSelectMessage] = useState<any>()

  const [noBodyFlag, setNoBodyFlag] = useState(false)

  const [isUseMethodModalVisible, setIsUseMethodModalVisible] = useState(false)

  const [isTFMethodVisible, setIsTFMethodVisible] = useState(false)

   const [useMethodSubmitData, setUseMethodSubmitData] = useState<any>()

  const [currentGroupIndex, setCurrentGroupIndex] = useState(0)

  const [actionFlag, setActionFlag] = useState<any>()

  const [printTemplateCategory, setPrintTemplateCategory] = useState<
    PrintTemplateCategory | undefined
  >()

  const [machiningTypeMsg, setMachiningTypeMsg] = useState('') //加工类别信息

  const [replaceMakeDisable, setReplaceMakeDisable] = useState(true) // 代煎按钮是否禁用

  // const [isShowReplaceMakeTable, setIsShowReplaceMakeTable] = useState(true) // 是否显示代煎行

  const [isSetting, setIsSetting] = useState(false) // 是否设置过代煎

  const [setID, setSetId] = useState(0)

  const [replaceMakeId, setreplaceMakeId] = useState<any>('')

  const [drugAmount, setDrugAmount] = useState<any>()

  const [totalRetailPriceAmount, setTotalRetailPriceAmount] = useState<any>()

  const [messageApi, contextHolder] = message.useMessage()

  const [isFilterVisible, setIsFilterVisible] = useState(false)
  
  const actionRef = useRef<GlobalKeyboardAction>(null)

  const [isOpenReplaceMake, setIsOpenReplaceMake] = useState(false) //是否开通代煎

  const [potionType, setpotionType] = useState(0) //上次的代煎方式

  const [quickAddProjectLoading, setQuickAddProjectLoading] = useState(false)

  const nurseStationWay = useSelector(
    selectStringSetting(Settings.Treatment.nurseStationWay)
  )
  const [curePlanLoading, setCurePlanLoading] = useState(false)

  const [isShowVisibale, setIsShowVisibale] = useState(false)

  const registrationId =
    (query.get('registrationId') as string) || toothRegistrationId

  const [categoryVisible, setCategoryVisible] = useState(false)

  const [materialsExists, setmaterialsExists] = useState(0)

  const [treatmentExists, settreatmentExists] = useState(0)

  const [isOpenPriceRatio, setIsOpenPriceRatio] = useState(false)

  const [printZXDData, setPrintZXDData] = useState<any>()

  const [printFlagDetail, setPrintFlagDetail] = useState<any>()

  const [completionType, setCompletionType] = useState<any>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [couponsVisable, setCouponsVisable] = useState(false)

  const [couponsList, setCouponsList] = useState<any>([])

  const [couponsIds, setCouponsIds] = useState<any>([])

  const twoMenus = useSelector(selectTwoMenus)

  const [selectTag, setSelectTag] = useState(false)

  const [TFRecipeList, setTFRecipeList] = useState<any>([])

  const [btnLoading, setBtnLoading] = useState(false)
  const [mlBtnLoading, setmlBtnLoading] = useState(false)
  const [cfBtnLoading, setcfBtnLoading] = useState(false)
  const [kcBtnLoading, setkcBtnLoading] = useState(false)
  const [pendingSetMealPriceType, setPendingSetMealPriceType] = useState<number>()

  const resetSetMealLoading = () => {
    setBtnLoading(false)
    setmlBtnLoading(false)
    setkcBtnLoading(false)
  }

  const localData: any = JSON.parse(
    localStorage.getItem('retailPreferencesSettingData') || '{}'
  )

  const menu = twoMenus.filter((v: any) => {
    if (v.name === '优惠券管理') {
      return v
    }
  })

  const [comparisonModalVisible, setComparisonModalVisible] = useState(false)

  const [comparisonModalData, setComparisonModalData] = useState<any>([])

  const [saveSkip, setSaveSkip] = useState<any>(false)

  const [comparisonType, SetComparisonType] = useState(0)

  const [settingData, setSettingData] = useState<any>()

  const [expiredInDaysEyeFlag, setExpiredInDaysEyeFlag] = useState<any>('1')
  const [xWTreatmentPartsItem, setXWTreatmentPartsItem] = useState<any>(null)


  const isOpenYBTJ = settings[Checks.YBTJ]

  const currentDoctorLimit: any = useSelector(selectCurrentDoctorLimit)

  const [xyCustomTemplateFlag, setXyCustomTemplateFlag] = useState(false)
  let saveRecipeMaterialsData: any = []

  const expiredInDaysEyeFlags: any = localStorage.getItem('expiredInDaysEyeFlag')

  //皮试参数
  const [pitestParams, setPitestParms] = useState<any>()

  useEffect(() => {
    localStorage.setItem('expiredInDaysEyeFlag', expiredInDaysEyeFlags ? expiredInDaysEyeFlags : '1')
  }, [])

  useEffect(() => {
    setExpiredInDaysEyeFlag(expiredInDaysEyeFlags ? expiredInDaysEyeFlags : expiredInDaysEyeFlag || 1)
  }, [])

  useEffect(() => {
    if (isCopyModalVisible) {
      dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.YSCKLSBL }))
        .then(unwrapResult)
        .then((res: any) => {
          setYSCKLSBLData(res)
        })
    }
  }, [isCopyModalVisible])

  useEffect(() => {
    setSelectTag(false)
    //查询机构是否配置了西药定制模板（如果配置了定制模板，则打印西药处方单的时候不展示其他类型的处方单，直接跳打印页面）
    dispatch(selectTenantPrintTemplateWithTemplateCode({ templateCode: 'WesternMedicine' }))
      .then(unwrapResult)
      .then((c: any) => {
        if (c != null && parseFloat(c) > 0) {
          setXyCustomTemplateFlag(true);
        } else {
          setXyCustomTemplateFlag(false);
        }
      })
  }, [])

  const getTipsMessage = (
    materialsExists = 0,
    treatmentExists = 0,
    type = 0
  ) => {
    let str = ''
    let tab = ''
    if (materialsExists == 0 && treatmentExists == 0) {
      str = '药品目录和诊疗目录'
      tab = '【商品管理】和【诊疗管理】'
    } else if (materialsExists == 0 && treatmentExists == 1) {
      str = '药品目录'
      tab = '【商品管理】'
    } else if (materialsExists == 1 && treatmentExists == 0) {
      str = '诊疗目录'
      tab = '【诊疗管理】'
    }
    return type == 0 ? str : tab
  }

  useEffect(() => {
    if (
      recipeUseMethod &&
      recipeUseMethod[1] === '外用' &&
      recipeUseMethod[2]?.length > 0 &&
      recipeUseMethod[3]?.length > 0
    ) {
      setRecipeUseMethod([recipeUseMethod[0], recipeUseMethod[1], '', ''])
    }
  }, [recipeUseMethod])

  useEffect(() => {
    tipCountNum && tipCountNum(tipCount)
  }, [tipCount])

  const flag = localStorage.getItem('openYL')

  useEffect(() => {
    if (flag == 'true') {
      setOpenYl(true)
    } else {
      setOpenYl(false)
    }
  }, [])

  const printSet = (
    <Row>
      <Col
        style={{
          padding: '2px 5px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'right',
        }}
      >
        <Form.Item
          label='处方笺打印金额'
          style={{
            marginBottom: '0px',
          }}
        >
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={showAmount}
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              setShowAmount(v)
            }}
            style={{
              backgroundColor: showAmount ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
        <Form.Item
          label='处方笺打印厂家'
          style={{
            marginBottom: '0px',
          }}
        >
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={showProducer}
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              setShowProducer(v)
              saveTenantFunctionList(Checks.CFJDYCJHPCH, v)
            }}
            style={{
              backgroundColor: showProducer ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
        <Form.Item
          label='处方笺打印病历号'
          style={{
            marginBottom: '0px',
          }}
        >
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={showBarCode}
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              setShowBarCode(v)
              saveTenantFunctionList(Checks.CFJDYBLH, v)
            }}
            style={{
              backgroundColor: showBarCode ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
        <Form.Item
          label='处方笺打印备注'
          style={{
            marginBottom: '0px',
          }}
        >
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={showRemark}
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              setShowRemark(v)
              saveTenantFunctionList(Checks.CFJDYBZ, v)
            }}
            style={{
              backgroundColor: showRemark ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
        <Form.Item
          label='处方笺打印主诉'
          style={{
            marginBottom: '0px',
          }}
        >
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={showZs}
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              setShowZs(v)
              saveTenantFunctionList(Checks.CFJDYZS, v)
            }}
            style={{
              backgroundColor: showZs ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
      </Col>
    </Row>
  )

  useEffect(() => {
    dispatch(getSettingDetail())
    setShowAmount(settings[Checks.CFJDYCFJE])
    setShowBarCode(settings[Checks.CFJDYBLH])
    setShowProducer(settings[Checks.CFJDYCJHPCH])
    setShowRemark(settings[Checks.CFJDYBZ])
    setShowZs(settings[Checks.CFJDYZS])
    return () => {
      dispatch(setCurePlanListVisible(false))
    }
  }, [])

  const setUpdateFlags = (insuranceFlag: string, updateFlag: string) => {
    if (treatment?.insuranceCode && treatment?.insuranceCode != 'ZIFEI') {
      dispatch(
        setUpdateFlagsAsync({
          treatmentId: treatmentId,
          insuranceFlag: treatment?.insuranceFlag,
          updateFlag,
        })
      )
        .then(unwrapResult)
        .then(() => {
          getTreatmentsDetail()
        })
    }
  }

  const getTreatmentsDetail = () => {
    dispatch(
      getTreatments({
        registrationId,
        treatmentId : treatmentId || treatment?.id,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        getPatientData && getPatientData(v)
        dispatch(setRecipeEditorTreatment(v?.treatment))
      })
  }

  const saveTenantFunctionList = (id: any, v: boolean) => {
    dispatch(
      saveSettingOneFunction({
        functionList: [{ type: id, value: v.toString() }],
      })
    )
      .then(unwrapResult)
      .then(() => {
        message.info('设置成功')
        dispatch(getSettingDetail())
      })
      .catch(() => {
        switch (id) {
          //32：处方笺打印条码，28：处方笺打印金额
          case Checks.CFJDYBLH:
            setShowBarCode(!v)
            break
          case Checks.CFJDYCFJE:
            setShowAmount(!v)
            break
          case Checks.CFJDYCJHPCH:
            setShowProducer(!v)
            break
          case Checks.CFJDYBZ:
            setShowRemark(!v)
            break
          case Checks.CFJDYZS:
            setShowZs(!v)
            break
        }
      })
  }
  
  //药品超量提醒
  const overReminder = (reminder: string) => {
    if (reminder?.trim() !== "") {
      Modal.info({
        centered: false,
        title: '温馨提醒',
        width: 600,
        content: (
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <ExclamationCircleFilled
              style={{ color: '#FFAE55', fontSize: 24, marginRight: 8 }}
            />
            <div>
              {reminder.split('\r\n').map((line: any, index: any) => (
                <span key={index}>
                  {index == 0 ? '请注意: ' : ''}
                  {line}
                  {index < reminder.split('\r\n').length - 1 && <br />}
                </span>
              ))}
            </div>
          </div>
        ),
        okText: '我知道了',
        icon: null,
        onOk: () => {
          setSaveSkip(false)
        },
      })
    }
  }

  const merge = (dryRun: boolean): boolean => {
    if (!recipe) {
      return false
    }
    return mergeGroup(
      materials,
      selectedKeys,
      dryRun
        ? undefined
        : (ms) => {
          dispatch(updateSortAndGroupNumber({
            materials: ms,
            syncFirstItemFUD: syncFirstItemFUD,
          }))
            .then(unwrapResult)
            .then(() => {
              setSelectedKeys([])
            })
        }
    )
  }

  const split = (dryRun: boolean): boolean => {
    if (!recipe) {
      return false
    }
    return splitGroup(
      materials,
      selectedKeys,
      dryRun
        ? undefined
        : (ms) => {
          dispatch(updateSortAndGroupNumber({
            materials: ms,
            syncFirstItemFUD: syncFirstItemFUD,
          }))
            .then(unwrapResult)
            .then(() => {
              setSelectedKeys([])
            })
        }
    )
  }

  // 药品信息展示：取列表「项目信息」列灰色小字中生产厂家之前的部分
  // 中药/颗粒/贴敷方、诊疗项目保持原有提示
  const getMaterialInfoText = (m: any) => {
    if (isTcmRecipeCategory(recipeCategory) || m?.drugType == 1) {
      return ''
    }
    const spec = m?.spec ? m?.spec : '-'
    const packSpec = m?.packSpec ? m?.packSpec : '-'
    const accountUnit = m?.accountUnit ? m?.accountUnit : '-'

    // 新目录库展示方式
    if (settings?.[Checks.MLKG] == 1) {
      return packSpec
    }
    // 老目录库展示方式
    return `${spec}/${packSpec}/${accountUnit}`
  }

  const add = (
    m: Material,
    ignoreStorage: boolean,
    id = '',
    isTbEdit = false,
    modalAdd = false,
  ) => {
    const addMaterial = materials?.filter((v) => v.id == m.id)

    dispatch(setPageLoading(true))

    // 药品id与目录id相同时，意味着是按目录新增的药品 || 药品id与库存id相同时，意味着是按库存新增的药品  || 药品id以库房名称开头 ，意味着即不忽略库存也不指定批次新增的药品    新增药时提醒  ||  modalAdd模态框编辑改药提醒
    // modalAdd 模态框编辑时，如果materials中已有相同id且同名的数据（编辑已有药品），不进行提醒
    if (
      (m?.id == m?.materialsCatalogId || m?.id == m?.inventoryLedgerId || m?.id.startsWith(m?.storehouseName) || modalAdd) &&
      materials.find((mt) => m.name === mt.name && m.id !== mt.id) &&
      !(modalAdd && materials?.some((mt) => mt.id === m.id && m.name === mt.name))
    ) {
      if (isTcmRecipeCategory(recipeCategory)) {
        Modal.warn({
          title: '提示',
          content: `已经添加了「${m.name}」，请仔细核对。`,
          onOk: () => {
            setSelectTag(true)
            setTimeout(() => {
              setSelectTag(false)
            }, 10)
          },
        })

        dispatch(setPageLoading(false))
        return
      } else {
        messageApi.open({
          type: 'warning',
          content: '请注意！您添加了多个「' + m.name + '」。',
          className: 'custom-class',
          style: {
            marginTop: '35vh',
          },
        })
      }
    }
    let groupNumber = m.groupNumber
    if (groupNumber <= 0) {
      groupNumber = 1
      if (materials.length > 0) {
        while (materials.find((m) => m.groupNumber === groupNumber)) {
          ++groupNumber
        }
      }
    }
    // let drugCount = 0

    // drugCount = Math.ceil(
    //                               ((calc || material?.frequencyCalc || 0) *
    //                                 form.getFieldValue('normalDose') *
    //                                 Number(v)) /
    //                                 material?.transitionScale
    // )
    const datas = { ...m }
    createIfNotExist((treatmentId, recipeId) => {

      // 跳过保存药品
      if (saveSkip) {
        return
      }

      dispatch(
        saveRecipeMaterials({
          treatmentId,
          recipeId,
          validateInventory: !ignoreStorage,
          syncFirstItemFUD: syncFirstItemFUD,
          createAutoFeeSwitch:
            createAutoFeeSwitch?.[56] == 'true' ? true : false,
          nurseStationWay:nurseStationWay,
          materials: [
            {
              ...m,
              splitUnit: addMaterial?.length
                ? m.splitTag > 0
                  ? m?.accountUnit
                  : m?.splitUnit
                : m?.splitUnit,
              accountUnit: addMaterial?.length
                ? m.splitTag > 0
                  ? addMaterial?.[0]?.accountUnit
                  : m?.accountUnit
                : m?.accountUnit,
              id,
              groupNumber,
              drugCount: m.drugCount * tipCount,
              // discount: m?.discount? Number(m?.discount) / 100 : undefined,
               discount: m?.discount ? Number(m?.discount) / 100 : 1,
              sort:
                materials.length === 0
                  ? 1
                  : id
                    ? m.sort
                    : materials
                      .map((m) => m.sort)
                      .reduce((p, c) => Math.max(p, c)) + 1,
            },
          ],
        })
      )
        .then(unwrapResult)
        .then(async (t: any) => {
          if (handlePrescriptionDrugLimit(t)) {
            dispatch(setPageLoading(false))
            return
          }

          if (m?.limitCount > 0 && (isTcmRecipeCategory(recipeCategory) ? m?.countPerTip : m?.drugCount) > m?.limitCount) {
            messageApi.open({
              type: 'warning',
              content: `${m?.name}超出设置的医保限量${m?.limitCount}`,
              className: 'custom-class',
              style: {
                marginTop: '35vh',
              },
            })
          }

          const reminders = t?.map((v: any) => v?.overdoseReminder || "");
          const hasNonEmpty = reminders?.some((r:any) => r.trim() !== "");
          if (hasNonEmpty) {
            setSaveSkip(true)
            const reminder = reminders.filter((r:any) => r.trim() !== "").join("\n");
            overReminder(reminder)
          }

          if (isTbEdit) {
            await dispatch(
              getBatchSynchronizationRecipeItem({
                sourceRecipeItemId: m?.id,
                targetRecipeId: m?.recipeId,
                type: 0,
              })
            )
              .then(unwrapResult)
              .then(() => {
                // if (location.pathname == '/retail') {
                //   dispatch(getRecipeDetail(recipeId))
                // }
              })
          }
          localStorage.removeItem('calc')
          dispatch(setPageLoading(false))
          if (!id || id == '') {
            setTimeout(() => {
              getDown()
            }, 200)
          }
          if (recipeCategory == 3 && treatment?.insuranceCode && treatment?.insuranceCode != 'ZIFEI') {
            if (materials?.length > (settings[Checks.ZYKFWSTX] ? (Number(settings[Checks.ZYKFWSTX]) - 1) : 19)) {
              messageApi.open({
                type: 'warning',
                content:
                  '请注意！当前处方已经超' +
                  (settings[Checks.ZYKFWSTX] ? Number(settings[Checks.ZYKFWSTX]) : 20) +
                  '味中药',
                className: 'custom-class',
                style: {
                  marginTop: '35vh',
                },
              })
            }
          }
          if (location.pathname == '/treatment') {
            dispatch(getRecipeDetail(recipeId))
              .then(unwrapResult)
              .then((v: any) => {
                const limit =
                  isOpenYBTJ &&
                    treatment?.insuranceCode != 'ZIFEI' &&
                    currentDoctorLimit &&
                    currentDoctorLimit?.limitType == 0 &&
                    currentDoctorLimit?.limitValue > 0 &&
                    (treatment?.treatmentCategory == 0 ||
                      treatment?.treatmentCategory == 2 ||
                      treatment?.treatmentCategory == 4)
                    ? Number(Number(currentDoctorLimit?.limitValue)?.toFixed(2))
                    : 30
                if (v[0]?.insuranceTipAmount?.toFixed(2) > limit) {
                  messageApi.open({
                    type: 'warning',
                    content: `当前帖均已超${limit}元，请注意`,
                    className: 'custom-class',
                    style: {
                      marginTop: '35vh',
                    },
                  })
                }
                //检查中药贴数是否一致
                if (checkTipConsistency(v?.[0])) {
                  messageApi.open({
                    type: 'warning',
                    content: `请注意，部分药品贴数与其他药品不一致，请检查处方明细是否有误。`,
                    className: 'custom-class',
                    style: {
                      marginTop: '35vh',
                    },
                  })
                }
              })
          }
          if (location.pathname !== '/retail' || isInsurance) {
            setUpdateFlags('1', '1')
          }
        })
        .catch((e) => {
          if (e?.message == '库存不足') {
            Modal.confirm({
              title: `请注意, [ ${m?.name} ]${getMaterialInfoText(m) ? ` ${getMaterialInfoText(m)}` : ''} 库存不足`,
              icon: <ExclamationCircleOutlined />,
              okText: '确认',
              cancelText: '取消',
            })
          }
          dispatch(setPageLoading(false))
        })
    })
  }

  const addGroup = (
    m: Material,
    ignoreStorage: boolean,
    id = '',
    recipeGroupId = ''
  ) => {
    createIfNotExist((treatmentId, recipeId) => {
      // 跳过保存药品
      if (saveSkip) {
        return
      }
      dispatch(setPageLoading(true))
      dispatch(
        saveRecipeMaterials({
          treatmentId,
          recipeId,
          validateInventory: !ignoreStorage,
          syncFirstItemFUD: syncFirstItemFUD,
          createAutoFeeSwitch:
            createAutoFeeSwitch?.[56] == 'true' ? true : false,
          nurseStationWay: nurseStationWay,
          materials: [
            {
              ...m,
              recipeGroupId: recipeGroupId,
              id,
              drugCount: m.drugCount * tipCount,
            },
          ],
        })
      )
        .then(unwrapResult)
        .then(async (t: any) => {
          if (handlePrescriptionDrugLimit(t)) {
            dispatch(setPageLoading(false))
            return
          }
          if (m?.limitCount > 0 && (isTcmRecipeCategory(recipeCategory) ? m?.countPerTip : m?.drugCount) > m?.limitCount) {
            messageApi.open({
              type: 'warning',
              content: `${m?.name}超出设置的医保限量${m?.limitCount}`,
              className: 'custom-class',
              style: {
                marginTop: '35vh',
              },
            })
          }
          dispatch(setPageLoading(false))
          if (location.pathname !== '/retail' || isInsurance) {
            setUpdateFlags('1', '1')
          }
        })
        .catch((e) => {
          if (e?.message == '库存不足') {
            Modal.confirm({
              title: `请注意, [ ${m?.name} ] 库存不足`,
              icon: <ExclamationCircleOutlined />,
              okText: '确认',
              cancelText: '取消',
              onOk: () => {
                dispatch(getRecipeDetail(recipeId))
              },
              onCancel: () => {
                dispatch(getRecipeDetail(recipeId))
              },
            })
          }
          dispatch(setPageLoading(false))
        })
        .finally(() => {
          setSelectMessage({})
        })
    })
  }

  // 失焦回车触发保存
  const saveGroup = (dosekKey: any, tipref: any, nameKey: any, field: any, item?: any) => {
    ZYFTFform.validateFields([dosekKey])
      .then(() => {
        const value = ZYFTFform.getFieldsValue([dosekKey])?.[dosekKey]
        const name = ZYFTFform.getFieldsValue([nameKey])?.[nameKey]
        const message = {
          ...item,
          ...selectMessage,
          countPerTip: value,
        }
        if (!value) {
          return
        }
        if (!item?.id) {
          const list = TFRecipeList?.filter((v: any) => {
            return v?.id == field.id
          })?.[0]?.groupItemList

          if (list?.find((mt: any) => message.name === mt.name && message.id !== mt.id)) {
            if (isTcmRecipeCategory(recipeCategory)) {
              Modal.warn({
                title: '提示',
                content: `已经添加了「${message.name}」，请仔细核对。`,
                onOk: () => {
                  dispatch(setPageLoading(false))
                  setFiles()
                  return
                },
              })
              return
            }
            setSelectMessage({})
          }
        }
        addGroup(message, ignoreStorage, item?.id || '', field.id);
      })
      .catch(() => {
        return
      })
  }
 
  // 更新
  const createOrUpdateGroup = (params: any,index?:any) => {
    dispatch(setPageLoading(true))
    setCurrentGroupIndex(index)
    dispatch(
      createOrUpdateGroupRecipe({
        ...params,
      })
    ).then(unwrapResult)
    .then((v) => {
      if (location.pathname !== '/retail' || isInsurance) {
        setUpdateFlags('1', '1')
      }
    })
    .finally(() => {
      dispatch(setPageLoading(false))
      setUseMethodSubmitData({})
    })
  }

  // 删除
  const deleteGroup = (params: any) => {
    Modal.confirm({
      centered: true,
      title: '确认操作',
      content: (
        <div>
          <ExclamationCircleFilled
            style={{ color: '#FFAE55', fontSize: 18 }}
          />
          &nbsp;是否确认删除？
        </div>
      ),
      okText: '确认',
      cancelText: '取消',
      icon: null,
      onOk: () => {
        dispatch(setPageLoading(true))
        dispatch(deleteGroupRecipe(params))
          .then(unwrapResult)
          .then((v) => {
            notification.success({
              message: '操作成功',
            })
          })
          .finally(() => {
            dispatch(setPageLoading(false))
          })
      },
    })

  }

  function checkTipConsistency(recipeData: any) {
    // 检查itemList是否存在且长度大于1
    if (!recipeData.itemList || recipeData.itemList.length <= 1) {
      return; // 只有一个明细时不作判断
    }

    // 收集所有tip值
    const tips = recipeData.itemList.map((item: any) => item.tip);

    // 检查是否所有tip值都相同
    const firstTip = tips[0];
    const hasInconsistentTips = tips.some((tip: any) => tip !== firstTip);

    return hasInconsistentTips; // 返回false表示所有贴数一致
  }

  const createIfNotExist = (
    callback: (treatmentId: string, recipeId: string, recipe?: any) => void,
    tipsFlag?: any,
    tipsCounts?: any
  ) => {
    const isRetailMode = mode === RecipeEditorMode.Retail
    const isCurrentRetailRecipe =
      recipeId && recipe && String(recipe.id) === String(recipeId)

    // 快速开单切换处方类别时，Redux 中的 recipe 可能还是上一张处方。
    // 有当前处方 ID 但详情尚未同步时，先加载该处方，不能复用上一张处方保存。
    if (isRetailMode && recipeId && !isCurrentRetailRecipe) {
      dispatch(getRecipeDetail(recipeId))
        .then(unwrapResult)
        .then(([currentRecipe]) => {
          callback(
            currentRecipe.treatmentId,
            currentRecipe.id,
            currentRecipe
          )
          if (isCopyReciptParam?.copyDiagnosticsFlag == 1) {
            onNewRecipe && onNewRecipe(currentRecipe, copyDiease)
          }
        })
      return
    }

    if (recipe && (!isRetailMode || isCurrentRetailRecipe)) {
      callback(recipe.treatmentId, recipe.id, recipe)
      if (isCopyReciptParam?.copyDiagnosticsFlag == 1) {
        onNewRecipe && onNewRecipe(recipe, copyDiease)
      }
    } else if (mode === RecipeEditorMode.Retail) {
      if (recipeCategory) {
        if (state == 1) {
          const birthdayStr = String(patientObj?.birthday || '')
          if (birthdayStr) {
            const birthdayDigits = birthdayStr.replace(/[-/]/g, '')
            const now = new Date()
            const todayStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`
            if (birthdayDigits > todayStr) {
              notification.error({ message: '出生日期填写不对' })
              return
            }
          }
          if (
            patientObj?.patientName &&
            patientObj?.birthday
            // patientObj?.treatmentDoctorId
          ) {
            dispatch(
              createRetailRecipePatient({
                patient: {
                  name: patientObj?.patientName,
                  sex: patientObj?.patientSex || 0,
                  ageMonth: patientObj?.ageMonth,
                  ageYear: patientObj?.ageYear,
                  ageDay: patientObj?.ageDay,
                  birthday: patientObj?.birthday,
                  id: patientObj?.patientId,
                  maritalStatus: 0,
                  phone: patientObj?.phone,
                  address: patientObj?.address,
                  provinceCode: patientObj?.provinceCode,
                  cityCode: patientObj?.cityCode,
                  contryCode: patientObj?.contryCode,
                },
                recipeAndSexVO: {
                  treatmentId,
                  category: recipeCategory,
                  disease: patientObj?.disease,
                  treatmentDepartmentId: patientObj?.treatmentDepartmentId,
                  treatmentDepartmentName: patientObj?.treatmentDepartmentName,
                  treatmentDoctorId: patientObj?.treatmentDoctorId,
                  treatmentDoctorName: patientObj?.treatmentDoctorName,
                  treatmentAssistantDoctorId: patientObj?.treatmentAssistantDoctorId,
                  treatmentAssistantDoctorName: patientObj?.treatmentAssistantDoctorName,
                  salesmanId: patientObj?.salesmanId,
                  salesmanName: patientObj?.salesmanName,
                },
                tip: tipCount,
              })
            )
              .then(unwrapResult)
              .then((recipe) => {
                callback(recipe.treatmentId, recipe.id, recipe)
                onNewRecipe && onNewRecipe(recipe, copyDiease)
                if (tipsFlag) {
                  getTipsCounts(tipsCounts, recipe)
                }
              })
          } else if (
            !patientObj?.patientName &&
            !patientObj?.birthday
            //  &&patientObj?.treatmentDoctorId
          ) {
            dispatch(
              createRetailRecipePatient({
                recipeAndSexVO: {
                  treatmentId,
                  category: recipeCategory,
                  disease: patientObj?.disease,
                  treatmentDepartmentId: patientObj?.treatmentDepartmentId,
                  treatmentDepartmentName: patientObj?.treatmentDepartmentName,
                  treatmentDoctorId: patientObj?.treatmentDoctorId,
                  treatmentDoctorName: patientObj?.treatmentDoctorName,
                  patientSex: patientObj?.patientSex || 0,
                  salesmanId: patientObj?.salesmanId,
                  salesmanName: patientObj?.salesmanName,
                },
                tip: tipCount,
              })
            )
              .then(unwrapResult)
              .then((recipe) => {
                callback(recipe.treatmentId, recipe.id, recipe)
                onNewRecipe && onNewRecipe(recipe, copyDiease)
                if (tipsFlag) {
                  getTipsCounts(tipsCounts, recipe)
                }
              })
          } else {
            dispatch(setPageLoading(false))
            setBtnLoading(false)
            setmlBtnLoading(false)
            setkcBtnLoading(false)
            notification.info({
              message: '请填写必填项',
            })
          }
        } else {
          dispatch(
            createRetailRecipe({
              treatmentId,
              ageMonth: patientObj?.ageMonth,
              ageYear: patientObj?.ageYear,
              ageDay: patientObj?.ageDay,
              birthday: patientObj?.birthday,
              category: recipeCategory,
              patientId: patientObj?.id,
              patientName: patientObj?.patientName,
              patientSex: patientObj?.patientSex,
              phone: patientObj?.phone,
              disease: patientObj?.disease,
              treatmentDepartmentId: patientObj?.treatmentDepartmentId,
              treatmentDepartmentName: patientObj?.treatmentDepartmentName,
              treatmentDoctorId: patientObj?.treatmentDoctorId,
              treatmentDoctorName: patientObj?.treatmentDoctorName,
              tip: tipCount,
            })
          )
            .then(unwrapResult)
            .then((recipe) => {
              callback(recipe.treatmentId, recipe.id)
              onNewRecipe && onNewRecipe(recipe, copyDiease)
            })
        }
      }
    } else if (mode === RecipeEditorMode.Extra) {
      if (treatmentId) {
        dispatch(
          createOrUpdateRecipe({
            category: RecipeCategory.Extras,
            treatmentId,
          } as Recipe)
        )
          .then(unwrapResult)
          .then((recipeId) => {
            setUpdateFlags('1', '1')
            return dispatch(getRecipeDetail(recipeId))
          })
          .then(unwrapResult)
          .then(([recipe]) => {
            callback(treatmentId, recipe.id, recipe)
            onNewRecipe && onNewRecipe(recipe)
          })
          .catch(() => {
            // do nothing.
          })
      }
    } else {
      notification.warning({ message: '请先添加一个空处方' })
      setIsCopyReciptModalVisible(false)
      setcfBtnLoading(false)
      resetSetMealLoading()
    }
  }

  const handlePrescriptionDrugLimit = (result: any) => {
    if (!result?.flag) {
      return false
    }
    const content = result?.message || '处方单不可超过5种药品'
    if (result.flag === PRESCRIPTION_DRUG_LIMIT_RECIPE_FULL) {
      Modal.warning({
        centered: true,
        title: '提示',
        content,
        okText: '知道了',
        icon: <ExclamationCircleFilled style={{ color: '#faad14' }} />,
      })
      return true
    }
    if (result.flag === PRESCRIPTION_DRUG_LIMIT_CREATE_RECIPE) {
      notification.info({
        message: content,
        duration: 3,
      })
      if (treatmentId && recipeCategory) {
        dispatch(
          createOrUpdateRecipe({
            treatmentId,
            category: recipeCategory,
          } as Recipe)
        )
          .then(unwrapResult)
          .then((newRecipeId) => dispatch(getRecipeDetail(newRecipeId)))
          .then(unwrapResult)
          .then(([newRecipe]) => {
            onNewRecipe && onNewRecipe(newRecipe)
          })
      }
      return true
    }
    return false
  }

  const getTipsCounts = (tipsCounts?: any, recipes?: any) => {
    if (tipsCounts > 0) {
      dispatch(
        createOrUpdateRecipe({
          ...recipes,
          tip: tipsCounts,
          useMethod: recipeUseMethod.join(','),
        } as Recipe)
      )
        .then(unwrapResult)
        .then((recipeId) => {
          setTipCount(tipsCounts)
          getRecipeDetailList(recipeId)
          if (location.pathname !== '/retail' || isInsurance) {
            setUpdateFlags('1', '1')
          }
        })
    }
  }
  useEffect(() => {
    setReplaceMakeDisable(materials.length === 0)
    //处方中 只剩一个代煎费时，删除这笔费用。与2025-11-12 删除该逻辑
    // if (materials.length === 1 && materials[0].id === replaceMakeId) {
    //   dispatch(removeMaterials({ ids: [replaceMakeId], syncFirstItemFUD: checkData?.find((v: any) => v.code == '11')?.codeName == 'true' ? true : false,}))
    //     .then(unwrapResult)
    //     .then(() => {
    //       dispatch(isdeleteReplaceMakeSetting({ status: 1, id: setID }))
    //         .then(unwrapResult)
    //         .then(() => {
    //           replaceMakeInfo()
    //         })
    //     })
    // }
    onRefreshRecipe && onRefreshRecipe(materials || [])
  }, [materials])

  useEffect(() => {
    if (isSetting) {
      const replaceMake = materials.find((v: any) => v.billingCategory === '97')
      setreplaceMakeId(replaceMake?.id)
    }
  }, [isSetting, materials])

  useEffect(() => {
    if (location.pathname !== '/retail' && !treatment) {
      getTreatmentsDetail()
    }
  }, [])

  useEffect(() => {
    if ((location.pathname == '/retail' || location.pathname == '/pharmacy/retail' )&& isTcmRecipeCategory(recipeCategory)) {
      const tips = KSKDMRTS ? Number(KSKDMRTS) : localData?.tips ? Number(localData?.tips) : tipCount
      setTipCount(tips)
    } else {
      setTipCount(1)
    }
  }, [location])

  useEffect(() => {
    const num: any = materials?.map((v) => {
      return Number(v?.drugAmount)
    })
    setDrugAmount(sum(num))
    const retailPriceNum: any = materials?.map((v) => {
      return Number(v?.originalDrugAmount)
    })
    setTotalRetailPriceAmount(sum(retailPriceNum))
  }, [materials])

  useEffect(() => {
    dispatch(resetRecipeEditor())
    return () => {
      dispatch(resetRecipeEditor())
      setRecipeUseMethod([])
      setElseRecipeUseMethod({})
      setTipCount(1)
    }
  }, [])

  useEffect(() => {
    if (isTcmRecipeCategory(recipeCategory)) {
      setRecipeUseMethod(DefaultUseMethod)
      setElseRecipeUseMethod({})
      const tips = KSKDMRTS ? Number(KSKDMRTS) : localData?.tips ? Number(localData?.tips) : tipCount
      if (location.pathname == '/retail' || location.pathname == '/pharmacy/retail') {
        setTipCount(tips)
      } else {
        setTipCount(Number(tipsCount) || 7)
      }
    } else {
      setRecipeUseMethod([])
      setElseRecipeUseMethod({})
      setTipCount(1)
    }
  }, [recipeCategory])


  useEffect(() => {
    if (!isDecoctingSettingModalVisible) {
      if (recipeId) {
        dispatch(setPageLoading(true))
        getRecipeDetailList(recipeId)
        setTimeout(() => {
          dispatch(setPageLoading(false))
        }, 5000)
      } else {
        dispatch(resetRecipeEditor())
      }
    }
  }, [dispatch, recipeId, isDecoctingSettingModalVisible])


  useEffect(() => {
   setFiles()
  }, [recipe])

  const setFiles = ()=>{
     if (recipe) {
      ZYFTFform.resetFields()
      const groupList = recipe?.groupList?.map((group: any) => {
        const list = materials?.filter((item: any) => item?.recipeGroupId == group.id);
        return {
          ...group,
          groupItemList: list
        };
      });
      setTFRecipeList(groupList)
      const formValues: any = {}
      groupList?.forEach((v: any, index: number) => {
        v.groupItemList?.forEach((item: any, itemIndex: number) => {
          formValues[`recipeItem_name_${index}_${itemIndex}`] = item.name || ''
          formValues[`recipeItem_dose_${index}_${itemIndex}`] = item.countPerTip == -1 ? '' : item.countPerTip || 1
        })
        // formValues[`recipeList[${index}].tip`] = v.groupTip || 1
        // formValues[`recipeList[${index}].useMethod`] = v.groupUsemethod || ''
      })
      ZYFTFform.setFieldsValue(formValues)
    }
  }

  useEffect(() => {
    if (recipe) {
      const flag = localStorage.getItem('SHOWCATEGORYMODAL') == '1'
      setCategoryVisible(
        (recipe.materialsExists == 0 || recipe.treatmentExists == 0) && !flag
      )
      setmaterialsExists(recipe.materialsExists || 0)
      settreatmentExists(recipe.treatmentExists || 0)
      setTipCount(recipe.tip <= 0 ? 1 : recipe.tip)
      if (recipe.useMethod) {
        setRecipeUseMethod(recipe.useMethod?.split(',') || [])
        const fValue: any =
          (recipe?.recipeNormalFrequency
            ? ',' + recipe?.recipeNormalFrequency
            : '') +
          (recipe?.recipeNormalUsemethod
            ? ',' + recipe?.recipeNormalUsemethod
            : '') +
          (recipe?.recipeNormalDose ? ',' + recipe?.recipeNormalDose : '') +
          (recipe?.remark ? ',' : '')

        setElseMethod(fValue)
        setElseRemark(recipe?.remark ? recipe?.remark : '')
        setElseRecipeUseMethod({
          recipeNormalFrequency: recipe?.recipeNormalFrequency,
          recipeNormalUsemethod: recipe?.recipeNormalUsemethod,
          recipeNormalDose: recipe?.recipeNormalDose,
          remark: recipe?.remark,
        })
      }
      onChange && onChange(recipe)
    }
  }, [recipe])

  const getReciptPrintList = () => {
    dispatch(getPrintZXDData(recipeId))
      .then(unwrapResult)
      .then((v: any) => {
        setPrintZXDData(v)
      })
  }

  const replaceMakeInfo = () => {
    if (
      recipeCategory === 3 ||
      recipeCategory === 12
      // &&materials.length !== 0
    ) {
      const data: replaceMakeInfoParams = {
        decoctionType: recipeCategory === 3 ? 0 : 1,
        tenantRecipeId: recipeId!,
      }

      // 暂时注释
      dispatch(getReplaceMakeInfo({ ...data }))
        .then(unwrapResult)
        .then((res: any) => {
          setIsOpenReplaceMake(res.openType === 0)
          setSetId(res.settingId)
          setIsSetting(res.status === 1)
          setMachiningTypeMsg(res.machiningTypeMsg)
          setpotionType(res.potionType?.toString())
          setIsOpenPriceRatio(res.openPriceRatio == 0)
        })
    } else {
      setpotionType(2)
      setIsSetting(false)
    }
  }
  // 获取代煎处方信息
  useEffect(() => {
    replaceMakeInfo()
  }, [isDecoctingSettingModalVisible, recipeId])

  useEffect(() => {
    setIsDispose(recipeCategory == 13)
  }, [recipeCategory])

  const getPrice = (m: any) => {
    if (m?.comboSplitTag == 1 && m?.drugTypeA == 0) {
      return m?.catalogSplitPrice
    } else if (m?.comboSplitTag == 0 && m?.drugTypeA == 1) {
      return m?.catalogPrice
    } else if (m?.comboSplitTag == 0 && m?.drugTypeA == 0) {
      return m?.catalogPrice
    }
  }
  const getUnit = (m: any) => {
    if (m.comboSplitTag == 1 && m.drugTypeA == 0) {
      return m.catalogSplitUnit
    } else if (m.comboSplitTag == 0 && m.drugTypeA == 1) {
      return m.accountUnit
    } else if (m.comboSplitTag == 0 && m.drugTypeA == 0) {
      return m.catalogUnit
    }
  }

  //获取库存售价
  const getNewPrice = (m: any) => {
    if (m.comboSplitTag == 1 && m.drugTypeA == 0) {
      return m.latestSplitPrice
    } else if (m.comboSplitTag == 0 && m.drugTypeA == 1) {
      return m.latestPrice
    } else if (m.comboSplitTag == 0 && m.drugTypeA == 0) {
      return m.latestPrice
    }
  }
  //获取库存进价
  const getNewUnitPrice = (m: any) => {
    if (m.comboSplitTag == 1 && m.drugTypeA == 0) {
      return m.costSplitPrice
    } else if (m.comboSplitTag == 0 && m.drugTypeA == 1) {
      return 0
    } else if (m.comboSplitTag == 0 && m.drugTypeA == 0) {
      return m.costPrice
    }
  }
  const getNewUnit = (m: any) => {
    if (m.comboSplitTag == 1 && m.drugTypeA == 0) {
      return m.latestSplitUnit
    } else if (m.comboSplitTag == 0 && m.drugTypeA == 1) {
      return m.latestUnit
    } else if (m.comboSplitTag == 0 && m.drugTypeA == 0) {
      return m.latestUnit
    }
  }

  const MedicineColumn = discountFlag
    ? MedicineMaterialDiscountColumns
    : MedicineMaterialColumns

  const TcmColumn = discountFlag ? TcmDiscountColumns : TcmColumns
  
  const changeItemsPayType = (
    <Menu
      onClick={(item) => {
        if (!selectedKeys || selectedKeys.length <= 0) {
          notification.error({
            message: '请选择至少一条明细',
          })
          return
        }
        setUpdateItemTypeBatchReadLoading(true)
        const param: PayTypeBodyBatch = {
          treatmentId: Number(treatmentId),
          itemPayType: item.key,
          recipeItemIds: selectedKeys,
        }
        dispatch(updateItemPayTypeBatchAsync(param))
          .then(unwrapResult)
          .then(() => {
            dispatch(getRecipeDetail(recipeId || ''))
              .then(unwrapResult)
              .then(() => {
                setSelectedKeys([])
                notification.success({
                  message: '操作成功',
                })
                setUpdateItemTypeBatchReadLoading(false)
              })
          })
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
        医保
      </Menu.Item>
      <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
        历年
      </Menu.Item>
      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )

  // 拖拽
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    })
  )

  const getDown = () => {
    try {
      const tableDoms: any = document?.getElementById('tableDom')?.parentNode
        ?.parentNode?.parentNode
      tableDoms.scrollTop = 99999
    } catch (e) {
      return
    }
  }

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      const params: any = {
        operationItemId: active.id,
        targetItemId: over?.id,
        recipeId,
      }
      dispatch(setPageLoading(true))
      dispatch(exchangeList(params))
        .then(unwrapResult)
        .then((v) => {
          getRecipeDetailList(recipeId || '')
        })
        .catch(() => {
          dispatch(setPageLoading(false))
        })
    }
    // dispatch(setPageLoading(false))
  }

  const getRecipeDetailList = (recipeId: any) => {
    dispatch(getRecipeDetail(recipeId))
  }

  interface RowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    'data-row-key': string
  }

  const Rows = (props: RowProps) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props['data-row-key'],
    })

    const style: React.CSSProperties = {
      ...props.style,
      transform: CSS.Transform.toString(
        transform && { ...transform, scaleY: 1 }
      ),
      transition,
      cursor: 'move',
      ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
    }

    return (
      <tr
        {...props}
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
      />
    )
  }

  useEffect(() => {
    // 添加套餐
    const flag: any = isSetMealModalVisible
    localStorage?.setItem('editMedicalVisible', flag)
  }, [isSetMealModalVisible])

  useEffect(() => {
    // 复制处方
    const flag: any = isCopyModalVisible
    localStorage?.setItem('editMedicalVisible', flag)
  }, [isCopyModalVisible])

  useEffect(() => {
    // 代煎设置
    const flag: any = isDecoctingSettingModalVisible
    localStorage?.setItem('editMedicalVisible', flag)
  }, [isDecoctingSettingModalVisible])

  useEffect(() => {
    // 打印设置
    const flag: any = isPrintSettingModalVisible
    localStorage?.setItem('editMedicalVisible', flag)
  }, [isPrintSettingModalVisible])

  useEffect(() => {
    // 处方用法
    const flag: any = isUseMethodModalVisible
    localStorage?.setItem('editMedicalVisible', flag)
  }, [isUseMethodModalVisible])

  const getCurrentComboSavedMaterials = (savedMaterials: any, sourceMaterials: any) => {
    const savedList = Array.isArray(savedMaterials) ? savedMaterials : []
    const sourceList = Array.isArray(sourceMaterials) ? sourceMaterials : []
    if (!sourceList.length || savedList.length <= sourceList.length) {
      return savedList
    }

    const sourceGroupNumbers = new Set(
      sourceList
        ?.map((m: any) => m?.groupNumber)
        ?.filter((groupNumber: any) => groupNumber !== undefined && groupNumber !== null)
        ?.map((groupNumber: any) => String(groupNumber))
    )
    const currentSavedList = savedList?.filter((item: any) =>
      sourceGroupNumbers.has(String(item?.groupNumber))
    )

    return currentSavedList.length ? currentSavedList : savedList.slice(-sourceList.length)
  }

  // 复制处方后只对比本次新增明细，避免之前复制的数据再次出现在温馨提醒中。
  const getCurrentCopyRecipeItems = (recipeItems: any) => {
    const itemList = Array.isArray(recipeItems) ? recipeItems : []
    const previousList = Array.isArray(materials) ? materials : []
    if (!previousList.length) {
      return itemList
    }

    const previousItemIds = new Set(
      previousList
        ?.map((item: any) => item?.id)
        ?.filter((id: any) => id !== undefined && id !== null && id !== '')
        ?.map((id: any) => String(id))
    )
    const currentItemsById = itemList?.filter((item: any) =>
      !previousItemIds.has(String(item?.id))
    )
    if (currentItemsById.length) {
      return currentItemsById
    }

    // 明细 ID 无法对应时，按复制后追加的组号和顺序兜底。
    const maxPreviousGroupNumber = previousList.reduce(
      (max: number, item: any) => Math.max(max, Number(item?.groupNumber) || 0),
      0
    )
    const currentItemsByGroup = itemList?.filter(
      (item: any) => Number(item?.groupNumber) > maxPreviousGroupNumber
    )
    if (currentItemsByGroup.length) {
      return currentItemsByGroup
    }

    const copiedCount = itemList.length - previousList.length
    return copiedCount > 0 ? itemList.slice(-copiedCount) : []
  }

  const getCurrentComboRecipeItems = (recipeItems: any) => {
    const itemList = Array.isArray(recipeItems) ? recipeItems : []
    if (isTcmRecipeCategory(recipe?.category || recipeCategory)) {
      return itemList
    }
    if (!saveRecipeMaterialsData?.length) {
      return []
    }

    const savedItemIds = new Set(
      saveRecipeMaterialsData
        ?.map((item: any) => item?.id)
        ?.filter((id: any) => id !== undefined && id !== null && id !== '')
        ?.map((id: any) => String(id))
    )
    const itemsById = itemList?.filter((item: any) =>
      savedItemIds.has(String(item?.id))
    )
    if (itemsById.length) {
      return itemsById
    }

    const savedGroupNumbers = new Set(
      saveRecipeMaterialsData
        ?.map((item: any) => item?.groupNumber)
        ?.filter((groupNumber: any) => groupNumber !== undefined && groupNumber !== null)
        ?.map((groupNumber: any) => String(groupNumber))
    )
    const itemsByGroup = itemList?.filter((item: any) =>
      savedGroupNumbers.has(String(item?.groupNumber))
    )

    return itemsByGroup.length
      ? itemsByGroup
      : itemList.slice(-saveRecipeMaterialsData.length)
  }
  const getTips = (recipeId: any, srcRecipeId?: string) => {
    const sourceRecipeId = srcRecipeId || isCopyReciptParam?.srcRecipeId
    if (location.pathname == '/retail') {
      dispatch(getRecipeDetail(recipeId))
        .then(unwrapResult)
        .then((v: any) => {
          if (comparisonType == 1) {
            getChangeData(
              getCurrentComboRecipeItems(v?.[0]?.itemList)?.map((n: any) => {
                return settings?.[Checks.MLKG] != 1 ? {
                  id: n.localItemId,
                  name: n.name,
                  accountUnit: n.splitTag ? n.splitUnit : n.accountUnit,
                  retailPrice: n.retailPrice,
                  spec: n.spec,
                  packSpec: n.packSpec,
                } :{
                  id: n.localItemId,
                  name: n.name,
                  retailPrice: n.retailPrice,
                  spec: n.spec,
                }
              }),
              saveRecipeMaterialsData?.map((n: any) => {
                return settings?.[Checks.MLKG] != 1 ? {
                  id: n.localItemId,
                  name: n.name,
                  accountUnit: n.splitTag ? n.splitUnit : n.accountUnit,
                  retailPrice: n.retailPrice,
                  spec: n.spec,
                  packSpec: n.packSpec,
                } : {
                  id: n.localItemId,
                  name: n.name,
                  retailPrice: n.retailPrice,
                  spec: n.spec,
                }
              })
            )
          } else if (comparisonType == 2) {
            dispatch(
              getMaterialList({
                recipeId: sourceRecipeId,
                size: 100,
              })
            )
              .then(unwrapResult)
              .then((res) => {
                getChangeData(
                  getCurrentCopyRecipeItems(v?.[0]?.itemList)
                    ?.filter((t: any) => !!t?.copySrcId)
                    ?.map((n: any) => {
                      return settings?.[Checks.MLKG] != 1 ? {
                        id: n.localItemId,
                        name: n.name,
                        accountUnit: n.splitTag ? n.splitUnit : n.accountUnit,
                        retailPrice: n.retailPrice,
                        spec: n.spec,
                        packSpec: n.packSpec,
                      } : {
                        id: n.localItemId,
                        name: n.name,
                        retailPrice: n.retailPrice,
                        spec: n.spec,
                      }
                    }),
                  res?.map((n: any) => {
                    return settings?.[Checks.MLKG] != 1 ? {
                      id: n.localItemId,
                      name: n.name,
                      accountUnit: n.splitTag ? n.splitUnit : n.accountUnit,
                      retailPrice: n.retailPrice,
                      spec: n.spec,
                      packSpec: n.packSpec,
                    } : {
                      id: n.localItemId,
                      name: n.name,
                      retailPrice: n.retailPrice,
                      spec: n.spec,
                    }
                  })
                )
              })
          }
        })
    }
    if (location.pathname == '/treatment') {
      dispatch(getRecipeDetail(recipeId))
        .then(unwrapResult)
        .then((v: any) => {
          if (v[0]?.insuranceTipAmount?.toFixed(2) > 30) {
            messageApi.open({
              type: 'warning',
              content: '当前帖均已超30元，请注意',
              className: 'custom-class',
              style: {
                marginTop: '35vh',
              },
            })
          }
          if (comparisonType == 1) {
            getChangeData(
              getCurrentComboRecipeItems(v?.[0]?.itemList)?.map((n: any) => {
                return settings?.[Checks.MLKG] != 1 ? {
                  id: n.localItemId,
                  name: n.name,
                  accountUnit: n.splitTag ? n.splitUnit : n.accountUnit,
                  retailPrice: n.retailPrice,
                  spec: n.spec,
                  packSpec: n.packSpec,
                } : {
                  id: n.localItemId,
                  name: n.name,
                  retailPrice: n.retailPrice,
                  spec: n.spec,
                }
              }),
              saveRecipeMaterialsData?.map((n: any) => {
                return settings?.[Checks.MLKG] != 1 ? {
                  id: n.localItemId,
                  name: n.name,
                  accountUnit: n.splitTag ? n.splitUnit : n.accountUnit,
                  retailPrice: n.retailPrice,
                  spec: n.spec,
                  packSpec: n.packSpec,
                } : {
                  id: n.localItemId,
                  name: n.name,
                  retailPrice: n.retailPrice,
                  spec: n.spec,
                }
              })
            )
          } else if (comparisonType == 2) {
            dispatch(
              getMaterialList({
                recipeId: sourceRecipeId,
                size: 100,
              })
            )
              .then(unwrapResult)
              .then((res) => {
                getChangeData(
                  getCurrentCopyRecipeItems(v?.[0]?.itemList)
                    ?.filter((t: any) => !!t?.copySrcId)
                    ?.map((n: any) => {
                      return settings?.[Checks.MLKG] != 1 ? {
                        id: n.localItemId,
                        name: n.name,
                        accountUnit: n.splitTag ? n.splitUnit : n.accountUnit,
                        retailPrice: n.retailPrice,
                        spec: n.spec,
                        packSpec: n.packSpec,
                      } : {
                        id: n.localItemId,
                        name: n.name,
                        retailPrice: n.retailPrice,
                        spec: n.spec,
                      }
                    }),
                  res?.map((n: any) => {
                    return settings?.[Checks.MLKG] != 1 ? {
                      id: n.localItemId,
                      name: n.name,
                      accountUnit: n.splitTag ? n.splitUnit : n.accountUnit,
                      retailPrice: n.retailPrice,
                      spec: n.spec,
                      packSpec: n.packSpec,
                    } : {
                      id: n.localItemId,
                      name: n.name,
                      retailPrice: n.retailPrice,
                      spec: n.spec,
                    }
                  })
                )
              })
          }
          if (isTcmRecipeCategory(recipe?.category || recipeCategory)) {
            if (isCopyReciptTip) {
              const tipsList = v?.[0]?.itemList?.map((item: any) => {
                return item?.tip
              })
              const flag = tipsList.every((item: any) => item === tipsList[0])
              if (!flag) {
                messageApi.open({
                  type: 'warning',
                  content: '请注意，部分草药帖数不一样，请确认',
                  className: 'custom-class',
                  style: {
                    marginTop: '35vh',
                  },
                })
              }
            }
          }
        })
    }
  }

  //判断添加套餐数据是否发生变化
  const getChangeData = (arr1: any, arr2: any) => {
    const result = []
    for (const item1 of arr1) {
      const foundItem = arr2?.find((item2: any) => item2?.id == item1?.id)
      if (foundItem) {
        const unequalFields = []
        for (const key in item1) {
          if (key !== 'id' && item1[key] !== foundItem[key]) {
            if(foundItem[key] == '克' && item1[key] == 'g'){
              continue;
            }
            unequalFields.push({
              field: key,
              value1: item1[key],
              value2: foundItem[key],
            })
          }
        }
        if (unequalFields.length > 0) {
          result.push({ id: item1.id, name: item1.name, unequalFields })
        }
      }
    }
    if (result.length) {
      const comparisonInfoType = JSON.parse(
        localStorage.getItem('comparisonInfoType') || 'false'
      )
      const sevenDaysNoInfo = JSON.parse(
        localStorage.getItem('sevenDaysNoInfo') || 'false'
      )
      if (!sevenDaysNoInfo?.value) {
        if (comparisonInfoType) {
          notification.warning({
            message:
              '请注意，部分项目的关键信息相比原处方有一些变化，请仔细核对',
            description: (
              <div>
                {result?.map((m: any) => {
                  return (
                    <div key={m.id}>
                      <span style={{ fontWeight: 'bold' }}>{m.name}</span>&nbsp;
                      {m.unequalFields &&
                        m.unequalFields?.map((v: any) => {
                          const oldValue = v.field == "name" ? "名称" : v.field == "accountUnit" ? "单位" : v.field == "retailPrice" ? "单价" : v.field == "packSpec" ? "包装规格" : v.field == "spec" ? "制剂规格" : ""
                          const newValue = v.field == "name" ? "名称" : v.field == "accountUnit" ? "单位" : v.field == "retailPrice" ? "单价" : v.field == "spec" ? "规格" : ""
                          return (
                            <span key={v.id}>
                              {settings?.[Checks.MLKG] == 1 ? newValue : oldValue}
                              ：&nbsp;
                              {v.value2}&nbsp;
                              <ArrowRightOutlined
                                style={{ color: '#FFA037' }}
                              />
                              &nbsp;{v.value1};&nbsp;
                            </span>
                          )
                        })}
                    </div>
                  )
                })}
              </div>
            ),
          })
        } else {
          setComparisonModalData(result)
          setComparisonModalVisible(true)
        }
      }
      SetComparisonType(0)
    }
  }

  useEffect(() => {
    if (curePlanListVisible) {
      // 获取详情
      dispatch(getPrintTemplateSettingDetail())
        .then(unwrapResult)
        .then((v: any) => {
          setPrintFlagDetail(v)
        })
    }
  }, [curePlanListVisible])

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
  }

  useEffect(() => {
    if (isTreatmentPartsModalVisible) {
      dispatch(defaultXianBingListAsync(2))
        .then(unwrapResult)
        .then((res: any) => {
          setTreatmentPartsList(res)
        })
    }
  }, [isTreatmentPartsModalVisible])

  const UpdateRecipe = (callback: () => void, recipe: Recipe) => {
    return dispatch(
      createOrUpdateRecipe({
        ...recipe,
        recipeNormalFrequency: selectData?.comboNormalFrequency ? selectData?.comboNormalFrequency : recipe?.recipeNormalFrequency,
        recipeNormalUsemethod: selectData?.comboNormalUsemethod ? selectData?.comboNormalUsemethod : recipe?.recipeNormalUsemethod,
        recipeNormalDose: selectData?.comboNormalDose ? selectData?.comboNormalDose : recipe?.recipeNormalDose,
        remark: selectData?.remark ? selectData?.remark : recipe?.remark,
        tip: tipCount,
        useMethod: selectData?.comboUseMethod ? selectData?.comboUseMethod : recipe?.useMethod,
      } as Recipe)
    )
      .then(unwrapResult)
      .then((res) => {
        callback && callback()
      })
      .catch(() => {
        // 处方更新失败时不会进入套餐明细保存的 finally，需要在此复位价格按钮状态。
        resetSetMealLoading()
      })
  }

  // 部位弹窗提交后 treatmentParts 一定有值（允许为空字符串），此时应继续保存，
  // 避免重复打开部位弹窗，导致套餐保存未执行且按钮一直处于 loading 状态。
  const shouldOpenTreatmentPartsModal = (treatmentParts?: any) =>
    treatmentParts === undefined &&
    noBodyFlag &&
    Boolean(selectData?.treatmentParts)

  // 使用目录价格
  const getCopyMLSubmit = (treatmentParts?: any) => {
    if (shouldOpenTreatmentPartsModal(treatmentParts)) {
      setIsTreatmentPartsModalVisible(true)
      return
    }

    setmlBtnLoading(true)
    setBtnLoading(true)
    setkcBtnLoading(true)

    if (recipeCategory == RecipeCategory.Tcm || recipeCategory == RecipeCategory.TcmGranules || recipeCategory == RecipeCategory.TcmApply) {
      createIfNotExist((treatmentId, recipeId, recipe) => {
        UpdateRecipe(() => {
          getMLSubmit(treatmentParts, treatmentId, recipeId)
        }, recipe)
      }
      )
    } else {
      createIfNotExist((treatmentId, recipeId, recipe) => {
        getMLSubmit(treatmentParts, treatmentId, recipeId)
      })
    }
  }

  const getMLSubmit = (treatmentParts?: any, treatmentId?: any, recipeId?: any) => {
    const maxGroupNumber = materials.reduce(
      (g, m) => Math.max(g, m.groupNumber),
      0
    )
    const submitMaterials = copyMealParams?.map((m: any) => {
      return {
        ...m,
        groupNumber: m?.groupNumber + maxGroupNumber,
        retailPrice: getPrice(m),
        id: '',
        accountUnit: m?.accountUnit,
        splitUnit: m?.comboSplitUnit,
        splitScale: m?.comboSplitScale,
        splitTag: m?.comboSplitTag,
        tempType: 1,
      }
    })
    dispatch(
      saveRecipeComboMaterials({
        treatmentId,
        recipeId,
        comboId,
        syncFirstItemFUD: syncFirstItemFUD,
        createAutoFeeSwitch:
          createAutoFeeSwitch?.[56] == 'true' ? true : false,
        validateInventory: false,
        treatmentParts: treatmentParts,
        nurseStationWay: nurseStationWay,
        copyAmountType: 0,
        materials: copyMealParams?.map((m: any) => {
          return {
            ...m,
            groupNumber: m?.groupNumber + maxGroupNumber,
            retailPrice: getPrice(m),
            id: '',
            accountUnit: m?.accountUnit,
            splitUnit: m?.comboSplitUnit,
            splitScale: m?.comboSplitScale,
            splitTag: m?.comboSplitTag,
            tempType: 1, //是否是使用目录价格
          }
        }),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (handlePrescriptionDrugLimit(res)) {
          return
        }
        const currentSavedMaterials = isTcmRecipeCategory(recipeCategory)
          ? res
          : getCurrentComboSavedMaterials(res, submitMaterials)
        saveRecipeMaterialsData = currentSavedMaterials
        if (recipeCategory === RecipeCategory.Tcm) {
          const couldReplaceStockList = res?.map((v: any) => v?.couldReplaceStockList)?.flat(1)
          if (couldReplaceStockList?.length) {
            setDataList(res)
            setCouldReplaceStockListModalVisible(true)
            setShowFlag(true)
          } else {
            getTips(recipeId)
          }
        } else {
          getTips(recipeId)
        }
      })
      .finally(() => {
        setIsMealModalVisible(false)
        setmlBtnLoading(false)
        setBtnLoading(false)
        setkcBtnLoading(false)
        setIsTreatmentPartsModalVisible(false)
        setCurrentGroupIndex(0)
      })
  }

  // 使用套餐价格
  const getCopyTCSubmit = (treatmentParts?: any) => {
    if (shouldOpenTreatmentPartsModal(treatmentParts)) {
      setIsTreatmentPartsModalVisible(true)
      return
    }

    setBtnLoading(true)
    setmlBtnLoading(true)
    setkcBtnLoading(true)

    if (recipeCategory == RecipeCategory.Tcm || recipeCategory == RecipeCategory.TcmGranules || recipeCategory == RecipeCategory.TcmApply) {
      createIfNotExist((treatmentId, recipeId, recipe) => {
        UpdateRecipe(() => {
          getTCSubmit(treatmentParts, treatmentId, recipeId)
        }, recipe)
      }
      )
    } else {
      createIfNotExist((treatmentId, recipeId, recipe) => {
        getTCSubmit(treatmentParts, treatmentId, recipeId)
      })
    }
  }

  const getTCSubmit = (treatmentParts?: any, treatmentId?: any, recipeId?: any) => {
    const maxGroupNumber = materials.reduce(
      (g, m) => Math.max(g, m.groupNumber),
      0
    )
    const submitMaterials = copyMealParams?.map((m: any) => ({
      ...m,
      groupNumber: m?.groupNumber + maxGroupNumber,
      id: '',
      accountUnit: m?.accountUnit,
      splitUnit: m?.comboSplitUnit,
      splitScale: m?.comboSplitScale,
      splitTag: m?.comboSplitTag,
    }))
    dispatch(
      saveRecipeComboMaterials({
        treatmentId,
        recipeId,
        comboId,
        syncFirstItemFUD: syncFirstItemFUD,
        createAutoFeeSwitch:
          createAutoFeeSwitch?.[56] == 'true' ? true : false,
        validateInventory: false,
        treatmentParts: treatmentParts,
        nurseStationWay: nurseStationWay,
        copyAmountType: 1,
        materials: copyMealParams?.map((m: any) => ({
          ...m,
          groupNumber: m?.groupNumber + maxGroupNumber,
          id: '',
          accountUnit: m?.accountUnit,
          splitUnit: m?.comboSplitUnit,
          splitScale: m?.comboSplitScale,
          splitTag: m?.comboSplitTag,
        })),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (handlePrescriptionDrugLimit(res)) {
          return
        }
        const currentSavedMaterials = isTcmRecipeCategory(recipeCategory)
          ? res
          : getCurrentComboSavedMaterials(res, submitMaterials)
        const reminders = currentSavedMaterials?.map((v: any) => v?.overdoseReminder || "");
        const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
        if (hasNonEmpty) {
          const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
          overReminder(reminder)
        }

        saveRecipeMaterialsData = currentSavedMaterials
        if (recipeCategory === RecipeCategory.Tcm) {
          const couldReplaceStockList = res?.map((v: any) => v?.couldReplaceStockList)?.flat(1)
          if (couldReplaceStockList?.length) {
            setDataList(res)
            setShowFlag(true)
            setCouldReplaceStockListModalVisible(true)
          } else {
            getTips(recipeId)
          }
        } else {
          getTips(recipeId)
        }
      })
      .finally(() => {
        setIsMealModalVisible(false)
        setBtnLoading(false)
        setmlBtnLoading(false)
        setkcBtnLoading(false)
        setIsTreatmentPartsModalVisible(false)
        setCurrentGroupIndex(0)
      })
  }

  // 使用库存价格
  const getCopyKCSubmit = (treatmentParts?: any) => {
    if (shouldOpenTreatmentPartsModal(treatmentParts)) {
      setIsTreatmentPartsModalVisible(true)
      return
    }

    setkcBtnLoading(true)
    setBtnLoading(true)
    setmlBtnLoading(true)

    if (recipeCategory == RecipeCategory.Tcm || recipeCategory == RecipeCategory.TcmGranules || recipeCategory == RecipeCategory.TcmApply) {
      createIfNotExist((treatmentId, recipeId, recipe) => {
        UpdateRecipe(() => {
          getKCSubmit(treatmentParts, treatmentId, recipeId)
        }, recipe)
      }
      )
    } else {
      createIfNotExist((treatmentId, recipeId, recipe) => {
        getKCSubmit(treatmentParts, treatmentId, recipeId)
      })
    }
  }

  const getKCSubmit = (treatmentParts?: any, treatmentId?: any, recipeId?: any) => {
    const maxGroupNumber = materials.reduce(
      (g, m) => Math.max(g, m.groupNumber),
      0
    )
    const submitMaterials = copyMealParams?.map((m: any) => {
      return {
        ...m,
        groupNumber: m?.groupNumber + maxGroupNumber,
        retailPrice: getNewPrice(m),
        rawCostPrice: getNewUnitPrice(m),
        id: '',
        accountUnit: m?.accountUnit,
        splitUnit: m?.comboSplitUnit,
        splitScale: m?.comboSplitScale,
        splitTag: m?.comboSplitTag,
        tempType: 2,
      }
    })
    dispatch(
      saveRecipeComboMaterials({
        treatmentId,
        recipeId,
        comboId,
        syncFirstItemFUD: syncFirstItemFUD,
        createAutoFeeSwitch:
          createAutoFeeSwitch?.[56] == 'true' ? true : false,
        validateInventory: false,
        treatmentParts: treatmentParts,
        nurseStationWay: nurseStationWay,
        copyAmountType: 2,
        materials: copyMealParams?.map((m: any) => {
          return {
            ...m,
            groupNumber: m?.groupNumber + maxGroupNumber,
            retailPrice: getNewPrice(m),
            rawCostPrice: getNewUnitPrice(m),
            id: '',
            accountUnit: m?.accountUnit,
            splitUnit: m?.comboSplitUnit,
            splitScale: m?.comboSplitScale,
            splitTag: m?.comboSplitTag,
            tempType: 2, //是否是使用最新价格
          }
        }),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (handlePrescriptionDrugLimit(res)) {
          return
        }
        const currentSavedMaterials = isTcmRecipeCategory(recipeCategory)
          ? res
          : getCurrentComboSavedMaterials(res, submitMaterials)
        saveRecipeMaterialsData = currentSavedMaterials
        if (recipeCategory === RecipeCategory.Tcm) {
          const couldReplaceStockList = res?.map((v: any) => v?.couldReplaceStockList)?.flat(1)
          if (couldReplaceStockList?.length) {
            setDataList(res)
            setShowFlag(true)
            setCouldReplaceStockListModalVisible(true)
          } else {
            getTips(recipeId)
          }
        } else {
          getTips(recipeId)
        }
      })
      .finally(() => {
        setIsMealModalVisible(false)
        setkcBtnLoading(false)
        setBtnLoading(false)
        setmlBtnLoading(false)
        setIsTreatmentPartsModalVisible(false)
        setCurrentGroupIndex(0)
      })
  }

  useEffect(() => {
    if (pendingSetMealPriceType === undefined) {
      return
    }

    // 自动选择唯一价格时，等待套餐明细、套餐 ID 等状态提交后再保存，
    // 避免首次添加读取到上一次的状态，导致未发起保存请求。
    const priceType = pendingSetMealPriceType
    setPendingSetMealPriceType(undefined)
    if (priceType === 1) {
      getCopyMLSubmit()
    } else if (priceType === 2) {
      getCopyTCSubmit()
    } else if (priceType === 3) {
      getCopyKCSubmit()
    }
  }, [pendingSetMealPriceType])

  useEffect(() => {
    if (!isCopyMealModalVisible) {
      setSelectData('')
      setNoBodyFlag(false)
    }
  }, [isCopyMealModalVisible])

  useEffect(() => {
    if (isTreatmentPartsModalVisible) {
      if (selectData?.treatmentParts)
        form.setFieldsValue({
          treatmentParts: selectData?.treatmentParts
            ? selectData?.treatmentParts?.split(',')
            : [],
        })
    }
  }, [isTreatmentPartsModalVisible])

 const filter = (
    <Row>
      <GlobalKeyboardAction
        ref={actionRef}
        manually
        onEscPress={() => setIsFilterVisible(false)}
      />
      <Col
        style={{
          padding: '10px 20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
        }}
      >
        <Form.Item label='是否指定批次'>
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={tcmUseSpecifiedBatch}
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              const [k1, k2] =
                [
                  Settings.Recipe.TcmUseSpecifiedBatch,
                  Settings.Recipe.TcmIgnoreStorage,
                ]

              dispatch(
                setSettings({
                  [k1]: v,
                })
              )
              if (v) {
                dispatch(
                  setSettings({
                    [k2]: false,
                  })
                )
              }
            }}
            style={{
              backgroundColor: tcmUseSpecifiedBatch ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
        <Form.Item label='是否忽略库存'>
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={tcmIgnoreStorage}
           onClick={(_, e) => e.stopPropagation()}
           onChange={(v) => {
             const [k1, k2] =
               [
                 Settings.Recipe.TcmUseSpecifiedBatch,
                 Settings.Recipe.TcmIgnoreStorage,
               ]
             dispatch(
               setSettings({
                 [k2]: v,
               })
              )
              if (v) {
                dispatch(
                  setSettings({
                    [k1]: false,
                  })
                )
              }
            }}
            style={{
              backgroundColor: tcmIgnoreStorage ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
        <Button
          type='primary'
          onClick={() => {
            setIsFilterVisible(false)
          }}
        >
          关闭(Esc)
        </Button>
      </Col >
    </Row >
  )

// 表单布局配置
const formItemLayout = {
  labelCol: { xs: { span: 24 }, sm: { span: 6 } },
  wrapperCol: { xs: { span: 24 }, sm: { span: 18 } },
};

  const setTFFilesData = (m: any) => {
    setSelectMessage(m)
  }

 const setRefFocus = ( ref: any) => {
    // ✅ 正确跳当前克数
    setTimeout(() => {
      ref?.focus();
      ref?.select();
    }, 10);
  }

  const submitML = (params: any) => {
    setmlBtnLoading(true)
    setcfBtnLoading(true)
    setkcBtnLoading(true)
    createIfNotExist((_, recipeId) => {
      dispatch(
        copyRecipe({
          ...params,
          copyAmountType: 0,
          destRecipeId: recipeId,
        })
        )
        .then(unwrapResult)
        .then((res: any) => {
          saveRecipeMaterialsData = res
          if (recipeCategory === RecipeCategory.Tcm) {
            const couldReplaceStockList = res
              ?.map((v: any) => v?.couldReplaceStockList)
              ?.flat(1)
            if (couldReplaceStockList?.length) {
              setDataList(res)
              setShowFlag(false)
              setCouldReplaceStockListModalVisible(true)
            } else {
              getTips(recipeId, params?.srcRecipeId)
            }
          } else {
            getTips(recipeId, params?.srcRecipeId)
          }

          //开方过量提醒
          if (res && res?.length > 0) {
            const reminders = res?.map((v: any) => v?.overdoseReminder || "");
            const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
            if (hasNonEmpty) {
              const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
              overReminder(reminder)
            }
          }

        })
        .finally(() => {
          setIsCopyReciptModalVisible(false)
          setmlBtnLoading(false)
          setcfBtnLoading(false)
          setkcBtnLoading(false)
        })
    })
  }

  const submitCF = (params: any) => {
    setmlBtnLoading(true)
    setcfBtnLoading(true)
    setkcBtnLoading(true)
    createIfNotExist((_, recipeId) => {
      dispatch(
        copyRecipe({
          ...params,
          copyAmountType: 1,
          destRecipeId: recipeId,
        })
        )
        .then(unwrapResult)
        .then((res: any) => {
          saveRecipeMaterialsData = res
          if (recipeCategory === RecipeCategory.Tcm) {
            const couldReplaceStockList = res
              ?.map((v: any) => v?.couldReplaceStockList)
              ?.flat(1)
            if (couldReplaceStockList?.length) {
              setDataList(res)
              setShowFlag(false)
              setCouldReplaceStockListModalVisible(true)
            } else {
              getTips(recipeId, params?.srcRecipeId)
            }
          } else {
            getTips(recipeId, params?.srcRecipeId)
          }

          //开方过量提醒
          if (res && res?.length > 0) {
            const reminders = res?.map((v: any) => v?.overdoseReminder || "");
            const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
            if (hasNonEmpty) {
              const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
              overReminder(reminder)
            }
          }

        })
        .finally(() => {
          setIsCopyReciptModalVisible(false)
          setmlBtnLoading(false)
          setcfBtnLoading(false)
          setkcBtnLoading(false)
        })
    })
  }

  const submitKC = (params: any) => {
    if (kskdTag || ydkdFlag) {
      setmlBtnLoading(true)
      setcfBtnLoading(true)
      setkcBtnLoading(true)
      createIfNotExist((_, recipeId) => {
        dispatch(
          copyRecipe({
            ...params,
            copyAmountType: 2,
            destRecipeId: recipeId,
          })
        )
          .then(unwrapResult)
          .then((res: any) => {
            saveRecipeMaterialsData = res
            if (recipeCategory === RecipeCategory.Tcm) {
              const couldReplaceStockList = res
                ?.map((v: any) => v?.couldReplaceStockList)
                ?.flat(1)
              if (couldReplaceStockList?.length) {
                setDataList(res)
                setShowFlag(false)
                setCouldReplaceStockListModalVisible(true)
              } else {
                getTips(recipeId, params?.srcRecipeId)
              }
            } else {
              getTips(recipeId, params?.srcRecipeId)
            }

            //开方过量提醒
            if (res && res?.length > 0) {
              const reminders = res?.map((v: any) => v?.overdoseReminder || "");
              const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
              if (hasNonEmpty) {
                const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
                overReminder(reminder)
              }
            }
          })
          .finally(() => {
            setIsCopyReciptModalVisible(false)
            setmlBtnLoading(false)
            setcfBtnLoading(false)
            setkcBtnLoading(false)
          })
      })
    } else {
      setmlBtnLoading(true)
      setcfBtnLoading(true)
      setkcBtnLoading(true)
      dispatch(
        copyRecipe({
          ...params,
          copyAmountType: 2,
          destRecipeId: recipeId,
        })
      )
        .then(unwrapResult)
        .then((res: any) => {
          saveRecipeMaterialsData = res
          if (recipeCategory === RecipeCategory.Tcm) {
            const couldReplaceStockList = res
              ?.map((v: any) => v?.couldReplaceStockList)
              ?.flat(1)
            if (couldReplaceStockList?.length) {
              setDataList(res)
              setShowFlag(false)
              setCouldReplaceStockListModalVisible(true)
            } else {
              getTips(recipeId, params?.srcRecipeId)
            }
          } else {
            getTips(recipeId, params?.srcRecipeId)
          }

          //开方过量提醒
          if (res && res?.length > 0) {
            const reminders = res?.map((v: any) => v?.overdoseReminder || "");
            const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
            if (hasNonEmpty) {
              const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
              overReminder(reminder)
            }
          }

        })
        .finally(() => {
          setIsCopyReciptModalVisible(false)
          setmlBtnLoading(false)
          setcfBtnLoading(false)
          setkcBtnLoading(false)
        })
    }
  }

  return (
    <>
      {contextHolder}
      <Col style={style} className={ZYHGcategory == 3 ? styles.recipeHGZS : kskdTag || ydkdFlag ? styles.containers : styles.container} >
        {recipeCategory == 15 ? <>
          <Spin spinning={pageLoading}>
            <div
              className={styles.TFcontainer}>
              <Row
                className={styles.ZYTFFRow}>
                <Col span={8} className={styles.ZYTFFColLeft}>
                  <span style={{ marginRight: '16px', fontWeight: 'bold' }}>{getRecipeCategoryName(recipeCategory)}</span>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Dropdown
                      trigger={['click']}
                      overlay={filter}
                      visible={isFilterVisible}
                      onVisibleChange={(v) => {
                        setIsFilterVisible(v)
                      }}
                    >
                      <SettingOutlined
                        style={{
                          fontSize: '20px',
                          color: '#999999',
                        }}
                        onClick={() => setIsFilterVisible(!isFilterVisible)}
                      />
                    </Dropdown>
                  </div>
                </Col>
                <Col span={16} className={styles.ZYTFFColRight}>
                  <Button
                    type='primary'
                    size='middle'
                    style={{ marginRight: '10px' }}
                    disabled={disabled || RecipeStatus === 3 || RecipeStatus === 5}
                    onClick={() => {
                      if (location.pathname == '/treatment') {
                        if (recipe) {
                          setIsCopyModalVisible(true)
                          SetComparisonType(2)
                        } else {
                          notification.warning({ message: '请先添加一个空处方' })
                        }
                      } else {
                        setIsCopyModalVisible(true)
                        SetComparisonType(2)
                      }
                    }}
                  >复制处方</Button>
                  <Button
                    type='primary'
                    size='middle'
                    style={{ marginRight: '10px' }}
                    onClick={() => {
                      setPrintTemplateCategory(PrintTemplateCategory.Zcy)
                    }}
                  >处方单打印</Button>
                  <Dropdown
                    overlay={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          width: '153px',
                          height: '138px',
                          backgroundColor: '#fff',
                          paddingTop: 19,
                          boxShadow: '0px 2px 6px 0px rgba(0,0,0,0.17)',
                        }}
                      >
                        <Button
                          style={{ width: '130px' }}
                          type='primary'
                          onClick={() => {
                            setIsPrintSettingModalVisible(true)
                          }}
                        >
                          打印设置
                        </Button>
                        <Button
                          style={{ margin: '15px 0 8px 0' }}
                          type='primary'
                          onClick={() => {
                            window.open(
                              window.location.origin + '/printSettingAll',
                              '_blank'
                            )
                          }}
                        >
                          自定义打印模板
                        </Button>
                        <span style={{ color: '#666', fontSize: 12 }}>
                          按机构需求个性化配置
                        </span>
                      </div>
                    }
                    trigger={['click']}
                  >
                    <Button type='primary' size='middle'>
                      打印设置
                    </Button>
                  </Dropdown>
                </Col>
              </Row>
              <div style={{ marginTop: '6px',overflowY: 'auto', overflowX: 'hidden',flex:1 }}>
                <Form
                  form={ZYFTFform}
                  layout="horizontal"
                  {...formItemLayout}
                >
                  {TFRecipeList?.map((field: any, index: number) => {
                    return (
                      <div key={field.id} style={{ marginBottom: '20px', padding: '4px', }}>
                        <Row className={styles.ZYTFFRowContent}>
                          <Col span={12}>
                            <span style={{ fontWeight: 'bold', fontSize: '17px' }}>
                              第 {index + 1} 组
                            </span>
                          </Col>
                          <Col span={12} className={styles.ZYTFFColRight}>
                            <Button type="link" onClick={() => {
                              const params = {
                                groupTip: 1,
                                id: '',
                                groupUsemethod: '',
                                recipeId: recipeId,
                                treatmentId: treatmentId,
                              }
                              createOrUpdateGroup(params,TFRecipeList?.length )
                            }} style={{ marginRight: '6px' }}>
                              加一组
                            </Button>
                            <Button danger type="text" size="small" onClick={() => {
                              const params = {
                                groupTip: field?.groupTip,
                                id: field?.id,
                                groupUsemethod: field?.groupUsemethod,
                                recipeId: recipeId,
                                treatmentId: treatmentId,
                              }
                              deleteGroup(params)
                              setCurrentGroupIndex(0)
                            }}>
                              删除
                            </Button>
                          </Col>
                        </Row>
                        <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                          {field?.groupItemList?.map((item: any, itemIndex: number) => {
                            // 唯一标识当前项
                            const itemKey = `${index}-${itemIndex}`;
                            const isHover = hoverItemKey === itemKey;
                            let indicator = 'transparent'
                            const expiredInDays = item.deadline
                              ? moment.duration(moment(item.deadline).diff(moment())).asDays()
                              : 9999
                            if (item.inventoryInfo || item.unShelveInfo || expiredInDays <= 90) {
                              indicator = theme.e
                            } else if (item?.anaesthesiaTag == 1 || item?.drugCategory == '毒性药品') {
                              indicator = '#FF20CE'
                            }
                            return (
                              <div
                                key={itemIndex}
                                style={{
                                  margin: '8px 0',
                                  position: 'relative', // 必须
                                  borderRadius: 4,
                                  transition: 'all 0.2s ease',
                                  width: '256px'
                                }}
                                onMouseEnter={() => setHoverItemKey(itemKey)}
                                onMouseLeave={() => setHoverItemKey(null)}
                              >
                                {isHover && (
                                  <div
                                    className={styles.deleteIcon}
                                  >
                                    <CloseOutlined style={{ fontSize: '12px' }}
                                      onClick={() => {
                                        Modal.confirm({
                                          centered: true,
                                          title: '确认操作',
                                          content: (
                                            <div>
                                              <ExclamationCircleFilled
                                                style={{ color: '#FFAE55', fontSize: 18 }}
                                              />
                                              &nbsp;是否确认删除？
                                            </div>
                                          ),
                                          okText: '确认',
                                          cancelText: '取消',
                                          icon: null,
                                          onOk: () => {
                                            dispatch(setPageLoading(true))
                                            dispatch(removeMaterials({ ids: [item?.id], syncFirstItemFUD: syncFirstItemFUD}))
                                              .then(unwrapResult)
                                              .then(() => {
                                                notification.success({
                                                  message: '操作成功',
                                                })
                                              })
                                              .finally(() => {
                                                dispatch(setPageLoading(false))
                                              })
                                          },
                                        })
                                      }} />
                                  </div>
                                )}
                                <Row style={{ width: '216px', position: 'relative' }}>
                                  <Row style={{ width: '100%' }}>
                                    <Form.Item
                                      className={styles.nameItem}
                                      name={"recipeItem_name_" + index + "_" + itemIndex}
                                      rules={[{ required: true, message: '请选择药品' }]}
                                    >
                                      <RecipeItemInput
                                        placeholder="请选择药品"
                                        searfhTcFlag={false}
                                        selectTag={selectTag}
                                        filters={false}
                                        isRestrictUser={1}
                                        wbTag={wbTag}
                                        potionType={potionType}
                                        insuranceCode={insuranceCode}
                                        ref={(el) => {
                                          // ✅ 用 index + itemIndex 绝对稳定，不跳错
                                          refMedical.current[`${index}-${itemIndex}`] = el;
                                        }}
                                        patientPhone={patientObj?.phone}
                                        isShowPageChange={true}
                                        disabled={true}
                                        type={completionType}
                                        category={RecipeCategory.TcmApply}
                                        useSpecifiedBatch={isTcmRecipeCategory(RecipeCategory.TcmApply) ? tcmUseSpecifiedBatch : useSpecifiedBatch}
                                        ignoreStorage={isTcmRecipeCategory(RecipeCategory.TcmApply) ? tcmIgnoreStorage : ignoreStorage}
                                        includeAllTcm={mode === RecipeEditorMode.Retail}
                                        onSelect={(m: any) => {
                                          const key = "recipeItem_name_" + index + "_" + itemIndex;
                                          const unitKey = "recipeItem_unit_" + index + "_" + itemIndex;
                                          ZYFTFform.setFieldsValue({
                                            [key]: m.name || '',
                                            [unitKey]: m.splitTag == 1 ? m?.splitUnit || 'g' : m?.accountUnit || 'g',
                                          });
                                          setTFFilesData(m)
                                          const nameValue = ZYFTFform.getFieldsValue([key])
                                          if (!nameValue?.[key]) {
                                            return
                                          }
                                          const ref = refNumber.current[`${index}-${itemIndex}`]
                                          setRefFocus(ref)
                                        }}
                                        // onBlur={() => {
                                        //   const key = "recipeItem_name_" + index + "_" + itemIndex;
                                        //   const nameValue = ZYFTFform.getFieldsValue([key])
                                        //   if (!nameValue?.[key]) {
                                        //     return
                                        //   }
                                        //   const ref = refNumber.current[`${index}-${itemIndex}`]
                                        //   setRefFocus(ref)
                                        // }}
                                        // ✅ 回车正确跳当前克数
                                        onPressEnter={() => {
                                          const key = "recipeItem_name_" + index + "_" + itemIndex;
                                          const nameValue = ZYFTFform.getFieldsValue([key])
                                          if (!nameValue?.[key]) {
                                            return
                                          }
                                          const ref = refNumber.current[`${index}-${itemIndex}`]
                                          setRefFocus(ref)
                                        }}
                                      />
                                    </Form.Item>
                                    {/* ========== 克数 ========== */}
                                    <Form.Item
                                      className={styles.numberItem}
                                      name={"recipeItem_dose_" + index + "_" + itemIndex}
                                      required
                                      rules={[
                                        { required: true, message: '请输入克数' },
                                        { pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/), message: '请输入数字' }
                                      ]}
                                    >
                                      <Input
                                        placeholder="克数"
                                        ref={(el) => {
                                          refNumber.current[`${index}-${itemIndex}`] = el;
                                        }}
                                        onFocus={() => {
                                          const ref = refNumber.current[`${index}-${itemIndex}`]
                                          setRefFocus(ref)
                                        }}
                                        onBlur={(() => {
                                          const dosekKey = "recipeItem_dose_" + index + "_" + itemIndex
                                          const tipref = `${index}-${itemIndex}`
                                          const nameKey = "recipeItem_name_" + index + "_" + itemIndex;
                                          saveGroup(dosekKey, tipref, nameKey, field, item)
                                          setCurrentGroupIndex(index)
                                        })}
                                        onPressEnter={(e) => {
                                          const dosekKey = "recipeItem_dose_" + index + "_" + itemIndex
                                          const tipref = `${index}-${itemIndex}`
                                          const nameKey = "recipeItem_name_" + index + "_" + itemIndex;
                                          saveGroup(dosekKey, tipref, nameKey, field, item)
                                          setCurrentGroupIndex(index)
                                        }}
                                      />
                                    </Form.Item>
                                    <Form.Item className={styles.unitItem}>
                                      <div className={styles.unitItems}>{(item.splitTag == 1 ? item?.splitUnit : item?.accountUnit) || 'g'}</div>
                                    </Form.Item>
                                  </Row>
                                  {indicator !== 'transparent' &&
                                    <span style={{ color: indicator }} className={styles.tips}>
                                      {item.inventoryInfo || expiredInDays <= 90 || item.unShelveInfo ?
                                        item.inventoryInfo +
                                        (expiredInDays <= 90
                                          ? (expiredInDays <= 90 ?
                                            expiredInDays < 0 ? (`已过期`) : (expiredInDaysEyeFlag == '1' ? `有效期:${Math.floor(expiredInDays)}天 ` : '') : '')
                                          : '') +
                                        item.unShelveInfo
                                        : ''}
                                    </span>
                                  }
                                </Row>
                              </div>
                            )
                          })}
                          <Col span={6} style={{ margin: '8px 0' }}>
                            <Row>
                              {/* ========== 药品名称 ========== */}
                              <Form.Item
                                className={styles.nameItem}
                                name={"recipeItem_name_" + index + "_" + field?.groupItemList?.length + 1}
                                rules={[{ required: true, message: '请选择药品' }]}
                              >
                                <RecipeItemInput
                                  placeholder="请选择药品"
                                  searfhTcFlag={false}
                                  selectTag={selectTag}
                                  filters={false}
                                  isRestrictUser={1}
                                  wbTag={wbTag}
                                  potionType={potionType}
                                  autoFocus={index == currentGroupIndex ? true : false}
                                  insuranceCode={insuranceCode}
                                  ref={(el) => {
                                    refMedical.current[`${index}-${field?.groupItemList?.length + 1}`] = el;
                                  }}
                                  patientPhone={patientObj?.phone}
                                  isShowPageChange={true}
                                  disabled={disabled}
                                  type={ItemCompletionType.Auto}
                                  category={RecipeCategory.TcmApply}
                                  useSpecifiedBatch={isTcmRecipeCategory(RecipeCategory.TcmApply) ? tcmUseSpecifiedBatch : useSpecifiedBatch}
                                  ignoreStorage={isTcmRecipeCategory(RecipeCategory.TcmApply) ? tcmIgnoreStorage : ignoreStorage}
                                  includeAllTcm={mode === RecipeEditorMode.Retail}
                                  onSelect={(m: any) => {
                                    const key = "recipeItem_name_" + index + "_" + field?.groupItemList?.length + 1;
                                    const unitKey = "recipeItem_unit_" + index + "_" + field?.groupItemList?.length + 1;
                                    ZYFTFform.setFieldsValue({
                                      [key]: m.name || '',
                                      [unitKey]:( m.splitTag == 1 ? m?.splitUnit : m?.accountUnit || 'g') || 'g' 
                                    });
                                    setTFFilesData(m)
                                    const nameValue = ZYFTFform.getFieldsValue([key])
                                    if (!nameValue?.[key]) {
                                      return
                                    }
                                    const ref = refNumber.current[`${index}-${field?.groupItemList?.length + 1}`]
                                    setRefFocus(ref)
                                  }}
                                  // onBlur={(e) => {
                                  //   const key = "recipeItem_name_" + index + "_" + field?.groupItemList?.length + 1;
                                  //   const nameValue = ZYFTFform.getFieldsValue([key])
                                  //   if (!nameValue?.[key]) {
                                  //     return
                                  //   }
                                  //   const ref = refNumber.current[`${index}-${field?.groupItemList?.length + 1}`]
                                  //   setRefFocus(ref)
                                  // }}
                                  onPressEnter={(e) => {
                                    const nameKey = "recipeItem_name_" + index + "_" + field?.groupItemList?.length + 1;
                                    const nameValue = ZYFTFform.getFieldsValue([nameKey])
                                    if (!nameValue?.[nameKey]) {
                                      return
                                    }
                                    const ref = refNumber.current[`${index}-${field?.groupItemList?.length + 1}`]
                                    setRefFocus(ref)
                                  }}
                                />
                              </Form.Item>
                              {/* ========== 克数 ========== */}
                              <Form.Item
                                className={styles.numberItem}
                                name={"recipeItem_dose_" + index + "_" + field?.groupItemList?.length + 1}
                                required
                                // ✅ 关键修复 1：给克数校验加上 validateTrigger
                                validateTrigger={['onChange', 'onBlur']}
                                rules={[
                                  { required: true, message: '请输入克数' },
                                  { pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/), message: '请输入数字' }
                                ]}
                              >
                                <Input
                                  placeholder="克数"
                                  ref={(el) => {
                                    refNumber.current[`${index}-${field?.groupItemList?.length + 1}`] = el;
                                  }}
                                  // ✅ 只受自己药品控制
                                  disabled={!selectMessage?.name}
                                  onBlur={((e) => {
                                    setActionFlag(2)
                                    if (actionFlag != 1) {
                                      const key = "recipeItem_dose_" + index + "_" + field?.groupItemList?.length + 1
                                      const tipref = `${index}-${field?.groupItemList?.length + 1}`
                                      const nameKey = "recipeItem_name_" + index + "_" + field?.groupItemList?.length + 1;
                                      saveGroup(key, tipref, nameKey, field)
                                      setCurrentGroupIndex(index)
                                    } 
                                  })}
                                  onPressEnter={(e) => {
                                    setActionFlag(1)
                                    if(pageLoading){
                                      return
                                    }
                                    const dosekKey = "recipeItem_dose_" + index + "_" + field?.groupItemList?.length + 1
                                    const tipref = `${index}-${field?.groupItemList?.length + 1}`
                                    const nameKey = "recipeItem_name_" + index + "_" + field?.groupItemList?.length + 1;
                                    saveGroup(dosekKey, tipref, nameKey, field)
                                    setCurrentGroupIndex(index)
                                  }}
                                />
                              </Form.Item>
                               <Form.Item
                                className={styles.unitItem}
                                name={"recipeItem_unit_" + index + "_" + field?.groupItemList?.length + 1}>
                                <Input defaultValue="g" disabled />
                              </Form.Item>
                            </Row>
                          </Col>
                        </div>

                        {/* ========== 帖数 + 用法 ========== */}
                        <Row
                          align="middle"
                          className={styles.tip}
                          style={{
                            color: theme.tc2,
                            fontSize: '0.875rem',
                            paddingBottom: discountFlag ? 0 : '10px',
                            position: 'relative',
                            top: '10px',
                            minWidth: kskdTag || ydkdFlag ? 1100 : 1250,
                          }}
                        >
                          帖数：
                          <Button
                            icon={<MinusOutlined />}
                            onClick={() => {
                              const v = field?.groupTip - 1
                              if (v > 0) {
                                const params = {
                                  groupTip: v,
                                  id: field?.id,
                                  groupUsemethod: field?.groupUsemethod,
                                  recipeId: recipeId,
                                  treatmentId: treatmentId,
                                }
                                createOrUpdateGroup(params,index)
                              }
                            }}
                          />
                          <InputNumber
                            style={{
                              width: '3.5rem',
                              color: theme.tc2,
                              fontSize: '1rem',
                              fontWeight: 'bold',
                              textAlign: 'center',
                            }}
                            value={field?.groupTip}
                            onChange={(v) => {
                              if (v) {
                                const params = {
                                  groupTip: v,
                                  id: field?.id,
                                  groupUsemethod: field?.groupUsemethod,
                                  recipeId: recipeId,
                                  treatmentId: treatmentId,
                                }
                                createOrUpdateGroup(params,index)
                              } else {
                                createIfNotExist(
                                  (treatmentId, recipeId) => {
                                    return
                                  },
                                  true,
                                  v
                                )
                              }
                            }}
                            min={1}
                            max={9999}
                            bordered={false}
                          />
                          <Button
                            icon={<PlusOutlined />}
                            onClick={() => {
                              const v = field?.groupTip + 1
                              const params = {
                                groupTip: v,
                                id: field?.id,
                                groupUsemethod: field?.groupUsemethod,
                                recipeId: recipeId,
                                treatmentId: treatmentId,
                              }
                              createOrUpdateGroup(params,index)
                            }}
                            style={{ marginRight: 10 }}
                          />
                          用法：
                          <Button
                            style={{
                              flex: 1,
                              color: theme.tc2,
                              width: '500px',
                              textAlign: 'left',
                              overflow: 'hidden',
                              maxWidth: '500px',
                              // textOverflow: 'ellipsis',
                            }}
                            icon={<SearchOutlined color={theme.c3} />}
                            onClick={() => {
                              const params = {
                                groupTip: field?.groupTip,
                                groupUsemethod: field?.groupUsemethod,
                                id: field?.id,
                                recipeId: recipeId,
                                treatmentId: treatmentId,
                              }
                              setCurrentGroupIndex(index)
                              setUseMethodSubmitData(params)
                              setIsTFMethodVisible(true)
                            }}
                          >
                            <span
                              style={{
                                width: '500px',
                              }}
                            >
                              {field?.groupUsemethod || ''}
                            </span>
                          </Button>
                        </Row>
                      </div>
                    );
                  })}
                </Form>
              </div>
            </div>
          </Spin>
        </>
          : <>
            <div
              style={{
                minWidth: kskdTag || ydkdFlag
                  ? recipeCategory === RecipeCategory.Medicine
                    ? 1400
                    : 1100
                  : 1250,
            }}
          >
            <RecipeItemEditor
              isMember={isMember}
              selectTag={selectTag} //光标选中
              getCompletionType={(v) => {
                setCompletionType(v)
              }}
              quickAddProjectLoading={quickAddProjectLoading}
              tipCount={tipCount}
              discountFlag={discountFlag}
              potionType={potionType}
              treatmentInsuranceCode={treatment?.insuranceCode}
              insuranceCode={insuranceCode}
              data={data}
              treatmentId={treatmentId}
              recipeId={recipeId}
              patientPhone={patientObj?.phone}
              category={recipeCategory}
              onChange={(m, ignoreStorage) => {
                add(m, ignoreStorage)
              }}
              quickAddProject={() => {
                setQuickAddProjectLoading(true)
                createIfNotExist((treatmentId, recipeId) => {
                  dispatch(setBatchAddVisibel(true))
                  setQuickAddProjectLoading(false)
                })
              }}
              addTC={(ms: any,
                comboId: any,
                category: any,
                flag: any,
                s: any) => {
                setComboId(comboId)
                const maxGroupNumber = materials.reduce(
                  (g, m) => Math.max(g, m.groupNumber),
                  0
                )
                setIsSetMealModalVisible(false)
                setCopyMealParams(ms)
                setSelectData(s)
                setNoBodyFlag(flag)
                setIsMealModalVisible(true)
                setCategory(category)
              }}
              includeAllTcm={mode === RecipeEditorMode.Retail}
              disabled={disabled}
              kskdTag={kskdTag}
              ydkdFlag={ydkdFlag}
            />
          </div>
          <Row
          className={styles.bar}
          align='middle'
          style={{
            minWidth: kskdTag || ydkdFlag
              ? recipeCategory === RecipeCategory.Medicine
                ? 1380
                : 1100
              : 1250,
            height: '42px',
            position: hisVersion == 1 ? ('relative' as any) : '',
            top: hisVersion == 1 ? ('36px' as any) : '',
          }}
        >
          {/* <Col
            span={24}
            style={{
              width: hisVersion == 1 && ('800px' as any),
              position: hisVersion == 1 ? ('fixed' as any) : '',
              top: hisVersion == 1 ? ('19.9%' as any) : '',
            }}
          > */}
          <Col
            span={(kskdTag || ydkdFlag) && recipeCategory === RecipeCategory.Tcm ? 18 : 22}
          >
            <Button
              danger
              type='primary'
              className={styles.button}
              disabled={selectedKeys.length === 0 || disabled}
              onClick={() => {
                if (recipe) {
                  dispatch(removeMaterials({ ids: selectedKeys, syncFirstItemFUD: syncFirstItemFUD}))
                    .then(unwrapResult)
                    .then(() => {
                      if (selectedKeys.includes(replaceMakeId) && isSetting) {
                        // 选中项包含代煎，则需要强制删除代煎列
                        dispatch(
                          isdeleteReplaceMakeSetting({
                            status: 1,
                            id: setID,
                          })
                        )
                          .then(unwrapResult)
                          .then(() => {
                            replaceMakeInfo()
                          })
                      }

                      if (location.pathname !== '/retail' || isInsurance) {
                        setUpdateFlags('1', '1')
                      }
                    })
                  setSelectedKeys([])
                }
                // Modal.confirm({
                //   title: '确定删除选中的项目',
                //   okText: '确定',
                //   cancelText: '取消',
                //   onOk: () => {
                //     if (recipe) {
                //       dispatch(removeMaterials(selectedKeys))
                //         .then(unwrapResult)
                //         .then(() => {
                //           if (
                //             selectedKeys.includes(replaceMakeId) &&
                //             isSetting
                //           ) {
                //             // 选中项包含代煎，则需要强制删除代煎列
                //             dispatch(
                //               isdeleteReplaceMakeSetting({
                //                 status: 1,
                //                 id: setID,
                //               })
                //             )
                //               .then(unwrapResult)
                //               .then(() => {
                //                 replaceMakeInfo()
                //               }
                //           }

                //           if (location.pathname !== '/retail' || isInsurance) {
                //             setUpdateFlags('1', '1')
                //           }
                //         })
                //       setSelectedKeys([])
                //     }
                //   },
                // })
              }}
            >
              删除选中行
            </Button>
            {treatment &&
              treatment?.insuranceCode &&
              treatment?.insuranceCode != 'ZIFEI' &&
              !isSettledFlag && (
                <>
                  <Dropdown
                    disabled={selectedKeys.length === 0 || disabled}
                    className={styles.button}
                    overlay={changeItemsPayType}
                    trigger={['click']}
                  >
                    <Button
                      type='primary'
                      className={styles.button}
                      loading={updateItemTypeBatchReadLoading}
                      disabled={updateItemTypeBatchReadLoading}
                    >
                      变更收费类型
                    </Button>
                  </Dropdown>
                </>
              )}
            {!isTcmRecipeCategory(recipeCategory) &&
              recipeCategory != RecipeCategory.Dispose && (
                <>
                  <Button
                    className={styles.button}
                    type='primary'
                    disabled={!merge(true) || disabled}
                    onClick={() => merge(false)}
                  >
                    合并分组
                  </Button>
                  <Button
                    type='primary'
                    className={styles.button}
                    disabled={!split(true) || disabled}
                    onClick={() => split(false)}
                  >
                    拆开分组
                  </Button>
                </>
              )}
            {treatment &&
              treatment?.insuranceCode &&
              treatment?.insuranceCode != 'ZIFEI' &&
              !isSettledFlag &&
              !yzcfTag && (
                <Button
                  type='primary'
                  className={styles.button}
                  onClick={() => {
                    Modal.confirm({
                      title: '',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{ color: '#FFAE55', fontSize: 18 }}
                          />
                          &nbsp;
                          医保转自费后，该患者本次就诊的所有费用的收费类型都将改成自费结算，请确认此操作!
                          <div>
                            如只需调整某一个药品或处方单的收费类型,请去单独修改药品的收费类型。
                          </div>
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(
                          getInsuranceToSelfpay({
                            registrationId: registrationId,
                            treatmentId: treatmentId,
                            patientName: patientName,
                          })
                        )
                          .then(unwrapResult)
                          .then((v) => {
                            notification.success({
                              message: '操作成功',
                            })
                            refresh && refresh()
                          })
                      },
                    })
                  }}
                >
                  医保转自费
                </Button>
              )}
            <Button
              type='primary'
              disabled={disabled || RecipeStatus === 3 || RecipeStatus === 5}
              className={styles.button}
              onClick={() => {
                if (location.pathname == '/treatment') {
                  if (recipe) {
                    setIsSetMealModalVisible(true)
                    SetComparisonType(1)
                  } else {
                    notification.warning({ message: '请先添加一个空处方' })
                  }
                } else {
                  setIsSetMealModalVisible(true)
                  SetComparisonType(1)
                }

              }}
            >
              添加套餐
            </Button>
            {mode !== RecipeEditorMode.Extra && (
              <Button
                type='primary'
                className={styles.button}
                disabled={disabled || RecipeStatus === 3 || RecipeStatus === 5}
                onClick={() => {
                  if (location.pathname == '/treatment') {
                    if (recipe) {
                      setIsCopyModalVisible(true)
                      SetComparisonType(2)
                    } else {
                      notification.warning({ message: '请先添加一个空处方' })
                    }
                  } else {
                    setIsCopyModalVisible(true)
                    SetComparisonType(2)
                  }
                }}
              >
                复制处方
              </Button>
            )}
            {mode !== RecipeEditorMode.Retail && (
              <>
                {recipeCategory !== RecipeCategory.Tcm &&
                  recipeCategory !== RecipeCategory.TcmGranules && (
                    <Button
                      type='primary'
                      className={styles.button}
                      onClick={() => {
                        if (recipeId) {
                          getReciptPrintList()
                        }
                        setPrintTemplateCategory(PrintTemplateCategory.Zxd)
                      }}
                    >
                      执行单打印
                    </Button>
                  )}
                {recipeCategory !== RecipeCategory.Tcm &&
                  recipeCategory !== RecipeCategory.TcmGranules &&
                  xyCustomTemplateFlag != true && (
                    <Dropdown
                      trigger={['click']}
                      overlay={
                        <Row
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 15,
                          }}
                        >
                          <Space direction='vertical' size='large'>
                            <Button
                              data-umami-event='新版处方单(适用打印偏好设置) - 按钮'
                              data-umami-event-tenantName={tenantName}
                              type='primary'
                              onClick={() => {
                                setPrintTemplateCategory(
                                  PrintTemplateCategory.JXJY
                                )
                              }}
                            >
                              新版处方单(适用打印偏好设置)
                            </Button>
                            <Button
                              data-umami-event='有诊疗(每页最多5个药品) - 按钮'
                              data-umami-event-tenantName={tenantName}
                              type='primary'
                              onClick={() =>
                                setPrintTemplateCategory(
                                  PrintTemplateCategory.Xyy
                                )
                              }
                            >
                              有诊疗
                              <span style={{ fontSize: '12px' }}>
                                (每页最多5个药品)
                              </span>
                            </Button>
                            <Button
                              data-umami-event='无诊疗(每页最多5个药品) - 按钮'
                              data-umami-event-tenantName={tenantName}
                              type='primary'
                              onClick={() =>
                                setPrintTemplateCategory(
                                  PrintTemplateCategory.Xyw
                                )
                              }
                            >
                              无诊疗
                              <span style={{ fontSize: '12px' }}>
                                (每页最多5个药品)
                              </span>
                            </Button>
                            <Button
                              data-umami-event='有诊疗(每页最多8个药品) - 按钮'
                              data-umami-event-tenantName={tenantName}
                              type='primary'
                              onClick={() =>
                                setPrintTemplateCategory(
                                  PrintTemplateCategory.Xycfjwzl
                                )
                              }
                            >
                              有诊疗
                              <span style={{ fontSize: '12px' }}>
                                (每页最多8个药品)
                              </span>
                            </Button>
                            <Button
                              data-umami-event='无诊疗(每页最多8个药品) - 按钮'
                              data-umami-event-tenantName={tenantName}
                              type='primary'
                              onClick={() =>
                                setPrintTemplateCategory(
                                  PrintTemplateCategory.Xycfjyzl
                                )
                              }
                            >
                              无诊疗
                              <span style={{ fontSize: '12px' }}>
                                (每页最多8个药品)
                              </span>
                            </Button>
                            <Button
                              type='primary'
                              data-umami-event={'外配处方单 - 按钮'}
                              data-umami-event-tenantName={tenantName}
                              onClick={() => {
                                // if (
                                //   treatment?.insuranceCode != 'ZIFEI'
                                // ) {
                                setPrintTemplateCategory(
                                  PrintTemplateCategory.Ybwpcfd
                                )
                                // } else {
                                //   setPrintTemplateCategory(
                                //     PrintTemplateCategory.Zfwpcfd
                                //   )
                                // }
                              }}
                            >
                              外配处方单
                            </Button>
                            {/* <Button
                              data-umami-event='医保外配处方单 - 按钮'
                              data-umami-event-tenantName={tenantName}
                              type='primary'
                              onClick={() =>
                                setPrintTemplateCategory(
                                  PrintTemplateCategory.Ybwpcfd
                                )
                              }
                            >
                              {getTemplateCategoryName(
                                PrintTemplateCategory.Ybwpcfd
                              )}
                            </Button>
                            <Button
                              data-umami-event='自费外配处方单 - 按钮'
                              data-umami-event-tenantName={tenantName}
                              type='primary'
                              onClick={() =>
                                setPrintTemplateCategory(
                                  PrintTemplateCategory.Zfwpcfd
                                )
                              }
                            >
                              {getTemplateCategoryName(
                                PrintTemplateCategory.Zfwpcfd
                              )}
                            </Button> */}
                          </Space>
                        </Row>
                      }
                    >
                      <Button type='primary' className={styles.button}>
                        处方单打印
                      </Button>
                    </Dropdown>
                  )}
                {recipeCategory !== RecipeCategory.Tcm &&
                  recipeCategory !== RecipeCategory.TcmGranules &&
                  xyCustomTemplateFlag == true && (
                    <Button
                      type='primary'
                      className={styles.button}
                      onClick={() => {
                        setPrintTemplateCategory(PrintTemplateCategory.JXJY)
                      }}
                    >
                      处方单打印
                    </Button>
                  )}
                {recipeCategory === RecipeCategory.Tcm && (
                  <Button
                    type='primary'
                    className={styles.button}
                    onClick={async () => {
                      // 中药方打印前判断双签
                      if (onBeforePrintRecipe) {
                        const canPrint = await onBeforePrintRecipe()
                        if (!canPrint) return
                      }
                      setPrintTemplateCategory(PrintTemplateCategory.Zcy)
                    }}
                  >
                    处方单打印
                  </Button>
                )}
                {recipeCategory === RecipeCategory.TcmGranules && (
                  <Button
                    type='primary'
                    className={styles.button}
                    onClick={() =>
                      setPrintTemplateCategory(PrintTemplateCategory.Klj)
                    }
                  >
                    处方单打印
                  </Button>
                )}
              </>
            )}
            {/* recipeCategory === RecipeCategory.TcmGranules || */}
            {recipeCategory === RecipeCategory.Tcm &&
              ((kskdTag || ydkdFlag) ? (
                <Button
                  style={{ border: '1px solid' }}
                  type={isSetting ? 'primary' : 'link'}
                  className={styles.button}
                  onClick={() => {
                    setIsDecoctingSettingModalVisible(true)
                    // setIsReplaceMakeModalVisible(true)
                  }}
                  disabled={
                    RecipeStatus === 3 ||
                    RecipeStatus == 5 ||
                    disabled ||
                    !name ||
                    !materials?.length
                  }
                >
                  代煎设置
                </Button>
              ) : (
                <Button
                  style={{ border: '1px solid' }}
                  type={isSetting ? 'primary' : 'link'}
                  className={styles.button}
                  onClick={() => {
                    setIsDecoctingSettingModalVisible(true)
                    // setIsReplaceMakeModalVisible(true)
                  }}
                  disabled={disabled}
                >
                  代煎设置
                </Button>
              ))}
            {isDispose && (
              <Space className={styles.disposeBtn}>
                <Badge count={planCount} overflowCount={99}>
                  <Button
                    type='primary'
                    loading={curePlanLoading}
                    disabled={location?.pathname == '/retail' ? disabled || !name : disabled}
                    onClick={() => {
                      setCurePlanLoading(true)
                      createIfNotExist((treatmentId, recipeId) => {
                        dispatch(setCurePlanListVisible(true))
                        setCurePlanLoading(false)
                      })
                    }}
                  >
                    治疗计划
                  </Button>
                </Badge>
              </Space>
            )}
            {/* <Popover placement='rightTop' content={printSet} trigger='click'>
              <Button style={{}} type='primary' className={styles.button}>
                打印设置
              </Button>
            </Popover> */}
            <Dropdown
              overlay={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '153px',
                    height: '138px',
                    backgroundColor: '#fff',
                    paddingTop: 19,
                    boxShadow: '0px 2px 6px 0px rgba(0,0,0,0.17)',
                  }}
                >
                  <Button
                    style={{ width: '130px' }}
                    type='primary'
                    onClick={() => {
                      setIsPrintSettingModalVisible(true)
                    }}
                  >
                    打印设置
                  </Button>
                  <Button
                    style={{ margin: '15px 0 8px 0' }}
                    type='primary'
                    onClick={() => {
                      window.open(
                        window.location.origin + '/printSettingAll',
                        '_blank'
                      )
                    }}
                  >
                    自定义打印模板
                  </Button>
                  <span style={{ color: '#666', fontSize: 12 }}>
                    按机构需求个性化配置
                  </span>
                </div>
              }
              trigger={['click']}
            >
              <Button style={{}} type='primary' className={styles.button}>
                打印设置
              </Button>
            </Dropdown>
            {(recipeCategory != 16) && (
              <Button
                type='primary'
                disabled={!materials?.length}
                className={styles.button}
                onClick={() => {
                  dispatch(setSetmealSelectId(0))
                  setIsModalVisible(true)
                  localStorage?.setItem('editMedicalVisible', 'true')
                }}
              >
                设置为套餐
              </Button>
              )}

            {!(
              recipeCategory === RecipeCategory.TcmGranules ||
              recipeCategory === RecipeCategory.Tcm
            ) &&
              isCoupons &&
              menu?.length ? (
              <Button
                type='primary'
                // disabled={!materials?.length}
                className={styles.button}
                onClick={() => {
                  setCouponsIds([])
                  if (patientObj.patientId) {
                    dispatch(
                      getPatientCouponsList({
                        patientId: patientObj.patientId,
                        useStatus: 1,
                      })
                    )
                      .then(unwrapResult)
                      .then((res: any) => {
                        setCouponsList(res)
                        if (res?.length) {
                          setCouponsVisable(true)
                        } else {
                          notification.info({
                            message: '当前患者无优惠券',
                          })
                        }
                      })
                  } else {
                    notification.info({
                      message: '请选择患者',
                    })
                  }
                }}
              >
                优惠券
              </Button>
            ) : (
              <></>
            )}
            {(recipeCategory == 3 || recipeCategory == 12) && (
              <>
                <Button
                  onClick={(v) => {
                    setOpenYl(true)
                    localStorage.setItem('openYL', 'true')
                  }}
                  type='primary'
                  className={styles.buttons}
                  style={{ position: 'relative' }}
                >
                  预览
                </Button>
                {openYl && (
                  <Draggable>
                    <div className={styles.rpContent}>
                      <div
                        className={styles.rpContentTitle}
                        style={{ position: 'relative' }}
                      >
                        <div style={{ position: 'absolute', left: 10 }}>
                          Rp.
                        </div>
                        <div>
                          {patientName}（帖数：{tipCount}帖
                          {RecipeStatus === 3 && RecipeDate
                            ? '，' + RecipeDate?.split(' ')[0]
                            : ''}
                          ）
                        </div>
                        <CloseOutlined
                          style={{
                            position: 'absolute',
                            right: 10,
                            color: '#8c8c8c',
                            marginRight: '10px',
                            fontSize: '22px',
                          }}
                          onClick={() => {
                            setOpenYl(false)
                            localStorage.setItem('openYL', 'false')
                          }}
                        />
                      </div>
                      <Row className={styles.rpContentMainContent}>
                        {materials?.map((v, index) => {
                          return (
                            <>
                              <Popover
                                content={
                                  <>
                                    <div style={{ cursor: 'pointer' }}>
                                      {index + 1}. {v?.name}
                                      <span>
                                        {/* &nbsp; */}
                                        {v?.normalUsemethod !== '无' &&
                                          v?.normalUsemethod !== '煎服' ? (
                                          <span style={{ fontWeight: 'bold' }}>
                                            /{' '}
                                            <span
                                              style={{
                                                fontWeight: 'normal',
                                                fontSize: '14px',
                                              }}
                                            >
                                              {v?.normalUsemethod}
                                            </span>{' '}
                                          </span>
                                        ) : (
                                          ''
                                        )}{' '}
                                        &nbsp;
                                      </span>
                                      /{v?.countPerTip}{' '}
                                      {v.splitTag ? v.splitUnit : v.accountUnit}
                                    </div>
                                  </>
                                }
                              >
                                <Col span={12}>
                                  <div className={styles.rpContentMain}>
                                    {index + 1}. {v?.name}
                                    <span
                                      className={
                                        styles.rpContentMainNormalWeight
                                      }
                                    >
                                      {/* &nbsp; */}
                                      {v?.normalUsemethod !== '无' &&
                                        v?.normalUsemethod !== '煎服' ? (
                                        <span style={{ fontWeight: 'bold' }}>
                                          /{' '}
                                          <span
                                            style={{
                                              fontWeight: 'normal',
                                              fontSize: '14px',
                                            }}
                                          >
                                            {v?.normalUsemethod}
                                          </span>{' '}
                                        </span>
                                      ) : (
                                        ''
                                      )}{' '}
                                      &nbsp;
                                    </span>
                                    /{v?.countPerTip}{' '}
                                    {v.splitTag ? v.splitUnit : v.accountUnit}
                                  </div>
                                </Col>
                              </Popover>
                            </>
                          )
                        })}
                      </Row>
                    </div>
                  </Draggable>
                )}
              </>
            )}
          </Col>
        </Row>
        {/* {(yzcfTag || kqMoveTag) && materials?.length ? (
          <EditableList
            sticky
            // scroll={{ y: '3rem' }}
            loading={pageLoading}
            dataSource={materials?.map((v) => {
             const discount = v?.discount ? (Number(v?.discount) * 100)?.toFixed(0) : '-'
              return {
                ...v,
                accountUnit: v.splitTag ? v.splitUnit : v.accountUnit,
                discount: discount,
                retailBeforePrice: v.retailPrice && discount
                  ? (Number(v.retailPrice) / Number(discount) * 100)?.toFixed(5)
                  : '0.00000',
              }
            })}
            columns={
              recipeCategory == RecipeCategory.Tcm ||
                recipeCategory == RecipeCategory.TcmGranules
                ? TcmColumn(
                  theme,
                  async (m, values) => {
                    const data: any = { ...m, ...values }
                    if (data?.tbEdit) {
                      !disabled && add(data, false, m.id, true)
                    }
                    if (m.billingCategory == '97') return
                    if (data?.countPerTip == 0) {
                      messageApi.open({
                        type: 'info',
                        content: '数量不可为 0',
                        style: {
                          marginTop: '35vh',
                        },
                      })
                    } else if (!(data?.retailPrice?.toString())) {
                      messageApi.open({
                        type: 'info',
                        content: '单价不可为空',
                        style: {
                          marginTop: '35vh',
                        },
                      })
                    } else {
                      !disabled && add({ ...m, ...values }, false, m.id)
                    }
                  },
                  allowedToChangePrice,
                  (itemPayType, v) => {
                    !disabled &&
                      dispatch(
                        updateItemPayTypeAsync({
                          itemPayType,
                          recipeItemId: v.id,
                        })
                      )
                        .then(unwrapResult)
                        .then((res) => {
                          getRecipeDetailList(recipeId || '')
                          setUpdateFlags('1', '1')
                          // onNewRecipe && onNewRecipe(res)
                        })
                  },
                  recipeCategory,
                  (m) => {
                    if (disabled) return
                    if (m.billingCategory === '97' && isSetting) {
                      return
                    } else {
                      setTargetMaterial(m)
                    }
                  },
                  false,
                  insuranceArray,
                  expiredInDaysEyeFlag,
                  (v: any) => {
                    setExpiredInDaysEyeFlag(v)
                    localStorage.setItem('expiredInDaysEyeFlag', v)
                  }
                )
                : recipeCategory == RecipeCategory.Dispose
                  ? DisposeColumns(
                    theme,
                    materials,
                    async (m, values: any) => {
                      const data = { ...m, ...values }
                      if (data?.tbEdit) {
                        !disabled && add(data, false, m.id, true)
                      }
                      if (data?.drugCount == 0) {
                        messageApi.open({
                          type: 'info',
                          content: '数量不可为 0',
                          style: {
                            marginTop: '35vh',
                          },
                        })
                      } else {
                        !disabled && add(data, false, m.id)
                      }
                    },
                    allowedToChangePrice,
                    (itemPayType, v) => {
                      !disabled &&
                        dispatch(
                          updateItemPayTypeAsync({
                            itemPayType,
                            recipeItemId: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((res) => {
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                          })
                    },
                    false,
                    (t, v, tooth, toothType) => {
                      if (disabled) return

                      if (t == 'toothEdit') {
                        if (toothType == 0) {
                          // 同步
                          const data = {
                            itemTooth: tooth,
                            recipeId: Number(recipeId),
                          }
                          dispatch(syncToothAsync(data))
                            .then(unwrapResult)
                            .then(() => {
                              getRecipeDetailList(recipeId || '')
                              setUpdateFlags('1', '1')
                            })
                        } else if (toothType == 1) {
                          // 保存
                          const data = {
                            itemTooth: tooth,
                            recipeItemId: Number(v.id),
                          }
                          dispatch(saveToothAsync(data))
                            .then(unwrapResult)
                            .then(() => {
                              getRecipeDetailList(recipeId || '')
                              setUpdateFlags('1', '1')
                            })
                        }
                      }
                    },
                    (m) => {
                      if (disabled) return
                      if (m.billingCategory === '97' && isSetting) {
                        return
                      } else {
                        setTargetMaterial(m)
                      }
                    },
                    true,
                    expiredInDaysEyeFlag,
                    (v: any) => {
                      setExpiredInDaysEyeFlag(v)
                      localStorage.setItem('expiredInDaysEyeFlag', v)
                    }
                  )
                : recipeCategory == RecipeCategory.TcmTreat  
                  ? TcmTreatColumn(
                    theme,
                    materials,
                    async (m, values: any) => {
                      const data: any = { ...m, ...values }
                      if (data?.tbEdit) {
                        !disabled && add(data, false, m.id, true)
                      }
                      // 诊疗不触发自动计算
                      if (data?.drugType == 1) {
                        if (data?.drugCount == 0) {
                          messageApi.open({
                            type: 'info',
                            content: '数量不可为 0',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else if (!(data?.retailPrice?.toString())) {
                          messageApi.open({
                            type: 'info',
                            content: '单价不可为空',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else {
                          !disabled && add(data, false, m.id)
                        }
                      } else {
                        if (data?.drugCount == 0) {
                          messageApi.open({
                            type: 'info',
                            content: '数量不可为 0',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else if (!(data?.retailPrice?.toString())) {
                          messageApi.open({
                            type: 'info',
                            content: '单价不可为空',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else {
                          if (autoChangePrice) {
                            // 用量计算比没有填写的时候不进行计算
                            const doseConvert: number =
                              data?.doseConvert && data?.doseConvert > 0
                                ? data?.doseConvert
                                : ''
                            if (!doseConvert) {
                              !disabled && add(data, false, m.id)
                              return
                            }
                            // 修改天数 计算数量
                            if (values?.useDays) {
                              //特殊用法剂量修正
                              const doseFix = (data?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0)) ? true : false;
                              let drugCount;
                              let splitDrugCount;

                              if (doseFix) {
                                //数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
                                drugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Number(values?.useDays)), (Math.ceil(CHU(data?.normalDose, doseConvert)))));
                                splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Math.ceil(data?.normalDose)), Number(values?.useDays)));
                              } else {
                                //数量 = 频次*天数*剂量/转换比 一次取整
                                // drugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0),Number(values?.useDays)),(CHU(data?.normalDose,doseConvert))));
                                // splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0),data?.normalDose),Number(values?.useDays)));
                                drugCount = Math.ceil(CHU(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), data?.normalDose), Number(values?.useDays)), doseConvert))
                                splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), data?.normalDose), Number(values?.useDays)));
                              }
                              const realDrugCount =
                                data?.splitTag == 1 ? splitDrugCount : drugCount

                              const autoDataDrugCount = {
                                ...data,
                                drugCount: realDrugCount || 1,
                              }
                              !disabled && add(autoDataDrugCount, false, m.id)
                            } else if (values?.drugCount) {
                              // 修改数量 计算天数
                              if (data?.frequencyCalc !== 0) {
                                //特殊用法剂量修正
                                const doseFix = (data?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0)) ? true : false;
                                let useDays;
                                let splitUseDays;
                                if (doseFix) {
                                  //天数 = 数量 / (频次*（剂量/转换比 先取整）) 再整体取整
                                  useDays = Math.floor(CHU(values?.drugCount, CHENG((data?.codeCalc || data?.frequencyCalc || 0), Math.ceil(CHU(data?.normalDose, doseConvert)))));
                                  splitUseDays = Math.floor(CHU(values?.drugCount, CHENG((data?.codeCalc || data?.frequencyCalc || 0), Math.ceil(data?.normalDose))));
                                } else {
                                  //天数 = 数量 / (频次*剂量/转换比) 一次取整
                                  // useDays = Math.floor(CHU(values?.drugCount,CHENG((data?.codeCalc ||data?.frequencyCalc ||0),CHU(data?.normalDose,doseConvert))));
                                  // splitUseDays = Math.floor(CHU(values?.drugCount,CHENG((data?.codeCalc ||data?.frequencyCalc ||0),data?.normalDose)));
                                  useDays = Math.floor(CHU(CHENG(Number(values?.drugCount), doseConvert), CHENG((data?.codeCalc || data?.frequencyCalc || 0), data?.normalDose)))
                                  splitUseDays = Math.floor(CHU(Number(values?.drugCount), CHENG((data?.codeCalc || data?.frequencyCalc || 0), data?.normalDose)))
                                }

                                const realUseDays: any =
                                  data?.splitTag == 1 ? splitUseDays : useDays

                                const autoDataUseDays = {
                                  ...data,
                                  useDays:
                                    realUseDays != 'Infinity'
                                      ? Math.floor(
                                        realUseDays < 1 ? 1 : realUseDays
                                      ) || 1
                                      : undefined,
                                }

                                !disabled && add(autoDataUseDays, false, m.id)
                              } else {
                                !disabled && add(data, false, m.id)
                              }
                            } else if (values?.normalFrequency) {
                              const pc: any = Number(
                                localStorage.getItem('calc')
                              )
                              if (pc == 0) {
                                !disabled && add(data, false, m.id)
                                return
                              }
                              const doseFix = (data?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0)) ? true : false;
                              let drugCount;
                              let splitDrugCount;
                              if (doseFix) {
                                //数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
                                drugCount = Math.ceil(CHENG(CHENG(pc, Number(data?.useDays)), (Math.ceil(CHU(data?.normalDose, doseConvert)))));
                                splitDrugCount = Math.ceil(CHENG(CHENG(pc, Math.ceil(data?.normalDose)), Number(data?.useDays)));
                              } else {
                                //数量 = 频次*天数*剂量/转换比 一次取整
                                // drugCount = Math.ceil(CHENG(CHENG(pc,Number(data?.useDays)),(CHU(data?.normalDose,doseConvert))));
                                // splitDrugCount = Math.ceil(CHENG(CHENG(pc,data?.normalDose),Number(data?.useDays)));
                                drugCount = Math.ceil(CHU(CHENG(CHENG(pc, data?.normalDose), Number(data?.useDays)), doseConvert));
                                splitDrugCount = Math.ceil(CHENG(CHENG(pc, data?.normalDose), Number(data?.useDays)));
                              }

                              const realDrugCount =
                                data?.splitTag == 1 ? splitDrugCount : drugCount

                              const autoDataNormalFrequency = {
                                ...data,
                                drugCount: realDrugCount || 1,
                              }
                              !disabled &&
                                add(autoDataNormalFrequency, false, m.id)
                            } else if (values?.normalDose) {
                              const doseFix = (values?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0)) ? true : false
                              let drugCount;
                              let splitDrugCount;
                              if (doseFix) {
                                //数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
                                drugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Number(data?.useDays)), (Math.ceil(CHU(Number(values?.normalDose), doseConvert)))));
                                splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Math.ceil(Number(values?.normalDose))), Number(data?.useDays)));
                              } else {
                                //数量 = 频次*天数*剂量/转换比 一次取整
                                // drugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0),Number(data?.useDays)),(CHU(Number(values?.normalDose),doseConvert))));
                                // splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0),Number(values?.normalDose)),Number(data?.useDays)));
                                drugCount = Math.ceil(CHU(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Number(values?.normalDose)), Number(data?.useDays)), doseConvert));
                                splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Number(values?.normalDose)), Number(data?.useDays)));
                              }

                              const realDrugCount =
                                data?.splitTag == 1 ? splitDrugCount : drugCount

                              const autoDataNormalFrequency = {
                                ...data,
                                drugCount: realDrugCount || 1,
                              }
                              !disabled &&
                                add(autoDataNormalFrequency, false, m.id)
                            } else {
                              !disabled && add(data, false, m.id)
                            }
                          } else {
                            !disabled && add(data, false, m.id)
                          }
                        }
                      }
                    },
                    allowedToChangePrice,
                    (itemPayType, v) => {
                      !disabled &&
                        dispatch(
                          updateItemPayTypeAsync({
                            itemPayType,
                            recipeItemId: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((res) => {
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                            // onNewRecipe && onNewRecipe(res)
                          })
                    },
                    false,
                    (t, v) => {
                      if (disabled) return
                      if (t === 'qupi') {
                        const data = {
                          patientId: patientId,
                          recipeId: v.recipeId,
                          skinTestInfo: v.skinTestInfo,
                          tenantRecipeItemId: v.id,
                        }
                        dispatch(editST(data))
                          .then(unwrapResult)
                          .then((res: any) => {
                            // setIsShowVisibale(false)
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                            if (
                              v?.skinTestInfo != '续用' &&
                              v?.skinTestInfo != '免皮'
                            ) {
                              notification.success({
                                message: '通知成功',
                              })
                            }
                          })
                      } else if(t === 'jgdj'){
                        // 结果登记
                        setPitestParms({
                          patientId: patientId,
                          recipeId: v.recipeId,
                          tenantRecipeItemId: v.id,
                        })
                        setIsModalRegisterVisible(true)
                      }
                    },
                    isShowVisibale,
                    (m) => {
                      if (disabled) return
                      if (m.billingCategory === '97' && isSetting) {
                        return
                      } else {
                        setTargetMaterial(m)
                      }
                    },
                    expiredInDaysEyeFlag,
                    (v: any) => {
                      setExpiredInDaysEyeFlag(v)
                      localStorage.setItem('expiredInDaysEyeFlag', v)
                    },
                    (v: any) => {
                      setXWTreatmentPartsItem(v);
                    },acupointList,
                    )
                  : MedicineColumn(
                    theme,
                    materials,
                    settings,
                    async (m, values: any) => {
                      const data: any = { ...m, ...values }
                      if (data?.tbEdit) {
                        !disabled && add(data, false, m.id, true)
                      }
                      // 诊疗不触发自动计算
                      if (data?.drugType == 1) {
                        if (data?.drugCount == 0) {
                          messageApi.open({
                            type: 'info',
                            content: '数量不可为 0',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else if (!(data?.retailPrice?.toString())) {
                          messageApi.open({
                            type: 'info',
                            content: '单价不可为空',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else {
                          !disabled && add(data, false, m.id)
                        }
                      } else {
                        if (data?.drugCount == 0) {
                          messageApi.open({
                            type: 'info',
                            content: '数量不可为 0',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else if (!(data?.retailPrice?.toString())) {
                          messageApi.open({
                            type: 'info',
                            content: '单价不可为空',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else {
                          if (autoChangePrice) {
                            // 用量计算比没有填写的时候不进行计算
                            const doseConvert: number =
                              data?.doseConvert && data?.doseConvert > 0
                                ? data?.doseConvert 
                                : ''
                            if(!doseConvert){
                              !disabled && add(data, false, m.id)
                              return
                            }
                            // 修改天数 计算数量
                            if (values?.useDays) {
                              //特殊用法剂量修正
                              const doseFix = (data?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0)) ? true : false;
                              let drugCount;
                              let splitDrugCount;

                              if (doseFix) {
                                //数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
                                drugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Number(values?.useDays)), (Math.ceil(CHU(data?.normalDose, doseConvert)))));
                                splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Math.ceil(data?.normalDose)), Number(values?.useDays)));
                              } else {
                                //数量 = 频次*天数*剂量/转换比 一次取整
                                // drugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0),Number(values?.useDays)),(CHU(data?.normalDose,doseConvert))));
                                // splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0),data?.normalDose),Number(values?.useDays)));
                                drugCount = Math.ceil(CHU(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), data?.normalDose), Number(values?.useDays)), doseConvert))
                                splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), data?.normalDose), Number(values?.useDays)));
                              }
                              const realDrugCount =
                                data?.splitTag == 1 ? splitDrugCount : drugCount

                              const autoDataDrugCount = {
                                ...data,
                                drugCount: realDrugCount || 1,
                              }
                              !disabled && add(autoDataDrugCount, false, m.id)
                            } else if (values?.drugCount) {
                              // 修改数量 计算天数
                              if (data?.frequencyCalc !== 0) {
                                //特殊用法剂量修正
                                const doseFix = (data?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0)) ? true : false;
                                let useDays;
                                let splitUseDays;
                                if (doseFix) {
                                  //天数 = 数量 / (频次*（剂量/转换比 先取整）) 再整体取整
                                  useDays = Math.floor(CHU(values?.drugCount, CHENG((data?.codeCalc || data?.frequencyCalc || 0), Math.ceil(CHU(data?.normalDose, doseConvert)))));
                                  splitUseDays = Math.floor(CHU(values?.drugCount, CHENG((data?.codeCalc || data?.frequencyCalc || 0), Math.ceil(data?.normalDose))));
                                } else {
                                  //天数 = 数量 / (频次*剂量/转换比) 一次取整
                                  // useDays = Math.floor(CHU(values?.drugCount,CHENG((data?.codeCalc ||data?.frequencyCalc ||0),CHU(data?.normalDose,doseConvert))));
                                  // splitUseDays = Math.floor(CHU(values?.drugCount,CHENG((data?.codeCalc ||data?.frequencyCalc ||0),data?.normalDose)));
                                  useDays = Math.floor(CHU(CHENG(Number(values?.drugCount), doseConvert), CHENG((data?.codeCalc || data?.frequencyCalc || 0), data?.normalDose)))
                                  splitUseDays = Math.floor(CHU(Number(values?.drugCount), CHENG((data?.codeCalc || data?.frequencyCalc || 0), data?.normalDose)))
                                }

                                const realUseDays: any =
                                  data?.splitTag == 1 ? splitUseDays : useDays

                                const autoDataUseDays = {
                                  ...data,
                                  useDays:
                                    realUseDays != 'Infinity'
                                      ? Math.floor(
                                        realUseDays < 1 ? 1 : realUseDays
                                      ) || 1
                                      : undefined,
                                }

                                !disabled && add(autoDataUseDays, false, m.id)
                              } else {
                                !disabled && add(data, false, m.id)
                              }
                            } else if (values?.normalFrequency) {
                              const pc: any = Number(
                                localStorage.getItem('calc')
                              )
                              if (pc == 0) {
                                !disabled && add(data, false, m.id)
                                return
                              }
                              const doseFix = (data?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0)) ? true : false;
                              let drugCount;
                              let splitDrugCount;
                              if (doseFix) {
                                //数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
                                drugCount = Math.ceil(CHENG(CHENG(pc, Number(data?.useDays)), (Math.ceil(CHU(data?.normalDose, doseConvert)))));
                                splitDrugCount = Math.ceil(CHENG(CHENG(pc, Math.ceil(data?.normalDose)), Number(data?.useDays)));
                              } else {
                                //数量 = 频次*天数*剂量/转换比 一次取整
                                // drugCount = Math.ceil(CHENG(CHENG(pc,Number(data?.useDays)),(CHU(data?.normalDose,doseConvert))));
                                // splitDrugCount = Math.ceil(CHENG(CHENG(pc,data?.normalDose),Number(data?.useDays)));
                                drugCount = Math.ceil(CHU(CHENG(CHENG(pc, data?.normalDose), Number(data?.useDays)), doseConvert));
                                splitDrugCount = Math.ceil(CHENG(CHENG(pc, data?.normalDose), Number(data?.useDays)));
                              }

                              const realDrugCount =
                                data?.splitTag == 1 ? splitDrugCount : drugCount

                              const autoDataNormalFrequency = {
                                ...data,
                                drugCount: realDrugCount || 1,
                              }
                              !disabled &&
                                add(autoDataNormalFrequency, false, m.id)
                            } else if (values?.normalDose) {
                              const doseFix = (values?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0)) ? true : false
                              let drugCount;
                              let splitDrugCount;
                              if (doseFix) {
                                //数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
                                drugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Number(data?.useDays)), (Math.ceil(CHU(Number(values?.normalDose), doseConvert)))));
                                splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Math.ceil(Number(values?.normalDose))), Number(data?.useDays)));
                              } else {
                                //数量 = 频次*天数*剂量/转换比 一次取整
                                // drugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0),Number(data?.useDays)),(CHU(Number(values?.normalDose),doseConvert))));
                                // splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0),Number(values?.normalDose)),Number(data?.useDays)));
                                drugCount = Math.ceil(CHU(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Number(values?.normalDose)), Number(data?.useDays)), doseConvert));
                                splitDrugCount = Math.ceil(CHENG(CHENG((data?.codeCalc || data?.frequencyCalc || 0), Number(values?.normalDose)), Number(data?.useDays)));
                              }

                              const realDrugCount =
                                data?.splitTag == 1 ? splitDrugCount : drugCount

                              const autoDataNormalFrequency = {
                                ...data,
                                drugCount: realDrugCount || 1,
                              }
                              !disabled &&
                                add(autoDataNormalFrequency, false, m.id)
                            } else {
                              !disabled && add(data, false, m.id)
                            }
                          } else {
                            !disabled && add(data, false, m.id)
                          }
                        }
                      }
                    },
                    allowedToChangePrice,
                    (itemPayType, v) => {
                      !disabled &&
                        dispatch(
                          updateItemPayTypeAsync({
                            itemPayType,
                            recipeItemId: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((res) => {
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                            // onNewRecipe && onNewRecipe(res)
                          })
                    },
                    false,
                    (t, v) => {
                      if (disabled) return
                      if (t === 'qupi') {
                        const data = {
                          patientId: patientId,
                          recipeId: v.recipeId,
                          skinTestInfo: v.skinTestInfo,
                          tenantRecipeItemId: v.id,
                        }
                        dispatch(editST(data))
                          .then(unwrapResult)
                          .then((res: any) => {
                            // setIsShowVisibale(false)
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                            if (
                              v?.skinTestInfo != '续用' &&
                              v?.skinTestInfo != '免皮'
                            ) {
                              notification.success({
                                message: '通知成功',
                              })
                            }
                          })
                      } else if(t === 'jgdj'){
                        // 结果登记
                        setPitestParms({
                          patientId: patientId,
                          recipeId: v.recipeId,
                          tenantRecipeItemId: v.id,
                        })
                        setIsModalRegisterVisible(true)
                      }
                    },
                    isShowVisibale,
                    (m) => {
                      if (disabled) return
                      if (m.billingCategory === '97' && isSetting) {
                        return
                      } else {
                        setTargetMaterial(m)
                      }
                    },
                    expiredInDaysEyeFlag,
                    (v: any) => {
                      setExpiredInDaysEyeFlag(v)
                      localStorage.setItem('expiredInDaysEyeFlag', v)
                    }
                  )
            }
            pagination={false}
            size='small'
            bordered
            id='tableDom'
            // className={state ? styles.minRecipeList : styles.maxRecipeList}
            className={
              recipeCategory == RecipeCategory.Dispose
                ? styles.tables
                : recipeCategory == RecipeCategory.Tcm ||
                  recipeCategory == RecipeCategory.TcmGranules || 
                  recipeCategory == RecipeCategory.TcmTreat  
                  ? styles.tcmTable
                  : styles.table
            }
            style={{
              margin: hisVersion == 1 ? '36px 0 0 0' : '0',
            }}
            rowKey={(m) => m.id}
            rowSelection={{
              selectedRowKeys: selectedKeys,
              onChange: (ks) => setSelectedKeys(ks as string[]),
            }}
          />
        ) : ( */}
          <EditableList
           sticky
            // scroll={{ y: '3rem' }}
            loading={pageLoading}
            dataSource={materials?.map((v) => {
              const discount = v?.discount ? (Number(v?.discount) * 100)?.toFixed(0) : '-'
              return {
                ...v,
                accountUnit: v.splitTag ? v.splitUnit : v.accountUnit,
                discount: discount,
                retailBeforePrice: v.retailPrice && discount
                  ? (Number(v.retailPrice) / Number(discount) * 100)?.toFixed(5)
                  : '0.00000',
              }
            })}
            columns={
              recipeCategory == RecipeCategory.Tcm ||
                recipeCategory == RecipeCategory.TcmGranules
                ? TcmColumn(
                  settings,
                  theme,
                  async (m, values) => {
                    const data: any = { ...m, ...values }
                    if (data?.tbEdit) {
                      !disabled && add(data, false, m.id, true)
                    }
                    if (m.billingCategory == '97') return
                    if (data?.countPerTip == 0) {
                      messageApi.open({
                        type: 'info',
                        content: '数量不可为 0',
                        style: {
                          marginTop: '35vh',
                        },
                      })
                    } else if (!(data?.retailPrice?.toString())) {
                      messageApi.open({
                        type: 'info',
                        content: '单价不可为空',
                        style: {
                          marginTop: '35vh',
                        },
                      })
                    } else {
                      !disabled && add({ ...m, ...values }, false, m.id)
                    }
                  },
                  allowedToChangePrice,
                  (itemPayType, v) => {
                    !disabled &&
                      dispatch(
                        updateItemPayTypeAsync({
                          itemPayType,
                          recipeItemId: v.id,
                        })
                      )
                        .then(unwrapResult)
                        .then((res) => {
                          getRecipeDetailList(recipeId || '')
                          setUpdateFlags('1', '1')
                          // onNewRecipe && onNewRecipe(res)
                        })
                  },
                  recipeCategory,
                  (m) => {
                    if (disabled) return
                    if (m.billingCategory === '97' && isSetting) {
                      return
                    } else {
                      setTargetMaterial(m)
                    }
                  },
                  false,
                  insuranceArray,
                  expiredInDaysEyeFlag,
                  (v: any) => {
                    setExpiredInDaysEyeFlag(v)
                    localStorage.setItem('expiredInDaysEyeFlag', v)
                  }
                )
                : recipeCategory == RecipeCategory.Dispose
                  ? DisposeColumns(
                    theme,
                    materials,
                    settings,
                    async (m, values: any) => {
                      const data = { ...m, ...values }
                      if (data?.tbEdit) {
                        !disabled && add(data, false, m.id, true)
                      }
                      if (data?.drugCount == 0) {
                        messageApi.open({
                          type: 'info',
                          content: '数量不可为 0',
                          style: {
                            marginTop: '35vh',
                          },
                        })
                      } else {
                        !disabled && add(data, false, m.id)
                      }
                    },
                    allowedToChangePrice,
                    (itemPayType, v) => {
                      !disabled &&
                        dispatch(
                          updateItemPayTypeAsync({
                            itemPayType,
                            recipeItemId: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((res) => {
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                          })
                    },
                    false,
                    (t, v, tooth, toothType) => {
                      if (disabled) return
                      if (t == 'toothEdit') {
                        // 诊疗项目且单位为"颗/每牙"时，牙位变化后重新保存明细让数量跟随牙位
                        const unit = v.splitTag ? v.splitUnit : v.accountUnit
                        const autoCount = settings?.[Checks.YWSLLD] && v?.drugType == 1 && (unit == '颗' || unit == '每牙')
                        const updateByTooth = () => {
                          add(
                            {...v,toothStruct: tooth,...(v?.drugCount > 0 ? { drugCount: v.drugCount } : {}),},false, v.id
                          )
                        }
                        const refreshList = () => {
                          getRecipeDetailList(recipeId || '')
                          setUpdateFlags('1', '1')
                        }
                        const afterSave = () => {
                          if (autoCount) {
                            updateByTooth()
                          } else {
                            refreshList()
                          }
                        }
                        if (toothType == 0) {
                          // 同步
                          dispatch(
                            syncToothAsync({ itemTooth: tooth, recipeId: Number(recipeId) })
                          )
                            .then(unwrapResult)
                            .then((() => {
                              refreshList()
                            }))
                        } else if (toothType == 1) {
                          // 保存
                          const data = { itemTooth: tooth, recipeItemId: Number(v.id) }
                          if ((yzcfTag || kqMoveTag) && materials?.length) {
                            dispatch(saveToothAsync(data))
                              .then(unwrapResult)
                              .then((()=>{
                                afterSave()
                              }))
                               console.log('toothType',toothType)
                          } else {
                             console.log('toothType',toothType)
                            dispatch(saveToothAsync(data))
                              .then(unwrapResult)
                              .then(() => {
                                if (autoCount) {
                                  updateByTooth()
                                }
                              })
                          }
                        }
                      }
                    },
                    (m) => {
                      if (disabled) return
                      if (m.billingCategory === '97' && isSetting) {
                        return
                      } else {
                        setTargetMaterial(m)
                      }
                    },
                    true,
                    expiredInDaysEyeFlag,
                    (v: any) => {
                      setExpiredInDaysEyeFlag(v)
                      localStorage.setItem('expiredInDaysEyeFlag', v)
                    },
                    (yzcfTag || kqMoveTag) && materials?.length ? false : discountFlag
                  )
                : recipeCategory == RecipeCategory.TcmTreat  
                  ? TcmTreatColumn(
                    theme,
                    materials,
                    settings,
                    async (m, values: any) => {
                      const data: any = { ...m, ...values }
                      if (data?.tbEdit) {
                        !disabled && add(data, false, m.id, true)
                      }
                      // 诊疗不触发自动计算
                      if (data?.drugType == 1) {
                        if (data?.drugCount == 0) {
                          messageApi.open({
                            type: 'info',
                            content: '数量不可为 0',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else if (!(data?.retailPrice?.toString())) {
                          messageApi.open({
                            type: 'info',
                            content: '单价不可为空',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else {
                          !disabled && add(data, false, m.id)
                        }
                      } else {
                        if (data?.drugCount == 0) {
                          messageApi.open({
                            type: 'info',
                            content: '数量不可为 0',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else if (!(data?.retailPrice?.toString())) {
                          messageApi.open({
                            type: 'info',
                            content: '单价不可为空',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else {
                          !disabled && add(data, false, m.id)
                        }
                      }
                    },
                    allowedToChangePrice,
                    (itemPayType, v) => {
                      !disabled &&
                        dispatch(
                          updateItemPayTypeAsync({
                            itemPayType,
                            recipeItemId: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((res) => {
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                            // onNewRecipe && onNewRecipe(res)
                          })
                    },
                    false,
                    (t, v) => {
                      if (disabled) return
                      if (t === 'qupi') {
                        const data = {
                          patientId: patientId,
                          recipeId: v.recipeId,
                          skinTestInfo: v.skinTestInfo,
                          tenantRecipeItemId: v.id,
                        }
                        dispatch(editST(data))
                          .then(unwrapResult)
                          .then((res: any) => {
                            // setIsShowVisibale(false)
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                            if (
                              v?.skinTestInfo != '续用' &&
                              v?.skinTestInfo != '免皮'
                            ) {
                              notification.success({
                                message: '通知成功',
                              })
                            }
                          })
                      } else if(t === 'jgdj'){
                        // 结果登记
                        setPitestParms({
                          patientId: patientId,
                          recipeId: v.recipeId,
                          tenantRecipeItemId: v.id,
                        })
                        setIsModalRegisterVisible(true)
                      }
                    },
                    isShowVisibale,
                    (m) => {
                      if (disabled) return
                      if (m.billingCategory === '97' && isSetting) {
                        return
                      } else {
                        setTargetMaterial(m)
                      }
                    },
                    expiredInDaysEyeFlag,
                    (v: any) => {
                      setExpiredInDaysEyeFlag(v)
                      localStorage.setItem('expiredInDaysEyeFlag', v)
                    },
                    (v: any) => {
                      setXWTreatmentPartsItem(v);
                    },acupointList,
                    )
                  : MedicineColumn(
                    theme,
                    materials,
                    settings,
                    async (m, values: any) => {
                      const data: any = { ...m, ...values }
                      if (data?.tbEdit) {
                        !disabled && add(data, false, m.id, true)
                      }
                      // 诊疗不触发自动计算
                      if (data?.drugType == 1) {
                        if (data?.drugCount == 0) {
                          messageApi.open({
                            type: 'info',
                            content: '数量不可为 0',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else if (!(data?.retailPrice?.toString())) {
                          messageApi.open({
                            type: 'info',
                            content: '单价不可为空',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else {
                          !disabled && add(data, false, m.id)
                        }
                      } else {
                        if (data?.drugCount == 0) {
                          messageApi.open({
                            type: 'info',
                            content: '数量不可为 0',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else if (!(data?.retailPrice?.toString())) {
                          messageApi.open({
                            type: 'info',
                            content: '单价不可为空',
                            style: {
                              marginTop: '35vh',
                            },
                          })
                        } else {
                          if (autoChangePrice) {
                            const doseFixJDJZ = (data?.normalDose > 0 && (data?.normalUsemethod?.indexOf("静滴") >= 0 || data?.normalUsemethod?.indexOf("静注") >= 0)) ? true : false
                            const doseFixWH = (data?.normalDose > 0 && (data?.normalUsemethod?.indexOf("雾化") >= 0 )) ? true : false
                            const frequencyCalc = values?.normalFrequency
                              ? Number(localStorage.getItem('calc')) || data?.codeCalc || data?.frequencyCalc || 0
                              : data?.codeCalc || data?.frequencyCalc || 0
                            const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS]
                            if (frequencyCalc == 0 || data?.doseUnit == '适量') {
                              !disabled && add(data, false, m.id)
                              return
                            }
                            if (settings?.[Checks.MLKG] == 1) {
                              if (!data?.doseUnit) {
                                !disabled && add(data, false, m.id)
                                return
                              }
                              if (values?.useDays) {
                                //特殊用法剂量修正
                                const drugCount = getNewAutoChangePriceDrugCount('useDays', data, data?.doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, data?.normalDose, values?.useDays, flag)
                                const splitDrugCount = getNewAutoChangePriceSplitDrugCount('useDays', data, data?.doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, data?.normalDose, values?.useDays, flag)
                                const realDrugCount = data?.splitTag == 1 ? splitDrugCount : drugCount

                                const autoDataDrugCount = {
                                  ...data,
                                  drugCount: realDrugCount || 1,
                                }
                                !disabled && add(autoDataDrugCount, false, m.id)
                              } else if (values?.drugCount) {
                                // 修改数量 计算天数
                                if (data?.frequencyCalc !== 0) {
                                  //特殊用法剂量修正
                                  const useDays = getNewAutoChangePriceUseDays('drugCount', data, data?.doseUnit, doseFixJDJZ, doseFixWH, values?.drugCount, frequencyCalc, data?.normalDose, flag)
                                  const splitUseDays = getNewAutoChangePriceSplitUseDays('drugCount', data, data?.doseUnit, doseFixJDJZ, doseFixWH, values?.drugCount, frequencyCalc, data?.normalDose, flag)
                                  const realUseDays: any = data?.splitTag == 1 ? splitUseDays : useDays

                                  const autoDataUseDays = {
                                    ...data,
                                    useDays: realUseDays != 'Infinity' ? Math.floor(realUseDays < 1 ? 1 : realUseDays) || 1 : undefined,
                                  }

                                  !disabled && add(autoDataUseDays, false, m.id)
                                } else {
                                  !disabled && add(data, false, m.id)
                                }
                              } else if (values?.normalFrequency) {
                                const pc: any = Number(
                                  localStorage.getItem('calc')
                                )
                                if (pc == 0) {
                                  !disabled && add(data, false, m.id)
                                  return
                                }
                                const drugCount = getNewAutoChangePriceDrugCount('normalFrequency', data, data?.doseUnit, doseFixJDJZ, doseFixWH, pc, data?.normalDose, data?.useDays, flag)
                                const splitDrugCount = getNewAutoChangePriceSplitDrugCount('normalFrequency', data, data?.doseUnit, doseFixJDJZ, doseFixWH, pc, data?.normalDose, data?.useDays, flag)
                                const realDrugCount = data?.splitTag == 1 ? splitDrugCount : drugCount

                                const autoDataDrugCount = {
                                  ...data,
                                  drugCount: realDrugCount || 1,
                                }
                                !disabled &&
                                  add(autoDataDrugCount, false, m.id)
                              } else if (values?.normalDose) {
                                const drugCount = getNewAutoChangePriceDrugCount('normalDose', data, data?.doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, values?.normalDose, data?.useDays, flag)
                                const splitDrugCount = getNewAutoChangePriceSplitDrugCount('normalDose', data, data?.doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, values?.normalDose, data?.useDays, flag)
                                const realDrugCount = data?.splitTag == 1 ? splitDrugCount : drugCount

                                const autoDataDrugCount = {
                                  ...data,
                                  drugCount: realDrugCount || 1,
                                }
                                !disabled &&
                                  add(autoDataDrugCount, false, m.id)
                              } else if (values?.doseUnit) {
                                const drugCount = getNewAutoChangePriceDrugCount('doseUnit', data, values?.doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, data?.normalDose, data?.useDays, flag)
                                const splitDrugCount = getNewAutoChangePriceSplitDrugCount('doseUnit', data, values?.doseUnit, doseFixJDJZ, doseFixWH, frequencyCalc, data?.normalDose, data?.useDays, flag)
                                const realDrugCount = data?.splitTag == 1 ? splitDrugCount : drugCount

                                const autoDataDrugCount = {
                                  ...data,
                                  drugCount: realDrugCount || 1,
                                }
                                !disabled &&
                                  add(autoDataDrugCount, false, m.id)
                              } else {
                                !disabled && add(data, false, m.id)
                              }
                            } else {
                              // 用量计算比没有填写的时候不进行计算
                              const doseConvert: number = data?.doseConvert && data?.doseConvert > 0 ? data?.doseConvert : ''
                              if (!doseConvert || data?.doseUnit == '适量' || frequencyCalc == 0 ) {
                                !disabled && add(data, false, m.id)
                                return
                              }
                              // 修改天数 计算数量
                              if (values?.useDays) {
                                const drugCount = getOldAutoChangePriceDrugCount('useDays', doseFixJDJZ, values?.useDays, '', data?.normalDose, doseConvert, frequencyCalc)
                                const splitDrugCount = getOldAutoChangePriceSplitDrugCount('useDays', doseFixJDJZ, values?.useDays, '', data?.normalDose, frequencyCalc)
                                const realDrugCount = data?.splitTag == 1 ? splitDrugCount : drugCount

                                const autoDataDrugCount = {
                                  ...data,
                                  drugCount: realDrugCount || 1,
                                }
                                !disabled && add(autoDataDrugCount, false, m.id)
                              } else if (values?.drugCount) {
                                // 修改数量 计算天数
                                if (data?.frequencyCalc !== 0) {
                                  const useDays = getOldAutoChangePriceUseDays('drugCount', doseFixJDJZ, values?.drugCount, frequencyCalc, data?.normalDose, doseConvert)
                                  const splitUseDays = getOldAutoChangePriceSplitUseDays('drugCount', doseFixJDJZ, values?.drugCount, frequencyCalc, data?.normalDose)
                                  const realUseDays: any = data?.splitTag == 1 ? splitUseDays : useDays

                                  const autoDataUseDays = {
                                    ...data,
                                    useDays: realUseDays != 'Infinity' ? Math.floor(realUseDays < 1 ? 1 : realUseDays) || 1 : undefined,
                                  }

                                  !disabled && add(autoDataUseDays, false, m.id)
                                } else {
                                  !disabled && add(data, false, m.id)
                                }
                              } else if (values?.normalFrequency) {
                                const pc: any = Number(
                                  localStorage.getItem('calc')
                                )
                                if (pc == 0) {
                                  !disabled && add(data, false, m.id)
                                  return
                                }
                                const drugCount = getOldAutoChangePriceDrugCount('normalFrequency', doseFixJDJZ, Number(data?.useDays), pc, data?.normalDose, doseConvert)
                                const splitDrugCount = getOldAutoChangePriceSplitDrugCount('normalFrequency', doseFixJDJZ, Number(data?.useDays), pc, data?.normalDose)
                                const realDrugCount = data?.splitTag == 1 ? splitDrugCount : drugCount

                                const autoDataNormalFrequency = {
                                  ...data,
                                  drugCount: realDrugCount || 1,
                                }
                                !disabled &&
                                  add(autoDataNormalFrequency, false, m.id)
                              } else if (values?.normalDose) {
                                const drugCount = getOldAutoChangePriceDrugCount('normalDose', doseFixJDJZ, Number(data?.useDays), '', Number(values?.normalDose), doseConvert, frequencyCalc)
                                const splitDrugCount = getOldAutoChangePriceSplitDrugCount('normalDose', doseFixJDJZ, Number(data?.useDays), '', Number(values?.normalDose), frequencyCalc)
                                const realDrugCount = data?.splitTag == 1 ? splitDrugCount : drugCount

                                const autoDataNormalFrequency = {
                                  ...data,
                                  drugCount: realDrugCount || 1,
                                }
                                !disabled &&
                                  add(autoDataNormalFrequency, false, m.id)
                              } else {
                                !disabled && add(data, false, m.id)
                              }
                            }
                          } else {
                            !disabled && add(data, false, m.id)
                          }
                        }
                      }
                    },
                    allowedToChangePrice,
                    (itemPayType, v) => {
                      !disabled &&
                        dispatch(
                          updateItemPayTypeAsync({
                            itemPayType,
                            recipeItemId: v.id,
                          })
                        )
                          .then(unwrapResult)
                          .then((res) => {
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                            // onNewRecipe && onNewRecipe(res)
                          })
                    },
                    false,
                    (t, v) => {
                      if (disabled) return
                      if (t === 'qupi') {
                        const data = {
                          patientId: patientId,
                          recipeId: v.recipeId,
                          skinTestInfo: v.skinTestInfo,
                          tenantRecipeItemId: v.id,
                        }
                        dispatch(editST(data))
                          .then(unwrapResult)
                          .then((res: any) => {
                            // setIsShowVisibale(false)
                            getRecipeDetailList(recipeId || '')
                            setUpdateFlags('1', '1')
                            if (
                              v?.skinTestInfo != '续用' &&
                              v?.skinTestInfo != '免皮'
                            ) {
                              notification.success({
                                message: '通知成功',
                              })
                            }
                          })
                      } else if(t === 'jgdj'){
                        // 结果登记
                        setPitestParms({
                          patientId: patientId,
                          recipeId: v.recipeId,
                          tenantRecipeItemId: v.id,
                        })
                        setIsModalRegisterVisible(true)
                      }
                    },
                    isShowVisibale,
                    (m) => {
                      if (disabled) return
                      if (m.billingCategory === '97' && isSetting) {
                        return
                      } else {
                        setTargetMaterial(m)
                      }
                    },
                    expiredInDaysEyeFlag,
                    (v: any) => {
                      setExpiredInDaysEyeFlag(v)
                      localStorage.setItem('expiredInDaysEyeFlag', v)
                    },
                    autoChangePrice
                  )
            }
            pagination={false}
            size='small'
            bordered
            id='tableDom'
            // className={state ? styles.minRecipeList : styles.maxRecipeList}
            className={
               recipeCategory == RecipeCategory.Dispose
                ? styles.tables : (yzcfTag || kqMoveTag) && materials?.length ? 
                (recipeCategory == RecipeCategory.Tcm ||
                  recipeCategory == RecipeCategory.TcmGranules || 
                  recipeCategory == RecipeCategory.TcmTreat  
                  ? styles.tcmTable
                  : styles.table):
                  recipeCategory == RecipeCategory.Tcm
                  ? styles.tcmKskdTable
                  : hisVersion == 1 ? styles.table : styles.tableKskd
            }
            style={{
              margin: hisVersion == 1 ? '36px 0 0 0' : '0',
            }}
            rowKey={(m) => m.id}
            rowSelection={{
              selectedRowKeys: selectedKeys,
              onChange: (ks) => setSelectedKeys(ks as string[]),
            }}
          // onRow={(m) => ({
          //   onDoubleClick: () => {
          //     if (disabled) return
          //     if (m.billingCategory === '97' && isSetting) {
          //       return
          //     } else {
          //       setTargetMaterial(m)
          //     }
          //   },
          // })}
          />
          {/* )} */}
          {(recipeCategory == RecipeCategory.Medicine || recipeCategory == RecipeCategory.Dispose || recipeCategory == RecipeCategory.Others) && discountFlag ? (
              <>
                <div
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                    top: '6px',
                  }}
                >{(location.pathname == '/retail' || location.pathname == '/pharmacy/retail') ?
                  <>
                    <span style={{ color: '#101010', fontSize: '20px' }}>
                      总金额 :
                    </span>
                    <span
                      style={{ color: 'red', fontSize: '24px', marginLeft: '4px' }}
                    >
                      {drugAmount?.toFixed(2)}
                    </span>
                    （<span>
                      <span style={{ color: '#101010', fontSize: '14px' }}>
                        原总金额 :
                      </span>
                      <span
                        style={{ color: 'red', fontSize: '14px', marginLeft: '4px' }}
                      >
                        {totalRetailPriceAmount?.toFixed(2)}
                      </span>
                      <span style={{ color: '#101010', fontSize: '14px' }}>
                        ，优惠 :
                      </span>
                      <span
                        style={{ color: 'red', fontSize: '14px', marginLeft: '4px' }}
                      >
                        {(totalRetailPriceAmount?.toFixed(2) - drugAmount?.toFixed(2))?.toFixed(2)}
                      </span>
                    </span>）
                  </> :
                  <>
                    <span style={{ color: '#101010', fontSize: '20px' }}>
                      总金额 :
                    </span>
                    <span
                      style={{ color: 'red', fontSize: '24px', marginLeft: '4px' }}
                    >
                      {drugAmount?.toFixed(2)}
                    </span>
                  </>}
                </div>
              </>
          ) : (
            <></>
          )}
          {isTcmRecipeCategory(recipeCategory) && (
              <Row
                align='middle'
                className={styles.tip}
                style={{
                  color: theme.tc2,
                  fontSize: '0.875rem',
                  paddingBottom: discountFlag ? 0 : '10px',
                  position: 'relative',
                  top: '6px',
                  minWidth: kskdTag || ydkdFlag ? 1100 : 1250,
                  // width: '100vw',
                }}
              >
                {discountFlag ? (
                  <div
                    style={{
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      marginRight: '10px',
                    }}
                  >
                    {(location.pathname == '/retail' || location.pathname == '/pharmacy/retail') ?
                      <>
                        <span style={{ color: '#101010', fontSize: '20px' }}>
                          总金额 :
                        </span>
                        <span
                          style={{ color: 'red', fontSize: '24px', marginLeft: '4px' }}
                        >
                          {drugAmount?.toFixed(2)}
                        </span>
                        （<span>
                          <span style={{ color: '#101010', fontSize: '14px' }}>
                            原总金额 :
                          </span>
                          <span
                            style={{ color: 'red', fontSize: '14px', marginLeft: '4px' }}
                          >
                            {totalRetailPriceAmount?.toFixed(2)}
                          </span>
                          <span style={{ color: '#101010', fontSize: '14px' }}>
                            ，优惠 :
                          </span>
                          <span
                            style={{ color: 'red', fontSize: '14px', marginLeft: '4px' }}
                          >
                            {(totalRetailPriceAmount?.toFixed(2) - drugAmount?.toFixed(2))?.toFixed(2)}
                          </span>
                        </span>）

                      </> : <>
                        <span style={{ color: '#101010', fontSize: '20px' }}>
                          总金额 :
                        </span>
                        <span
                          style={{ color: 'red', fontSize: '24px', marginLeft: '4px' }}
                        >
                          {drugAmount?.toFixed(2)}
                        </span>
                      </>}

                  </div>
                ) : (
                  <></>
                )}
                总帖均：
                <div
                  style={{
                    color: theme.tc1,
                    fontSize: '1.125rem',
                    marginRight: 10,
                  }}
                >
                  ¥
                  {/* {recipe
                ? (
                    recipe.amount / (recipe.tip || 1) -
                    (recipe.replaceMakePrice || 0)
                  ).toFixed(2)
                : ''} */}
                  {recipe?.totalTipAmount?.toFixed(2)}
                </div>
                自费帖均：
                <div
                  style={{
                    color: theme.tc1,
                    fontSize: '1.125rem',
                    marginRight: 10,
                  }}
                >
                  ¥
                  {/* {recipe
                ? (
                    (recipe.oneselfAmount || 0) / (recipe.tip || 1) -
                    (recipe.replaceMakePrice || 0)
                  ).toFixed(2)
                : ''} */}
                  {recipe?.zifeiTipAmount?.toFixed(2)}
                </div>
                {(recipeCategory == 3 || recipeCategory == 12) &&
                  JSON.parse(localStorage.getItem('credentials') as string)
                    .insuranceArray.length != 0 && (
                    <>
                      医保帖均：
                      <div
                        style={{
                          color: theme.tc1,
                          fontSize: '1.125rem',
                          marginRight: 10,
                        }}
                      >
                        ¥
                        {/* {recipe
                      ? (
                          (recipe?.amount || 0) / (recipe.tip || 1) -
                          (recipe?.YBReplaceMakePrice || 0)
                        ).toFixed(2)
                      : ''} */}
                        {recipe?.insuranceTipAmount?.toFixed(2)}
                      </div>
                    </>
                  )}
                {isSetting ? (
                  <>
                    {' '}
                    代煎类别：
                    <div
                      style={{
                        color:
                          machiningTypeMsg == '委外代煎袋装液体'
                            ? 'red'
                            : theme.tc1,
                        marginRight: 10,
                      }}
                    >
                      {machiningTypeMsg}
                    </div>
                  </>
                ) : (
                  ''
                )}
                帖数：
                <Button
                  icon={<MinusOutlined />}
                  onClick={() => {
                    if (recipe) {
                      const v = tipCount - 1
                      if (v > 0) {
                        dispatch(
                          createOrUpdateRecipe({
                            ...recipe,
                            tip: v,
                            useMethod: recipeUseMethod.join(','),
                          } as Recipe)
                        )
                          .then(unwrapResult)
                          .then((recipeId) => {
                            setTipCount(v)
                            if (location.pathname !== '/retail' || isInsurance) {
                              setUpdateFlags('1', '1')
                            }
                          })
                      }
                    } else {
                      const tipsCounts = tipCount - 1
                      createIfNotExist(
                        (treatmentId, recipeId) => {
                          return
                        },
                        true,
                        tipsCounts
                      )
                    }
                  }}
                />
                <InputNumber
                  style={{
                    width: '3.5rem',
                    color: theme.tc2,
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                  value={tipCount}
                  onChange={(v) => {
                    if (v) {
                      if (recipe) {
                        dispatch(
                          createOrUpdateRecipe({
                            ...recipe,
                            tip: v,
                            useMethod: recipeUseMethod.join(','),
                          } as Recipe)
                        )
                          .then(unwrapResult)
                          .then((recipeId) => {
                            setTipCount(v)
                            if (location.pathname !== '/retail' || isInsurance) {
                              setUpdateFlags('1', '1')
                            }
                          })
                      } else {
                        createIfNotExist(
                          (treatmentId, recipeId) => {
                            return
                          },
                          true,
                          v
                        )
                      }
                    } else {
                      setTipCount(undefined)
                    }
                  }}
                  min={1}
                  max={9999}
                  bordered={false}
                />
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    if (recipe) {
                      const v = tipCount + 1
                      dispatch(
                        createOrUpdateRecipe({
                          ...recipe,
                          tip: v,
                          useMethod: recipeUseMethod.join(','),
                        } as Recipe)
                      )
                        .then(unwrapResult)
                        .then((recipeId) => {
                          setTipCount(v)
                          if (location.pathname !== '/retail' || isInsurance) {
                            setUpdateFlags('1', '1')
                          }
                        })
                    } else {
                      const tipsCounts = tipCount + 1
                      createIfNotExist(
                        (treatmentId, recipeId) => {
                          return
                        },
                        true,
                        tipsCounts
                      )
                    }
                  }}
                  style={{ marginRight: 10 }}
                />
                处方用法：
                <Button
                  style={{
                    flex: 1,
                    color: theme.tc2,
                    width: '500px',
                    textAlign: 'left',
                    overflow: 'hidden',
                    maxWidth: '500px',
                    // textOverflow: 'ellipsis',
                  }}
                  icon={<SearchOutlined color={theme.c3} />}
                  onClick={() => {
                    if (recipe) {
                      localStorage?.setItem('editMedicalVisible', 'true')
                      setIsUseMethodModalVisible(true)
                    }
                  }}
                >
                  <span
                    style={{
                      width: '500px',
                    }}
                  >
                    {recipeUseMethod.join(',') + (elseMethod ? elseMethod : '')}
                    <span style={{ fontWeight: 'bold', color: '#000000' }}>
                      {elseRemark}
                    </span>
                  </span>
                </Button>
              </Row>
          )}</>}
        <Modal
          className={styles.history}
          width={1200}
          style={{ height: 720, maxHeight: 720, overflow: 'hidden' }}
          title='历史就诊信息'
          visible={isCopyModalVisible}
          footer={null}
          onCancel={() => {
            setIsCopyModalVisible(false)
            ref.current?.reset()
          }}
          destroyOnClose
        >
          <Treatments
            YSCKLSBLData={YSCKLSBLData}
            historyMessageTag={1}
            ref={ref}
            recipeId={recipeId}
            style={{ height: '100%' }}
            recipeCategory={recipe?.category || recipeCategory}
            exact={mode !== RecipeEditorMode.Retail}
            exactCategory={true}
            patientId={patientId || patientInfo?.patientId}
            showDiagnosis={false}
            onCopy={(vs, tip, flag = 0, diease) => {
              setCopyDiease(diease)
              const params = vs as CopyRecipeParams
              setIsCopyModalVisible(false)
              setIsCopyReciptParam(
                flag == 0 ? params : { ...params, copyDiagnosticsFlag: 1 }
              )
              setIsCopyReciptTip(tip)
              
              // 获取复制处方价格设置，如果只有一个选项直接调用
              const fzcfjgSetting = settings?.[Checks.FZCFJG]
              if (fzcfjgSetting) {
                const fzcfjgOptions = fzcfjgSetting.split(',')
                
                if (fzcfjgOptions.length === 1) {
                  switch (fzcfjgOptions[0]) {
                    case '1':
                      submitML(flag == 0 ? params : { ...params, copyDiagnosticsFlag: 1 })
                      break
                    case '2':
                      submitCF(flag == 0 ? params : { ...params, copyDiagnosticsFlag: 1 })
                      break
                    case '3':
                      submitKC(flag == 0 ? params : { ...params, copyDiagnosticsFlag: 1 })
                      break
                  }
                  return
                }
              }
              
              setIsCopyReciptModalVisible(true)
              // Modal.confirm({
              //   title: '是否从处方复制价格？',
              //   cancelText: '使用目录价格',
              //   okText: '使用处方价格',
              //   onOk: () =>
              //     createIfNotExist((_, recipeId) => {
              //       dispatch(
              //         copyRecipe({
              //           ...params,
              //           copyWithAmount: true,
              //           destRecipeId: recipeId,
              //         })
              //       )
              //     }),
              //   onCancel: () =>
              //     createIfNotExist((_, recipeId) => {
              //       dispatch(
              //         copyRecipe({
              //           ...params,
              //           copyWithAmount: false,
              //           destRecipeId: recipeId,
              //         })
              //       )
              //     }),
              // })
            }}
          />
        </Modal>
        <SetMealModal
          completionType={completionType}
          visible={isSetMealModalVisible}
          recipeCategory={recipeCategory || recipe?.category}
          onCancel={() => {
            setIsSetMealModalVisible(false)
          }}
          onChange={(
            ms: any,
            comboId: any,
            category: any,
            flag: any,
            s: any
          ) => {
            setComboId(comboId)
            const maxGroupNumber = materials.reduce(
              (g, m) => Math.max(g, m.groupNumber),
              0
            )
            if (settings?.[Checks.MLKG] === '1') {
              if (autoChangePrice) {
                const dataList = ms?.map((v: any) => {
                  const doseFixJDJZ = (v?.normalDose > 0 && (v?.normalUsemethod?.indexOf("静滴") >= 0 || v?.normalUsemethod?.indexOf("静注") >= 0)) ? true : false;
                  const doseFixWH = (v?.normalDose > 0 && (v?.normalUsemethod?.indexOf("雾化") >= 0)) ? true : false;
                  const calc = getNewNormalFrequencyCodeCalc(v?.normalFrequency) || 0
                  const flag = doseFixJDJZ ? settings?.[Checks.SZYLJS] : settings?.[Checks.WHYLJS];
                  const useDays = getNewAutoChangePriceUseDays('', v, v?.doseUnit, doseFixJDJZ, doseFixWH, v?.drugCount, calc, v?.normalDose, flag)
                  const splitUseDays = getNewAutoChangePriceSplitUseDays('', v, v?.doseUnit, doseFixJDJZ, doseFixWH, v?.drugCount, calc, v?.normalDose, flag)
                  const realUseDays: any = v?.splitTag == 1 ? splitUseDays : useDays
                  return {
                    ...v,
                    useDays: v?.billingCategory == '01' ? realUseDays : useDays || 1
                  }
                })
                setCopyMealParams(dataList)
              } else {
                setCopyMealParams(ms)
              }
            } else {
              setCopyMealParams(ms)
            }

            setIsSetMealModalVisible(false)
            setSelectData(s)
            setNoBodyFlag(flag)
            setCategory(category)
            
            const fzctjgSetting = settings?.[Checks.FZCTJG]
            if (fzctjgSetting) {
              const fzctjgOptions = fzctjgSetting.split(',')
              const visibleOptions = fzctjgOptions.filter((opt: string) => opt !== '3' || s?.category !== 2)
              // 只有一个可见选项 → 直接调用；零个可见选项 → 走目录价格
              if (visibleOptions.length <= 1) {
                if (visibleOptions.length === 1) {
                  const btnFlag = Number(visibleOptions[0])
                  setButtonFlag(btnFlag)
                  if (flag && s?.treatmentParts) {
                    setIsTreatmentPartsModalVisible(true)
                  } else {
                    setPendingSetMealPriceType(btnFlag)
                  }
                } else {
                  setButtonFlag(1)
                  if (flag && s?.treatmentParts) {
                    setIsTreatmentPartsModalVisible(true)
                  } else {
                    setPendingSetMealPriceType(1)
                  }
                }
                return
              }
            }
            
            setIsMealModalVisible(true)
          }}
        />
        {/* 批量添加处置项目弹框 */}
        <BatchAddModal
          onOk={(v) => {
            if (handlePrescriptionDrugLimit(v)) {
              return
            }
            setUpdateFlags('1', '1')
          }}
          insuranceCode={insuranceCode}
          treatmentId={treatmentId}
          recipeId={recipeId}
        />
        {/* 治疗计划列表弹框 */}
        <Modal
          title={
            toothRegistrationId
              ? '导入治疗计划'
              : `${patientInfo?.patientName ? patientInfo?.patientName : name} 的治疗计划`
          }
          width={1200}
          visible={curePlanListVisible}
          onCancel={() => {
            dispatch(setCurePlanListVisible(false))
          }}
          footer={null}
          className={styles.curePlanListModal}
        >
          <CurePlanListModal
            printFlagDetail={printFlagDetail}
            patientId={patientInfo?.patientId || patientId}
            onOk={() => {
              getRecipeDetailList(recipeId || '')
              setUpdateFlags('1', '1')
            }}
            insuranceCode={insuranceCode}
            treatmentId={treatmentId}
            recipeId={recipeId}
            toothRegistrationId={toothRegistrationId}
          />
        </Modal>
        {/* 添加新计划 */}
        {!toothRegistrationId && (
          <AddCurePlanModal
            patientObj={patientObj}
            insuranceCode={insuranceCode}
            data={data}
            recipeCategory={recipeCategory}
            mode={mode}
            treatmentId={treatmentId}
          />
        )}
        <UseMethodModal
          visible={isUseMethodModalVisible}
          value={recipeUseMethod}
          elseRecipeUseMethod={elseRecipeUseMethod}
          onCancel={() => {
            setIsUseMethodModalVisible(false)
          }}
          onChange={(values, formValue) => {
            const filterValues = values?.filter((v) => v != '')
            setIsUseMethodModalVisible(false)
            const fValue: any = formValue
              ? ',' +
              (formValue?.recipeNormalFrequency
                ? formValue?.recipeNormalFrequency + ','
                : '') +
              (formValue?.recipeNormalUsemethod
                ? formValue?.recipeNormalUsemethod + ','
                : '') +
              (formValue?.recipeNormalDose
                ? formValue?.recipeNormalDose + ','
                : '')
              : ''
            setElseRemark(formValue?.remark ? formValue?.remark : '')
            setRecipeUseMethod(filterValues)
            dispatch(
              createOrUpdateRecipe({
                ...recipe,
                ...formValue,
                tip: tipCount,
                useMethod: filterValues.join(','),
              } as Recipe)
            )
              .then(unwrapResult)
              .then((res) => {
                setElseMethod(fValue)
              })
          }}
        />
        <TFMethodModal
          value={useMethodSubmitData}
          visible={isTFMethodVisible}
          currentGroupIndex={currentGroupIndex}
          onChange={(values,index) => {
            setIsTFMethodVisible(false)
            const params ={
              ...useMethodSubmitData,
              groupUsemethod: values,
            }
            createOrUpdateGroup(params ,index)
          }}
          onCancel={() => {
            setIsTFMethodVisible(false)
            setUseMethodSubmitData({})
          }}
        />
        <PrintTemplateModal
          patientId={patientId}
          recipeUseMethod={recipeUseMethod}
          recipeCategory={recipeCategory}
          machiningTypeMsg={machiningTypeMsg}
          tipCount={tipCount}
          printZXDData={printZXDData}
          pagePrintFlag={'zxdPrint'}
          visible={!!printTemplateCategory}
          templateCategory={printTemplateCategory}
          recipeId={recipeId || recipe?.id}
          treatmentId={treatmentId}
          onCancel={() => setPrintTemplateCategory(undefined)}
          onOk={() => setPrintTemplateCategory(undefined)}
        />
        <RecipeItemModal
          insuranceCode={insuranceCode}
          discountFlag={discountFlag}
          potionType={potionType} // 上次代煎的方式
          category={recipeCategory}
          material={targetMaterial}
          onChange={(m) => {
            add(m, false, m.id, false, true)
          }}
          onCancel={() => setTargetMaterial(undefined)}
          onOk={() => setTargetMaterial(undefined)}
        />
        {/* <ReplaceMakeSettingModal
          visible={isReplaceMakeModalVisible}
          isOpenPriceRatio={isOpenPriceRatio}
          recipeId={Number(recipeId)} // 处方id
          recipeCategory={recipeCategory} // 代煎类型 种药，颗粒剂
          patientId={Number(recipe?.patientId)} // 患者ID
          isSetting={isSetting} // 是否设置过代煎
          potionType={potionType} // 上次代煎的方式
          isOpenReplaceMake={isOpenReplaceMake} // 是否开启代煎
          // isShowReplaceMakeTable={isShowReplaceMakeTable}
          onCancel={() => {
            setIsReplaceMakeModalVisible(false)
          }}
          onOk={() => {
            setIsReplaceMakeModalVisible(false)
          }}
        />

        {/* 代煎设置 */}
        <DecoctingSettingModal
          isSetting={isSetting} // 是否设置过代煎
          patientPhone={patientPhone}
          patientName={patientName}
          RecipeStatus={RecipeStatus}
          visible={isDecoctingSettingModalVisible}
          potionType={potionType} // 上次代煎的方式
          recipeId={Number(recipeId)} // 处方id
          patientId={Number(recipe?.patientId)} // 患者ID
          recipeCategory={recipeCategory} // 代煎类型 种药，颗粒剂
          isOpenReplaceMake={isOpenReplaceMake} // 是否开启代煎
          onCancel={() => {
            setIsDecoctingSettingModalVisible(false)
          }}
          onOk={() => {
            setIsDecoctingSettingModalVisible(false)
          }}
        ></DecoctingSettingModal>

        <Modal
          title='温馨提示'
          visible={categoryVisible}
          width={500}
          footer={null}
          keyboard={false}
          maskClosable={false}
          closable={false}
        >
          <div>
            您还没有设置过 {getTipsMessage(materialsExists, treatmentExists, 0)}
            <br />
            请先到 【库房工作站】--{' '}
            {getTipsMessage(materialsExists, treatmentExists, 1)} 进行设置
          </div>
          <Checkbox
            onChange={({ target }) => {
              const { checked } = target
              const flag = checked ? '1' : '0'
              localStorage.setItem('SHOWCATEGORYMODAL', flag)
            }}
            style={{ margin: '10px 0' }}
          >
            下次不再提示
          </Checkbox>
          <Row justify='end'>
            <Button type='primary' onClick={() => setCategoryVisible(false)}>
              确认
            </Button>
          </Row>
        </Modal>

       
        <CopyTCModal
          visible={isCopyMealModalVisible}
          mlBtnLoading={mlBtnLoading}
          btnLoading={btnLoading}
          kcBtnLoading={kcBtnLoading}
          isTreatCombo={selectData?.category === 2}
          onCancel={() => {
            setIsMealModalVisible(false)
            setBtnLoading(false)
            setmlBtnLoading(false)
            setkcBtnLoading(false)
          }}
          // 使用目录价格
          useML={() => {
            setButtonFlag(1)
            if (noBodyFlag && selectData?.treatmentParts) {
              setIsTreatmentPartsModalVisible(true)
            } else {
              getCopyMLSubmit()
            }
          }}
          // 使用套餐价格
          useTC={() => {
            setButtonFlag(2)
            if (noBodyFlag && selectData?.treatmentParts) {
              setIsTreatmentPartsModalVisible(true)
            } else {
              getCopyTCSubmit()
            }
          }}
          // 使用库存价格
          useKC={() => {
            setButtonFlag(3)
            if (noBodyFlag && selectData?.treatmentParts) {
              setIsTreatmentPartsModalVisible(true)
            } else {
              getCopyKCSubmit()
            }
          }}
        />
        <CopyModal
          visible={isCopyReciptModalVisible}
          mlBtnLoading={mlBtnLoading}
          cfBtnLoading={cfBtnLoading}
          kcBtnLoading={kcBtnLoading}
          onCancel={() => {
            setIsCopyReciptModalVisible(false)
            setcfBtnLoading(false)
            setmlBtnLoading(false)
            setkcBtnLoading(false)
          }}
          // 使用目录价格
          useML={() => {
            submitML(isCopyReciptParam)
          }}
          // 使用处方价格
          useCF={() => {
            submitCF(isCopyReciptParam)
          }}
          // 使用库存价格
          useKC={() => {
            submitKC(isCopyReciptParam)
          }}
        />
        {/* <Modal
          visible={isCopyReciptModalVisible}
          footer={null}
          destroyOnClose
          className={styles.modal}
        >
          <div
            style={{
              padding: '32px',
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <InfoCircleOutlined
              style={{
                color: '#faad14',
                marginRight: '10px',
                fontSize: '22px',
              }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
              是否从处方复制价格？
            </span>
          </div>
          <CloseOutlined
            style={{
              position: 'absolute',
              color: '#8c8c8c',
              right: 10,
              top: 20,
              marginRight: '10px',
              fontSize: '22px',
            }}
            onClick={() => {
              setIsCopyReciptModalVisible(false)
              setcfBtnLoading(false)
              setmlBtnLoading(false)
              setkcBtnLoading(false)
            }}
          />
          <Row
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '20px',
            }}
          >
            <Button
              style={{
                marginRight: '14px',
              }}
              loading={mlBtnLoading}
              onClick={() => {
                setmlBtnLoading(true)
                setcfBtnLoading(true)
                setkcBtnLoading(true)
                createIfNotExist((_, recipeId) => {
                  dispatch(
                    copyRecipe({
                      ...isCopyReciptParam,
                      copyAmountType: 0,
                      destRecipeId: recipeId,
                    })
                  )
                    .then(unwrapResult)
                    .then((res: any) => {
                      saveRecipeMaterialsData = res
                      if (recipeCategory === RecipeCategory.Tcm) {
                        const couldReplaceStockList = res
                          ?.map((v: any) => v?.couldReplaceStockList)
                          ?.flat(1)
                        if (couldReplaceStockList?.length) {
                          setDataList(res)
                          setShowFlag(false)
                          setCouldReplaceStockListModalVisible(true)
                        } else {
                          getTips(recipeId)
                        }
                      } else {
                        getTips(recipeId)
                      }

                      //开方过量提醒
                      if (res && res?.length > 0) {
                        const reminders = res?.map((v: any) => v?.overdoseReminder || "");
                        const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
                        if (hasNonEmpty) {
                          const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
                          overReminder(reminder)
                        }
                      }

                    })
                    .finally(() => {
                      setIsCopyReciptModalVisible(false)
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                })
              }}
            >
              使用目录价格
            </Button>
            <Button
              style={{
                marginRight: '14px',
              }}
              loading={cfBtnLoading}
              type='primary'
              onClick={() => {
                setmlBtnLoading(true)
                setcfBtnLoading(true)
                setkcBtnLoading(true)
                createIfNotExist((_, recipeId) => {
                  dispatch(
                    copyRecipe({
                      ...isCopyReciptParam,
                      copyAmountType: 1,
                      destRecipeId: recipeId,
                    })
                  )
                    .then(unwrapResult)
                    .then((res: any) => {
                      saveRecipeMaterialsData = res
                      if (recipeCategory === RecipeCategory.Tcm) {
                        const couldReplaceStockList = res
                          ?.map((v: any) => v?.couldReplaceStockList)
                          ?.flat(1)
                        if (couldReplaceStockList?.length) {
                          setDataList(res)
                          setShowFlag(false)
                          setCouldReplaceStockListModalVisible(true)
                        } else {
                          getTips(recipeId)
                        }
                      } else {
                        getTips(recipeId)
                      }

                      //开方过量提醒
                      if (res && res?.length > 0) {
                        const reminders = res?.map((v: any) => v?.overdoseReminder || "");
                        const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
                        if (hasNonEmpty) {
                          const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
                          overReminder(reminder)
                        }
                      }

                    })
                    .finally(() => {
                      setIsCopyReciptModalVisible(false)
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                })
              }}
            >
              使用处方价格
            </Button>
            {kskdTag ? (
              <Button
                style={{
                  marginRight: '14px',
                }}
                loading={cfBtnLoading}
                type='primary'
                onClick={() => {
                  setmlBtnLoading(true)
                  setcfBtnLoading(true)
                  setkcBtnLoading(true)
                  createIfNotExist((_, recipeId) => {
                    dispatch(
                      copyRecipe({
                        ...isCopyReciptParam,
                        copyAmountType: 2,
                        destRecipeId: recipeId,
                      })
                    )
                      .then(unwrapResult)
                      .then((res: any) => {
                        saveRecipeMaterialsData = res
                        if (recipeCategory === RecipeCategory.Tcm) {
                          const couldReplaceStockList = res
                            ?.map((v: any) => v?.couldReplaceStockList)
                            ?.flat(1)
                          if (couldReplaceStockList?.length) {
                            setDataList(res)
                            setShowFlag(false)
                            setCouldReplaceStockListModalVisible(true)
                          } else {
                            getTips(recipeId)
                          }
                        } else {
                          getTips(recipeId)
                        }

                        //开方过量提醒
                        if (res && res?.length > 0) {
                          const reminders = res?.map((v: any) => v?.overdoseReminder || "");
                          const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
                          if (hasNonEmpty) {
                            const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
                            overReminder(reminder)
                          }
                        }
                      })
                      .finally(() => {
                        setIsCopyReciptModalVisible(false)
                        setmlBtnLoading(false)
                        setcfBtnLoading(false)
                        setkcBtnLoading(false)
                      })
                  })
                }}
              >
                使用库存价格
              </Button>
            ) : (
              <Button
                style={{
                  marginRight: '14px',
                }}
                loading={kcBtnLoading}
                type='primary'
                onClick={() => {
                  setmlBtnLoading(true)
                  setcfBtnLoading(true)
                  setkcBtnLoading(true)
                  dispatch(
                    copyRecipe({
                      ...isCopyReciptParam,
                      copyAmountType: 2,
                      destRecipeId: recipeId,
                    })
                  )
                    .then(unwrapResult)
                    .then((res: any) => {
                      saveRecipeMaterialsData = res
                      if (recipeCategory === RecipeCategory.Tcm) {
                        const couldReplaceStockList = res
                          ?.map((v: any) => v?.couldReplaceStockList)
                          ?.flat(1)
                        if (couldReplaceStockList?.length) {
                          setDataList(res)
                          setShowFlag(false)
                          setCouldReplaceStockListModalVisible(true)
                        } else {
                          getTips(recipeId)
                        }
                      } else {
                        getTips(recipeId)
                      }

                      //开方过量提醒
                      if (res && res?.length > 0) {
                        const reminders = res?.map((v: any) => v?.overdoseReminder || "");
                        const hasNonEmpty = reminders?.some((r: any) => r.trim() !== "");
                        if (hasNonEmpty) {
                          const reminder = reminders.filter((r: any) => r.trim() !== "").join("\n");
                          overReminder(reminder)
                        }
                      }

                    })
                    .finally(() => {
                      setIsCopyReciptModalVisible(false)
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                }}
              >
                使用库存价格
              </Button>
            )}
          </Row>
        </Modal> */}
        <SetmealModal
          recipeId={recipeId || materials?.[0]?.recipeId}
          isModalVisible={isModalVisible}
          onOk={() => {
            dispatch(setSetmealSelectId(0))
            dispatch(setSetmealDetail({}))
            setIsModalVisible(false)
            localStorage?.setItem('editMedicalVisible', 'false')
          }}
          onCancel={() => {
            dispatch(setSetmealDetail({}))
            dispatch(setSetmealSelectId(0))
            setIsModalVisible(false)
            localStorage?.setItem('editMedicalVisible', 'false')
          }}
        />
        <PrintSettingModal
          visible={isPrintSettingModalVisible}
          onCancel={() => {
            setIsPrintSettingModalVisible(false)
          }}
          onOk={() => {
            setIsPrintSettingModalVisible(false)
          }}
        ></PrintSettingModal>
        <Modal
          width={600}
          title='优惠券选择'
          okText='提交'
          footer={null}
          centered
          onOk={() => {
            setCouponsVisable(false)
          }}
          onCancel={() => {
            setCouponsVisable(false)
          }}
          visible={couponsVisable}
          destroyOnClose
        >
          <CouponsItems
            couponsList={couponsList}
            couponsIds={couponsIds}
            onClick={(v, n, i) => {
              setCouponsIds(i)
              setCouponsList(v)
            }}
          />
          <Row gutter={20} style={{ marginTop: '50px' }}>
            <Col span={24}>
              <Button
                type='primary'
                style={{ float: 'right', marginLeft: '10px' }}
                onClick={() => {
                  if (!couponsIds.length) {
                    notification.info({
                      message: '请选择优惠券',
                    })
                    return
                  }
                  if (recipe) {
                    dispatch(
                      getCouponsUse({
                        recipeId: recipe.id,
                        treatmentId: recipe.treatmentId,
                        patientId: recipe.patientId,
                        ids: couponsIds,
                      })
                    )
                      .then(unwrapResult)
                      .then(() => {
                        onNewRecipe && onNewRecipe(recipe)
                        getRecipeDetailList(recipe.id)
                        setCouponsVisable(false)
                        notification.success({
                          message: '操作成功',
                        })
                      })
                  } else {
                    if (recipeCategory) {
                      dispatch(
                        createRetailRecipePatient({
                          patient: {
                            name: patientObj?.patientName,
                            sex: patientObj?.patientSex || 0,
                            ageMonth: patientObj?.ageMonth,
                            ageYear: patientObj?.ageYear,
                            ageDay: patientObj?.ageDay,
                            birthday: patientObj?.birthday,
                            id: patientObj?.patientId,
                            maritalStatus: 0,
                            phone: patientObj?.phone,
                            address: patientObj?.address,
                            provinceCode: patientObj?.provinceCode,
                            cityCode: patientObj?.cityCode,
                            contryCode: patientObj?.contryCode,
                          },
                          recipeAndSexVO: {
                            treatmentId,
                            category: recipeCategory,
                            disease: patientObj?.disease,
                            treatmentDepartmentId:
                              patientObj?.treatmentDepartmentId,
                            treatmentDepartmentName:
                              patientObj?.treatmentDepartmentName,
                            treatmentDoctorId: patientObj?.treatmentDoctorId,
                            treatmentDoctorName:
                              patientObj?.treatmentDoctorName,
                            salesmanId: patientObj?.salesmanId,
                            salesmanName: patientObj?.salesmanName,
                          },
                          tip: tipCount,
                        })
                      )
                        .then(unwrapResult)
                        .then((recipe) => {
                          // callback(recipe.treatmentId, recipe.id)
                          dispatch(
                            getCouponsUse({
                              recipeId: recipe.id,
                              treatmentId: recipe.treatmentId,
                              patientId: recipe.patientId,
                              ids: couponsIds,
                            })
                          )
                            .then(unwrapResult)
                            .then(() => {
                              onNewRecipe && onNewRecipe(recipe)
                              setCouponsVisable(false)
                              notification.success({
                                message: '操作成功',
                              })
                            })
                        })
                    }
                  }
                }}
              >
                确定
              </Button>
              <Button
                style={{ float: 'right' }}
                onClick={() => {
                  setCouponsVisable(false)
                }}
              >
                取消
              </Button>
            </Col>
          </Row>
        </Modal>
        <Modal
          width={600}
          title='部位'
          okText=''
          footer={null}
          centered
          onOk={() => {
            setIsTreatmentPartsModalVisible(false)
            setButtonFlag('')
          }}
          onCancel={() => {
            setIsTreatmentPartsModalVisible(false)
            setButtonFlag('')
          }}
          visible={isTreatmentPartsModalVisible}
          destroyOnClose
        >
          <Form
            autoComplete='off'
            form={form}
            {...layout}
            name='control-hooks'
            onFinish={(vs) => {
              const treatmentParts = vs?.treatmentParts?.length
                ? vs?.treatmentParts?.join(',')
                : ''
              if (buttonFlag == 1) {
                getCopyMLSubmit(treatmentParts)
              } else if (buttonFlag == 2) {
                getCopyTCSubmit(treatmentParts)
              } else if (buttonFlag == 3) {
                getCopyKCSubmit(treatmentParts)
              }
            }}
          >
            <div style={{ height: '100px' }}>
              <Col span={24}>
                <Form.Item name='treatmentParts' label='部位'>
                  <Select
                    mode='multiple'
                    allowClear
                    value={treatmentParts}
                    onChange={(value: any) => {
                      setTreatmentParts(value)
                    }}
                  >
                    {TreatmentPartsCategoris?.map((v) => {
                      return (
                        <Option key={v} value={getTreatmentPartsName(v)}>
                          {getTreatmentPartsName(v)}
                        </Option>
                      )
                    })}
                    {treatmentPartsList.map((v: any) => {
                      return (
                        <Option key={v.id} value={v.name}>
                          {v.name}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
                <div
                  style={{ position: 'absolute', top: '6px', right: '56px' }}
                >
                  <SettingOutlined
                    style={{ color: '#999999' }}
                    onClick={() => setEditTreatmentParts(true)}
                  />
                </div>
              </Col>
            </div>

            <Row gutter={20}>
              <Col span={12}>
                <Button
                  onClick={() => {
                    form.resetFields()
                    setIsTreatmentPartsModalVisible(false)
                  }}
                  style={{ float: 'right' }}
                >
                  取消
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  type='primary'
                  htmlType='submit'
                  loading={buttonFlag == 1 ? mlBtnLoading : buttonFlag == 2 ? btnLoading : buttonFlag == 3 ? kcBtnLoading : false}
                  style={{ float: 'left' }}
                >
                  保存
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
        <SettingTreatmentParts
          isSettingTreatmentParts={editTreatmentParts}
          onCancel={() => {
            setEditTreatmentParts(false)
          }}
          onOk={() => {
            setEditTreatmentParts(false)
          }}
          refresh={() => {
            dispatch(defaultXianBingListAsync(2))
              .then(unwrapResult)
              .then((res) => {
                setTreatmentPartsList(res)
              })
          }}
        />
        <RecipeComparisonModal
          comparisonData={comparisonModalData}
          visible={comparisonModalVisible}
          onCancel={() => setComparisonModalVisible(false)}
        />
        <ChangeElseFactorModal
          showFlag={showFlag}
          dataList={dataList}
          visible={couldReplaceStockListModalVisible}
          onOk={(() => {
            setDataList([])
            setCouldReplaceStockListModalVisible(false)
            getRecipeDetailList(recipeId || '')
          })}
          onCancel={(() => {
            setDataList([])
            setCouldReplaceStockListModalVisible(false)
          })}
        ></ChangeElseFactorModal>

        {/* 选择穴位部位 */}
        <ChooseBWXWModal
          recipeItemId={xWTreatmentPartsItem?.id}
          thisItemAcup={xWTreatmentPartsItem?.treatmentParts}
          acupData={acupointList}
          visible={xWTreatmentPartsItem && xWTreatmentPartsItem?.id > 0}
          onCancel={() => setXWTreatmentPartsItem(null)}
          onOk={(params) => {
            setXWTreatmentPartsItem(null)
            if (recipeId) {
              dispatch(getRecipeDetail(recipeId))
            }
          }}
        ></ChooseBWXWModal>
        {/* 结果登记 */}
        <RegisterModal
          isModalRegisterVisible={isModalRegisterVisible}
          params={pitestParams}
          onOk={() => {
            if (recipeId) {
              dispatch(getRecipeDetail(recipeId))
            }
            setIsModalRegisterVisible(false);
          }}
          onCancel={() => {
            setIsModalRegisterVisible(false);
          }}
        />
      </Col>
    </>
  )
}

export const RecipeEditor = forwardRef(RecipeEditorRef)
export const saveSettingOneFunction = createAsyncThunk<
  void,
  service.SettingTenantOneFunction,
  RootThunkApi
>('setting/saveSettingOneFunction', async (body, api) => {
  return sendAsync(service.getSettingOneSave(body), api)
})

